/* 3e422f97f224eb3e3e45689d0ae034cea41342c2
 * This file is automatically generated by graphql-let. */

import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  GPSMultipolygon: any;
  ImageUpload: any;
};

export enum AccountType {
  /** Základní účet */
  Basic = 'BASIC',
  /** Bezplatný účet */
  Free = 'FREE',
  /** Premium profil */
  Premium = 'PREMIUM'
}

export enum ActivationAction {
  /** Aktivace */
  Activate = 'ACTIVATE',
  /** Prodloužení */
  Extend = 'EXTEND',
  /** Reaktivace zdarma */
  FreeReactivate = 'FREE_REACTIVATE',
  /** Zvýraznění */
  Highlight = 'HIGHLIGHT'
}

/**
 * Advert object including basic information about advertisement
 *
 */
export type Advert = DocumentReference & GalleryReference & NotificationReference & {
  __typename?: 'Advert';
  /** Action needed to activate advert */
  activationAction?: Maybe<ActivationAction>;
  /**
   * Check if an order for activation has been created in the last 10 minutes.
   *
   */
  activationPending?: Maybe<Scalars['Boolean']>;
  /**
   * Contains information about active state
   *
   */
  active?: Maybe<Scalars['Boolean']>;
  /** Generated address from region data */
  address?: Maybe<Scalars['String']>;
  /**
   * Address inserted by user
   *
   */
  addressInput?: Maybe<Scalars['String']>;
  /**
   * Address as user typed it
   *
   */
  addressUserInput?: Maybe<Scalars['String']>;
  advertStatsDaily?: Maybe<Array<Maybe<AdvertStatsDaily>>>;
  advertUserstate?: Maybe<AdvertUserstate>;
  age?: Maybe<Age>;
  archived?: Maybe<Scalars['Boolean']>;
  availableFrom?: Maybe<Scalars['DateTime']>;
  /** Advert badge/label */
  badge?: Maybe<AdvertBadge>;
  balcony?: Maybe<Scalars['Boolean']>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbItem>>>;
  /** Broker (formerly called Comfort specialist) */
  broker?: Maybe<Broker>;
  calendarEntries?: Maybe<CalendarEntryList>;
  cellar?: Maybe<Scalars['Boolean']>;
  charges?: Maybe<Scalars['Int']>;
  charity?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  cityDistrict?: Maybe<Scalars['String']>;
  /** Developers code */
  code?: Maybe<Scalars['String']>;
  condition?: Maybe<Condition>;
  construction?: Maybe<Construction>;
  /**
   * List of conversations related to advert
   *
   */
  conversations?: Maybe<ConversationList>;
  currency?: Maybe<Currency>;
  currentRentContract?: Maybe<RentContract>;
  dataJson?: Maybe<Scalars['String']>;
  /**
   * Number of days advert since last payment
   *
   */
  daysActive?: Maybe<Scalars['String']>;
  deposit?: Maybe<Scalars['Int']>;
  /**
   * User's description
   *
   */
  description?: Maybe<Scalars['String']>;
  /**
   * User's description in english
   *
   */
  descriptionEnglish?: Maybe<Scalars['String']>;
  disposition?: Maybe<Disposition>;
  equipped?: Maybe<Equipped>;
  estateType?: Maybe<EstateType>;
  etage?: Maybe<Scalars['Int']>;
  execution?: Maybe<Execution>;
  /** External ID from import */
  externalId?: Maybe<Scalars['ID']>;
  fee?: Maybe<Scalars['Int']>;
  /**
   * Check if Advert has 5 or more reactions
   *
   */
  fivesome?: Maybe<Scalars['Boolean']>;
  floor?: Maybe<Floor>;
  formattedAds?: Maybe<Array<Maybe<FormattedParameter>>>;
  formattedBoolParameters?: Maybe<Array<Maybe<FormattedBoolParameter>>>;
  formattedParameters?: Maybe<Array<Maybe<FormattedParameter>>>;
  frontGarden?: Maybe<Scalars['Int']>;
  galleries?: Maybe<Array<Maybe<Gallery>>>;
  garage?: Maybe<Scalars['Boolean']>;
  gps?: Maybe<GpsPoint>;
  hasContractRent?: Maybe<Scalars['Boolean']>;
  hash?: Maybe<Scalars['String']>;
  heating?: Maybe<Heating>;
  highlighted?: Maybe<Scalars['Boolean']>;
  houseNumber?: Maybe<Scalars['String']>;
  houseType?: Maybe<HouseType>;
  /** ID */
  id?: Maybe<Scalars['ID']>;
  imageAltText?: Maybe<Scalars['String']>;
  /**
   * Check if Advert has empty optional attributes
   *
   */
  incomplete?: Maybe<Scalars['Boolean']>;
  /**
   * Identifies if the advert is editable
   *
   */
  isEditable?: Maybe<Scalars['Boolean']>;
  /**
   * Identifies new adverts
   *
   */
  isNew?: Maybe<Scalars['Boolean']>;
  landType?: Maybe<LandType>;
  lastMonthHighlights?: Maybe<Array<Maybe<AdvertEvent>>>;
  lastUserVisit?: Maybe<AdvertUserVisit>;
  lift?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Locale>;
  loggia?: Maybe<Scalars['Boolean']>;
  /**
   * Default image
   *
   */
  mainImage?: Maybe<Image>;
  messageData?: Maybe<AdvertMessageData>;
  mortgageData?: Maybe<MortgageData>;
  /**
   * Check if Advert is new, i.e. not activated yet
   *
   */
  new?: Maybe<Scalars['Boolean']>;
  newBuilding?: Maybe<Scalars['Boolean']>;
  offerType?: Maybe<OfferType>;
  ownership?: Maybe<Ownership>;
  parking?: Maybe<Scalars['Boolean']>;
  penb?: Maybe<Penb>;
  poiData?: Maybe<Scalars['String']>;
  /**
   * Position in city
   *
   */
  positionCity?: Maybe<Scalars['String']>;
  /**
   * Position in county
   *
   */
  positionCounty?: Maybe<Scalars['String']>;
  /**
   * Position in region
   *
   */
  positionRegion?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  /** Formatted price */
  priceFormatted?: Maybe<Scalars['String']>;
  /**
   * Project this advert is part of
   *
   */
  project?: Maybe<Project>;
  publicGalleries?: Maybe<Array<Maybe<Gallery>>>;
  /** Array of public images */
  publicImages?: Maybe<Array<Maybe<Image>>>;
  reconstruction?: Maybe<Reconstruction>;
  region?: Maybe<Region>;
  regionTree?: Maybe<Array<Maybe<Region>>>;
  /** Parameters used for searching related adverts */
  relatedAdvertParameters?: Maybe<RelatedAdvertParameters>;
  /** List of related adverts */
  relatedAdverts?: Maybe<AdvertList>;
  rentContracts?: Maybe<Array<Maybe<RentContract>>>;
  rentCosts?: Maybe<Array<Maybe<RentCost>>>;
  rentDocuments?: Maybe<Array<Maybe<RentDocument>>>;
  rentEquipments?: Maybe<Array<Maybe<RentEquipment>>>;
  rentNotes?: Maybe<Array<Maybe<RentNote>>>;
  rentPlatform?: Maybe<Scalars['Boolean']>;
  rentPlatformOrder?: Maybe<Scalars['Int']>;
  rentPlatformStatus?: Maybe<RentPlatformAdvertStatus>;
  rentPlatformTimeExpiration?: Maybe<Scalars['DateTime']>;
  rentRepairs?: Maybe<Array<Maybe<RentRepair>>>;
  rentServices?: Maybe<Array<Maybe<RentService>>>;
  /**
   * Contains information about reservation state
   *
   */
  reserved?: Maybe<Scalars['Boolean']>;
  /**
   * Contains information about reservation user
   *
   */
  reservedUser?: Maybe<User>;
  roommate?: Maybe<Scalars['Boolean']>;
  sewage?: Maybe<Sewage>;
  street?: Maybe<Scalars['String']>;
  surface?: Maybe<Scalars['Int']>;
  surfaceLand?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  terrace?: Maybe<Scalars['Boolean']>;
  /**
   * Check if Advert has 3 or more reactions
   *
   */
  threesome?: Maybe<Scalars['Boolean']>;
  /**
   * Time of activation
   *
   */
  timeActivated?: Maybe<Scalars['DateTime']>;
  /**
   * Time of deactivation
   *
   */
  timeDeactivated?: Maybe<Scalars['DateTime']>;
  /**
   * Time of expiration
   *
   */
  timeExpiration?: Maybe<Scalars['DateTime']>;
  /**
   * Time of last top
   *
   */
  timeOrder?: Maybe<Scalars['DateTime']>;
  topHistoryLog?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  totalFloors?: Maybe<Scalars['Int']>;
  /**
   * 360° tour link
   *
   */
  tour360?: Maybe<Scalars['String']>;
  type?: Maybe<AdvertImportType>;
  /** URI where advert is available */
  uri?: Maybe<Scalars['String']>;
  /** Owner */
  user?: Maybe<User>;
  /**
   * Advert videos
   *
   */
  videos?: Maybe<Array<Maybe<AdvertVideo>>>;
  /**
   * Number of visits
   *
   */
  visitCount?: Maybe<Scalars['Int']>;
  water?: Maybe<Water>;
  zip?: Maybe<Scalars['String']>;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertAddressArgs = {
  locale: Locale;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertAdvertUserstateArgs = {
  state: AdvertUserstateState;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertBreadcrumbsArgs = {
  locale: Locale;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertCalendarEntriesArgs = {
  free?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  upcoming?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertConversationsArgs = {
  closed?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertFormattedAdsArgs = {
  locale: Locale;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertFormattedBoolParametersArgs = {
  locale: Locale;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertFormattedParametersArgs = {
  locale: Locale;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertImageAltTextArgs = {
  locale: Locale;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertMessageDataArgs = {
  locale: Locale;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertMortgageDataArgs = {
  locale: Locale;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertPriceFormattedArgs = {
  locale: Locale;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertPublicImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertRegionTreeArgs = {
  locale: Locale;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertRelatedAdvertsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/**
 * Advert object including basic information about advertisement
 *
 */
export type AdvertTagsArgs = {
  locale: Locale;
};

export type AdvertBadge = {
  __typename?: 'AdvertBadge';
  class?: Maybe<AdvertBadgeClass>;
  text?: Maybe<Scalars['String']>;
};

export enum AdvertBadgeClass {
  /** Dark green background */
  Highlight = 'HIGHLIGHT',
  /** Blue background */
  Info = 'INFO',
  /** Green background */
  Success = 'SUCCESS',
  /** Red background */
  Warning = 'WARNING'
}

export type AdvertDeactivateInput = {
  /**
   * Action to perform
   *
   */
  action: DeactivationAction;
  /**
   * Advert ID
   *
   */
  advertId: Scalars['ID'];
  /**
   * Number of days for customer alerts. All customers that have written a message involving this advertisement will receive email message about deactivation.
   *
   */
  alertTime?: InputMaybe<Scalars['Int']>;
  /**
   * Textual experience
   *
   */
  experience?: InputMaybe<Scalars['String']>;
  /**
   * Rating of experience with portal
   *
   */
  rating?: InputMaybe<Scalars['Int']>;
  /**
   * Reason of deactivation
   *
   */
  reason?: InputMaybe<Scalars['String']>;
};

export type AdvertEvent = {
  __typename?: 'AdvertEvent';
  id?: Maybe<Scalars['ID']>;
  orderPackage?: Maybe<OrderPackage>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  /**
   * Time the event is planned to occur
   *
   */
  timeDue?: Maybe<Scalars['DateTime']>;
  timeProcessed?: Maybe<Scalars['DateTime']>;
  type?: Maybe<AdvertEventType>;
  user?: Maybe<User>;
};

export type AdvertEventList = {
  __typename?: 'AdvertEventList';
  list?: Maybe<Array<Maybe<AdvertEvent>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum AdvertEventType {
  /** Aktivace */
  TypeActivate = 'TYPE_ACTIVATE',
  /** Aktivace projektu */
  TypeActivateProject = 'TYPE_ACTIVATE_PROJECT',
  /** Základní účet */
  TypeBasicAccount = 'TYPE_BASIC_ACCOUNT',
  /** Prodloužení */
  TypeExtend = 'TYPE_EXTEND',
  /** Reaktivace zdarma */
  TypeFreeReactivate = 'TYPE_FREE_REACTIVATE',
  /** Zvýraznění */
  TypeHighlight = 'TYPE_HIGHLIGHT',
  /** Konec - Zvýraznění */
  TypeHighlightEnd = 'TYPE_HIGHLIGHT_END',
  /** Zvýraznění ikony na mapě */
  TypeHighlightIcon = 'TYPE_HIGHLIGHT_ICON',
  /** Konec - Zvýraznění ikony na mapě */
  TypeHighlightIconEnd = 'TYPE_HIGHLIGHT_ICON_END',
  /** Homepage */
  TypeHomepage = 'TYPE_HOMEPAGE',
  /** Konec - Homepage */
  TypeHomepageEnd = 'TYPE_HOMEPAGE_END',
  /** Vrácení priority na homepage */
  TypeHomepagePriorityDecrease = 'TYPE_HOMEPAGE_PRIORITY_DECREASE',
  /** Vyšší priorita na homepage */
  TypeHomepagePriorityIncrease = 'TYPE_HOMEPAGE_PRIORITY_INCREASE',
  /** Topování */
  TypeOrder = 'TYPE_ORDER',
  /** Vrácení priority řazení */
  TypeOrderPriorityDecrease = 'TYPE_ORDER_PRIORITY_DECREASE',
  /** Vyšší priorita v řazení */
  TypeOrderPriorityIncrease = 'TYPE_ORDER_PRIORITY_INCREASE',
  /** Vrácení priority v podobných inzerátech */
  TypeOrderRelatedPriorityDecrease = 'TYPE_ORDER_RELATED_PRIORITY_DECREASE',
  /** Vyšší priorita v podobných inzerátech */
  TypeOrderRelatedPriorityIncrease = 'TYPE_ORDER_RELATED_PRIORITY_INCREASE',
  /** Premium účet */
  TypePremiumAccount = 'TYPE_PREMIUM_ACCOUNT',
  /** Správa nájmu - aktivace */
  TypeRentPlatform = 'TYPE_RENT_PLATFORM',
  /** Trial */
  TypeTrial = 'TYPE_TRIAL'
}

export type AdvertFilterOptions = {
  __typename?: 'AdvertFilterOptions';
  estateType?: Maybe<Array<Maybe<EstateType>>>;
  offerType?: Maybe<Array<Maybe<OfferType>>>;
  visible?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export enum AdvertImportType {
  /** Comfort */
  Comfort = 'COMFORT',
  /** CS Chalupy */
  CsChalupy = 'CS_CHALUPY',
  /** Dokonalý Nájemník */
  DokonalyNajemnik = 'DOKONALY_NAJEMNIK',
  /** Doma je doma */
  DomaJeDoma = 'DOMA_JE_DOMA',
  /** E-Chalupy */
  EChalupy = 'E_CHALUPY',
  /** Flatio */
  Flatio = 'FLATIO',
  /** Heimstaden */
  Heimstaden = 'HEIMSTADEN',
  /** iDeveloper */
  Ideveloper = 'IDEVELOPER',
  /** Maxima */
  Maxima = 'MAXIMA',
  /** Prague office */
  PragueOffice = 'PRAGUE_OFFICE',
  /** TvůjSprávce */
  TvujSpravce = 'TVUJ_SPRAVCE',
  /** Not imported */
  Undefined = 'UNDEFINED'
}

export type AdvertLead = {
  __typename?: 'AdvertLead';
  /** Advert ID */
  advertId?: Maybe<Scalars['ID']>;
  /** Email */
  email?: Maybe<Scalars['String']>;
  /** Name */
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** Name */
  lastName?: Maybe<Scalars['String']>;
  /** Message */
  message?: Maybe<Scalars['String']>;
  /** Phone */
  phone?: Maybe<Scalars['String']>;
};

export type AdvertLeadInput = {
  /** Advert ID */
  advertId: Scalars['ID'];
  /** Email */
  email: Scalars['String'];
  /** Name */
  firstName: Scalars['String'];
  /** Name */
  lastName: Scalars['String'];
  /** Message */
  message?: InputMaybe<Scalars['String']>;
  /** Phone */
  phone: Scalars['String'];
  /** Recaptcha token */
  recaptcha: Scalars['String'];
};

export type AdvertList = {
  __typename?: 'AdvertList';
  envelopePolygon?: Maybe<GpsPolygon>;
  list?: Maybe<Array<Maybe<Advert>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Advert object to be used as map marker */
export type AdvertMarker = {
  __typename?: 'AdvertMarker';
  /** Generated address from region data */
  address?: Maybe<Scalars['String']>;
  charges?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currency>;
  deposit?: Maybe<Scalars['Int']>;
  disposition?: Maybe<Disposition>;
  estateType?: Maybe<EstateType>;
  fee?: Maybe<Scalars['Int']>;
  gps?: Maybe<GpsPoint>;
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** Main image */
  mainImage?: Maybe<Scalars['String']>;
  offerType?: Maybe<OfferType>;
  price?: Maybe<Scalars['Int']>;
  roommate?: Maybe<Scalars['Boolean']>;
  surface?: Maybe<Scalars['Int']>;
  surfaceLand?: Maybe<Scalars['Int']>;
  /** Time of last top */
  timeOrder?: Maybe<Scalars['DateTime']>;
  type?: Maybe<AdvertImportType>;
  /** URI where advert is available */
  uri?: Maybe<Scalars['String']>;
};

export type AdvertMessageData = {
  __typename?: 'AdvertMessageData';
  messageType?: Maybe<AdvertMessageType>;
  requireLogin?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum AdvertMessageType {
  /** Advert is not active */
  Inactive = 'INACTIVE',
  /** Send reaction as service lead */
  Lead = 'LEAD',
  /** Instead of sending a message, redirect user to given link */
  Link = 'LINK',
  /** Normal message */
  Message = 'MESSAGE',
  /** Message has already been sent */
  MessageSent = 'MESSAGE_SENT',
  /** Logged user is the owner of this advert */
  Owner = 'OWNER',
  /** Login with premium account is required */
  RequirePremium = 'REQUIRE_PREMIUM'
}

export type AdvertParameter = {
  __typename?: 'AdvertParameter';
  key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum AdvertParameterName {
  /** Age */
  Age = 'AGE',
  /** Condition */
  Condition = 'CONDITION',
  /** Construction */
  Construction = 'CONSTRUCTION',
  /** Disposition */
  Disposition = 'DISPOSITION',
  /** Education */
  Education = 'EDUCATION',
  /** Equipped */
  Equipped = 'EQUIPPED',
  /** Estate type */
  EstateType = 'ESTATE_TYPE',
  /** Execution */
  Execution = 'EXECUTION',
  /** Floor */
  Floor = 'FLOOR',
  /** Heating */
  Heating = 'HEATING',
  /** Land type */
  LandType = 'LAND_TYPE',
  /** Advert offer type */
  OfferType = 'OFFER_TYPE',
  /** Ownership */
  Ownership = 'OWNERSHIP',
  /** PENB */
  Penb = 'PENB',
  /** Reconstruction */
  Reconstruction = 'RECONSTRUCTION',
  /** Rent platform advert status */
  RentPlatformAdvertStatus = 'RENT_PLATFORM_ADVERT_STATUS',
  /** Rent platform contract status */
  RentPlatformContractStatus = 'RENT_PLATFORM_CONTRACT_STATUS',
  /** Rent platform cost frequency */
  RentPlatformCostFrequency = 'RENT_PLATFORM_COST_FREQUENCY',
  /** Rent platform payment method */
  RentPlatformPaymentMethod = 'RENT_PLATFORM_PAYMENT_METHOD',
  /** Rent platform payment status */
  RentPlatformPaymentStatus = 'RENT_PLATFORM_PAYMENT_STATUS',
  /** Rent platform payment type */
  RentPlatformPaymentType = 'RENT_PLATFORM_PAYMENT_TYPE',
  /** Rent platform repair payer */
  RentPlatformRepairPayer = 'RENT_PLATFORM_REPAIR_PAYER',
  /** Rent platform service payer */
  RentPlatformServicePayer = 'RENT_PLATFORM_SERVICE_PAYER',
  /** Rent platform service type */
  RentPlatformServiceType = 'RENT_PLATFORM_SERVICE_TYPE',
  /** Rent platform tenant status */
  RentPlatformTenantStatus = 'RENT_PLATFORM_TENANT_STATUS',
  /** Sewage */
  Sewage = 'SEWAGE',
  /** Water */
  Water = 'WATER'
}

export type AdvertPriceEstimation = {
  __typename?: 'AdvertPriceEstimation';
  currency?: Maybe<Currency>;
  price?: Maybe<Scalars['Int']>;
  priceMax?: Maybe<Scalars['Int']>;
  priceMin?: Maybe<Scalars['Int']>;
  relatedAdverts?: Maybe<AdvertList>;
  relatedAdvertsExpired?: Maybe<AdvertList>;
};

export type AdvertPriceRange = {
  __typename?: 'AdvertPriceRange';
  estateType?: Maybe<EstateType>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  offerType?: Maybe<OfferType>;
};

export type AdvertStatsDaily = {
  __typename?: 'AdvertStatsDaily';
  contactCounter?: Maybe<Scalars['Int']>;
  day?: Maybe<Scalars['DateTime']>;
  viewCounter?: Maybe<Scalars['Int']>;
};

export enum AdvertType {
  Offer = 'OFFER',
  Request = 'REQUEST'
}

export type AdvertUserVisit = {
  __typename?: 'AdvertUserVisit';
  advert?: Maybe<Advert>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  user?: Maybe<User>;
};

/**
 * Object containing user's relation to advert. P.e.: Favourite
 *
 */
export type AdvertUserstate = {
  __typename?: 'AdvertUserstate';
  advert?: Maybe<Advert>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  state?: Maybe<AdvertUserstateState>;
  user?: Maybe<User>;
};

export type AdvertUserstateList = {
  __typename?: 'AdvertUserstateList';
  list?: Maybe<Array<Maybe<AdvertUserstate>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum AdvertUserstateState {
  Favourite = 'FAVOURITE'
}

export type AdvertVideo = {
  __typename?: 'AdvertVideo';
  advert?: Maybe<Advert>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status?: Maybe<AdvertVideoStatus>;
  url?: Maybe<Scalars['String']>;
};

export enum AdvertVideoStatus {
  Failed = 'FAILED',
  New = 'NEW',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export enum Age {
  /** 1 - 10 */
  Between_1_10 = 'BETWEEN_1_10',
  /** 10 - 30 */
  Between_10_30 = 'BETWEEN_10_30',
  /** 30 - 50 */
  Between_30_50 = 'BETWEEN_30_50',
  /** více než 50 */
  Over_50 = 'OVER_50',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export type ApplePaySession = {
  __typename?: 'ApplePaySession';
  displayName?: Maybe<Scalars['String']>;
  domainName?: Maybe<Scalars['String']>;
  epochTimestamp?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
  merchantIdentifier?: Maybe<Scalars['String']>;
  merchantSessionIdentifier?: Maybe<Scalars['String']>;
  nonce?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
};

export type AuthData = {
  __typename?: 'AuthData';
  accountType?: Maybe<AccountType>;
  errors?: Maybe<Array<Maybe<FormError>>>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['ID']>;
};

export type AvailablePaymentMethods = {
  __typename?: 'AvailablePaymentMethods';
  cardTokens?: Maybe<Array<Maybe<PayuCardToken>>>;
  merchantId?: Maybe<Scalars['ID']>;
  payByLinks?: Maybe<Array<Maybe<PayuPayByLink>>>;
  posIdRest?: Maybe<Scalars['Int']>;
  status?: Maybe<PayUResponseStatus>;
};

export type BreadcrumbItem = {
  __typename?: 'BreadcrumbItem';
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Broker = {
  __typename?: 'Broker';
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  photoFilename?: Maybe<Scalars['String']>;
};


export type BrokerPhotoArgs = {
  filter: ImageFilter;
};

export type BrokerList = {
  __typename?: 'BrokerList';
  list?: Maybe<Array<Maybe<Broker>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CalendarEntry = {
  __typename?: 'CalendarEntry';
  advert?: Maybe<Advert>;
  calendarEvent?: Maybe<CalendarEvent>;
  free?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  timeDue?: Maybe<Scalars['DateTime']>;
};

export type CalendarEntryList = {
  __typename?: 'CalendarEntryList';
  list?: Maybe<Array<Maybe<CalendarEntry>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  calendarEntry?: Maybe<CalendarEntry>;
  confirmed?: Maybe<Scalars['Boolean']>;
  conversation?: Maybe<Conversation>;
  id?: Maybe<Scalars['ID']>;
  visitor?: Maybe<User>;
};

export type CalendarEventList = {
  __typename?: 'CalendarEventList';
  list?: Maybe<Array<Maybe<CalendarEvent>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum CalendarEventRole {
  Owner = 'OWNER',
  Visitor = 'VISITOR'
}

export enum Condition {
  /** Špatný */
  Bad = 'BAD',
  /** Ve výstavbě */
  Construction = 'CONSTRUCTION',
  /** K demolici */
  Demolition = 'DEMOLITION',
  /** Dobrý */
  Good = 'GOOD',
  /** Novostavba */
  New = 'NEW',
  /** Nevyplněno */
  Undefined = 'UNDEFINED',
  /** Velmi dobrý */
  VeryGood = 'VERY_GOOD'
}

export enum Construction {
  /** Cihla */
  Cihla = 'CIHLA',
  /** Dřevostavba */
  Drevostavba = 'DREVOSTAVBA',
  /** Nízkoenergetický */
  Nizkoenergeticky = 'NIZKOENERGETICKY',
  /** Ostatní */
  Ostatni = 'OSTATNI',
  /** Panel */
  Panel = 'PANEL',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export type Conversation = NotificationReference & {
  __typename?: 'Conversation';
  advert?: Maybe<Advert>;
  calendarEvent?: Maybe<CalendarEvent>;
  calendarShared?: Maybe<Scalars['Boolean']>;
  customer?: Maybe<User>;
  customerNote?: Maybe<Scalars['String']>;
  customerStatus?: Maybe<ConversationStatus>;
  id?: Maybe<Scalars['ID']>;
  important?: Maybe<Scalars['Boolean']>;
  importantCustomer?: Maybe<Scalars['Boolean']>;
  importantSeller?: Maybe<Scalars['Boolean']>;
  lockedReason?: Maybe<ConversationLockedReason>;
  messages?: Maybe<MessageList>;
  ownerAnswered?: Maybe<Scalars['Boolean']>;
  seller?: Maybe<User>;
  sellerNote?: Maybe<Scalars['String']>;
  sellerStatus?: Maybe<ConversationStatus>;
};


export type ConversationMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  unread?: InputMaybe<Scalars['Boolean']>;
};

export type ConversationList = {
  __typename?: 'ConversationList';
  list?: Maybe<Array<Maybe<Conversation>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum ConversationLockedReason {
  /** Inzerát byl deaktivován */
  AdvertDeactivated = 'ADVERT_DEACTIVATED',
  /** Uzavřeno uživatelem */
  ClosedByUser = 'CLOSED_BY_USER',
  /** Uživatel již nepoužívá Bezrealitky */
  UserRemoved = 'USER_REMOVED'
}

export enum ConversationRole {
  Customer = 'CUSTOMER',
  Seller = 'SELLER'
}

export enum ConversationStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Locked = 'LOCKED'
}

export type CreditCheckAsServiceInput = {
  /**
   * Date of birth
   *
   */
  birthNumber?: InputMaybe<Scalars['String']>;
  /**
   * City name
   *
   */
  city: Scalars['String'];
  /**
   * Date of birth
   *
   */
  dateBirth?: InputMaybe<Scalars['String']>;
  /**
   * DIČ
   *
   */
  dic?: InputMaybe<Scalars['String']>;
  /**
   * First name
   *
   */
  firstName: Scalars['String'];
  /**
   * House number
   *
   */
  houseNumber: Scalars['String'];
  /**
   * IČ
   *
   */
  ic?: InputMaybe<Scalars['String']>;
  /**
   * Číslo dokladu
   *
   */
  idNumber?: InputMaybe<Scalars['String']>;
  /**
   * Typ dokladu
   *
   */
  idType?: InputMaybe<CreditcheckIdType>;
  /**
   * Last name
   *
   */
  lastName: Scalars['String'];
  /**
   * Locale
   *
   */
  locale: Locale;
  /**
   * OrderPackage ID containing creditcheck service
   *
   */
  orderPackageId: Scalars['ID'];
  /**
   * Street name
   *
   */
  street: Scalars['String'];
  /**
   * Street number
   *
   */
  streetNumber?: InputMaybe<Scalars['String']>;
};

export type CreditCheckForUserInput = {
  /**
   * Birth number
   *
   */
  birthNumber?: InputMaybe<Scalars['String']>;
  /**
   * City name
   *
   */
  city: Scalars['String'];
  /**
   * Date of birth
   *
   */
  dateBirth?: InputMaybe<Scalars['String']>;
  /**
   * DIČ
   *
   */
  dic?: InputMaybe<Scalars['String']>;
  /**
   * First name
   *
   */
  firstName: Scalars['String'];
  /**
   * House number
   *
   */
  houseNumber: Scalars['String'];
  /**
   * IČ
   *
   */
  ic?: InputMaybe<Scalars['String']>;
  /**
   * Číslo dokladu
   *
   */
  idNumber?: InputMaybe<Scalars['String']>;
  /**
   * Typ dokladu
   *
   */
  idType?: InputMaybe<CreditcheckIdType>;
  /**
   * Last name
   *
   */
  lastName: Scalars['String'];
  /**
   * Locale
   *
   */
  locale: Locale;
  /**
   * Street name
   *
   */
  street: Scalars['String'];
  /**
   * Street number
   *
   */
  streetNumber?: InputMaybe<Scalars['String']>;
};

export type Creditcheck = {
  __typename?: 'Creditcheck';
  addressMatch?: Maybe<CreditcheckStatus>;
  bankruptcy?: Maybe<CreditcheckStatus>;
  debtSp?: Maybe<CreditcheckStatus>;
  debtVzp?: Maybe<CreditcheckStatus>;
  dph?: Maybe<CreditcheckStatus>;
  executionEvidence?: Maybe<CreditcheckStatus>;
  executionSkov?: Maybe<CreditcheckStatus>;
  hledaniPcr?: Maybe<CreditcheckStatus>;
  id?: Maybe<Scalars['ID']>;
  idValid?: Maybe<CreditcheckStatus>;
  insolvencyRegister?: Maybe<CreditcheckStatus>;
  locale?: Maybe<Locale>;
  reportUrl?: Maybe<Scalars['String']>;
  requestBirthNumber?: Maybe<Scalars['String']>;
  requestCity?: Maybe<Scalars['String']>;
  requestDateBirth?: Maybe<Scalars['String']>;
  requestFirstName?: Maybe<Scalars['String']>;
  requestHouseNumber?: Maybe<Scalars['String']>;
  requestIdNumber?: Maybe<Scalars['String']>;
  requestIdType?: Maybe<CreditcheckIdType>;
  requestLastName?: Maybe<Scalars['String']>;
  requestLocale: Locale;
  requestStreet?: Maybe<Scalars['String']>;
  requestStreetNumber?: Maybe<Scalars['String']>;
  requestZip?: Maybe<Scalars['String']>;
  rnDb?: Maybe<CreditcheckStatus>;
  skUrad?: Maybe<CreditcheckStatus>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  vzpDebtors?: Maybe<CreditcheckStatus>;
  zpmvcrDebtors?: Maybe<CreditcheckStatus>;
};

export enum CreditcheckIdType {
  /** Občanský průkaz */
  Id = 'ID',
  /** Pas */
  Pass = 'PASS',
  /** Nezadáno */
  Undefined = 'UNDEFINED'
}

export enum CreditcheckStatus {
  /** Fail */
  Fail = 'FAIL',
  /** OK */
  Ok = 'OK'
}

export enum Currency {
  /** CZK */
  Czk = 'CZK',
  /** EUR */
  Eur = 'EUR'
}

export enum DateIntervalEnum {
  /** 1 hour */
  Interval_1Day = 'INTERVAL_1_DAY',
  /** 1 hour */
  Interval_1Hour = 'INTERVAL_1_HOUR',
  /** None */
  None = 'NONE'
}

export enum DeactivationAction {
  /** Deaktivace */
  Deactivate = 'DEACTIVATE',
  /** Smazání */
  Delete = 'DELETE',
  /** Smazání neaktivního inzerátu */
  DeleteInactive = 'DELETE_INACTIVE'
}

export enum Disposition {
  /** 1+1 */
  Disp_1_1 = 'DISP_1_1',
  /** 1-izbový */
  Disp_1Izb = 'DISP_1_IZB',
  /** 1+kk */
  Disp_1Kk = 'DISP_1_KK',
  /** 2+1 */
  Disp_2_1 = 'DISP_2_1',
  /** 2-izbový */
  Disp_2Izb = 'DISP_2_IZB',
  /** 2+kk */
  Disp_2Kk = 'DISP_2_KK',
  /** 3+1 */
  Disp_3_1 = 'DISP_3_1',
  /** 3-izbový */
  Disp_3Izb = 'DISP_3_IZB',
  /** 3+kk */
  Disp_3Kk = 'DISP_3_KK',
  /** 4+1 */
  Disp_4_1 = 'DISP_4_1',
  /** 4-izbový */
  Disp_4Izb = 'DISP_4_IZB',
  /** 4+kk */
  Disp_4Kk = 'DISP_4_KK',
  /** 5+1 */
  Disp_5_1 = 'DISP_5_1',
  /** 5-izbový */
  Disp_5Izb = 'DISP_5_IZB',
  /** 5+kk */
  Disp_5Kk = 'DISP_5_KK',
  /** 6+1 */
  Disp_6_1 = 'DISP_6_1',
  /** 6-izbový */
  Disp_6Izb = 'DISP_6_IZB',
  /** 6+kk */
  Disp_6Kk = 'DISP_6_KK',
  /** 7+1 */
  Disp_7_1 = 'DISP_7_1',
  /** 7-izbový */
  Disp_7Izb = 'DISP_7_IZB',
  /** 7+kk */
  Disp_7Kk = 'DISP_7_KK',
  /** Garsoniéra */
  Garsoniera = 'GARSONIERA',
  /** Ostatní */
  Ostatni = 'OSTATNI',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export type Document = {
  __typename?: 'Document';
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  reference?: Maybe<DocumentReference>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
};

export type DocumentList = {
  __typename?: 'DocumentList';
  list?: Maybe<Array<Maybe<Document>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Interface for types that can be used as document reference */
export type DocumentReference = {
  /** ID */
  id?: Maybe<Scalars['ID']>;
};

export type EditUserInput = {
  /**
   * City
   *
   */
  city?: InputMaybe<Scalars['String']>;
  /**
   * Education
   *
   */
  education?: InputMaybe<Education>;
  /**
   * Number of family members
   *
   */
  familyMembers?: InputMaybe<Scalars['Int']>;
  /**
   * First name
   *
   */
  firstname?: InputMaybe<Scalars['String']>;
  /**
   * ID of user
   *
   */
  id: Scalars['ID'];
  /**
   * Last name
   *
   */
  lastname?: InputMaybe<Scalars['String']>;
  /**
   * Register newsletters
   *
   */
  newsletter?: InputMaybe<Scalars['Boolean']>;
  /**
   * Note
   *
   */
  note?: InputMaybe<Scalars['String']>;
  /**
   * Has pets
   *
   */
  pets?: InputMaybe<Scalars['String']>;
  /**
   * Phone number
   *
   */
  phone?: InputMaybe<Scalars['String']>;
  /**
   * Is smoker
   *
   */
  smoker?: InputMaybe<Scalars['Boolean']>;
  /**
   * Street
   *
   */
  street?: InputMaybe<Scalars['String']>;
  /**
   * Street number
   *
   */
  streetNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<UserGroupType>;
  userGroupDic?: InputMaybe<Scalars['String']>;
  userGroupIc?: InputMaybe<Scalars['String']>;
  userGroupName?: InputMaybe<Scalars['String']>;
  userGroupType?: InputMaybe<UserGroupKeyType>;
  /**
   * Workplace
   *
   */
  workplace?: InputMaybe<Scalars['String']>;
  /**
   * Year of birth
   *
   */
  yearBorn?: InputMaybe<Scalars['Int']>;
  /**
   * ZIP code
   *
   */
  zip?: InputMaybe<Scalars['String']>;
};

export enum Education {
  /** Výuční list s maturitou */
  CertGrad = 'CERT_GRAD',
  /** Výuční list bez maturity */
  CertNoGrad = 'CERT_NO_GRAD',
  /** Základní škola */
  Elementary = 'ELEMENTARY',
  /** Střední škola */
  HighSchool = 'HIGH_SCHOOL',
  /** Vyberte */
  Undefined = 'UNDEFINED',
  /** Vysoká škola nebo VOŠ */
  University = 'UNIVERSITY'
}

export enum EntityType {
  /** Inzerát */
  Advert = 'ADVERT',
  /** Galerie */
  Gallery = 'GALLERY',
  /** Smlouva */
  RentContract = 'RENT_CONTRACT',
  /** Vybavení */
  RentEquipment = 'RENT_EQUIPMENT',
  /** Oprava */
  RentRepair = 'RENT_REPAIR',
  /** Nájemník */
  RentTenant = 'RENT_TENANT'
}

export enum Equipped {
  /** Částečně */
  Castecne = 'CASTECNE',
  /** Nevybavený */
  Nevybaveny = 'NEVYBAVENY',
  /** Nevyplněno */
  Undefined = 'UNDEFINED',
  /** Vybavený */
  Vybaveny = 'VYBAVENY'
}

export enum EstateType {
  /** Byt */
  Byt = 'BYT',
  /** Dům */
  Dum = 'DUM',
  /** Garáž */
  Garaz = 'GARAZ',
  /** Kancelář */
  Kancelar = 'KANCELAR',
  /** Nebytový prostor */
  NebytovyProstor = 'NEBYTOVY_PROSTOR',
  /** Pozemek */
  Pozemek = 'POZEMEK',
  /** Rekreační objekt */
  RekreacniObjekt = 'REKREACNI_OBJEKT',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export enum Execution {
  /** nadstandardní: nadstandardní použité materiály a technologie */
  Premium = 'PREMIUM',
  /** standardní: běžné materiály a technologie */
  Standard = 'STANDARD',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export enum Floor {
  /** podkroví */
  Attic = 'ATTIC',
  /** přízemí */
  Ground = 'GROUND',
  /** vyvýšené přízemí */
  HighGround = 'HIGH_GROUND',
  /** poslední podlaží */
  Last = 'LAST',
  /** první až předposlední podlaží */
  Middle = 'MIDDLE',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export type FormError = {
  __typename?: 'FormError';
  fieldName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type FormattedBoolParameter = {
  __typename?: 'FormattedBoolParameter';
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type FormattedParameter = {
  __typename?: 'FormattedParameter';
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  trackPixelSrc?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  valueHref?: Maybe<Scalars['String']>;
};

export type GpsPoint = {
  __typename?: 'GPSPoint';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type GpsPointInput = {
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
};

export type GpsPolygon = {
  __typename?: 'GPSPolygon';
  points?: Maybe<Array<Maybe<GpsPoint>>>;
};

export type GpsPolygonInput = {
  points?: InputMaybe<Array<InputMaybe<GpsPointInput>>>;
};

export type Gallery = {
  __typename?: 'Gallery';
  id?: Maybe<Scalars['ID']>;
  images?: Maybe<Array<Maybe<Image>>>;
  mainImageUrl?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<GalleryReference>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
};


export type GalleryMainImageUrlArgs = {
  filter: ImageFilter;
};

/** Interface for types that can be used as gallery reference */
export type GalleryReference = {
  /** ID */
  id?: Maybe<Scalars['ID']>;
};

export enum Heating {
  /** centrální */
  Central = 'CENTRAL',
  /** elektrický kotel */
  Electric = 'ELECTRIC',
  /** plynový kotel */
  Gas = 'GAS',
  /** tepelné čerpadlo (geotermální) */
  Geothermal = 'GEOTHERMAL',
  /** jiné */
  Other = 'OTHER',
  /** ústřední dálkové */
  Remote = 'REMOTE',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export enum HouseType {
  /** Dvojdům */
  Double = 'DOUBLE',
  /** Bytový dům */
  Flat = 'FLAT',
  /** Řadový dům */
  Row = 'ROW',
  /** Samostatný dům */
  Single = 'SINGLE',
  Undefined = 'UNDEFINED'
}

export type HrefLang = {
  __typename?: 'HrefLang';
  locale?: Maybe<Locale>;
  url?: Maybe<Scalars['String']>;
};

export type Image = {
  __typename?: 'Image';
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  main?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  reference?: Maybe<Gallery>;
  size?: Maybe<Size>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};


export type ImageSizeArgs = {
  filter: ImageFilter;
};


export type ImageUrlArgs = {
  filter: ImageFilter;
};

export enum ImageAction {
  /** Delete advert image */
  Delete = 'DELETE',
  /** Rotate advert image left */
  RotateLeft = 'ROTATE_LEFT',
  /** Rotate advert image right */
  RotateRight = 'ROTATE_RIGHT'
}

export enum ImageFilter {
  /** 1800 x 1200, with watermark */
  RecordMain = 'RECORD_MAIN',
  /** 600 x 400, with watermark */
  RecordThumb = 'RECORD_THUMB',
  /** 120 x 120 */
  UserPhoto = 'USER_PHOTO'
}

export enum LandType {
  /** Bydlení */
  Bydleni = 'BYDLENI',
  /** Komerční */
  Komercni = 'KOMERCNI',
  /** Les */
  Les = 'LES',
  /** Louka */
  Louka = 'LOUKA',
  /** Ostatní */
  Ostatni = 'OSTATNI',
  /** Pole */
  Pole = 'POLE',
  /** Rybník */
  Rybnik = 'RYBNIK',
  /** Nevyplněno */
  Undefined = 'UNDEFINED',
  /** Zahrada */
  Zahrada = 'ZAHRADA'
}

export type LayoutStats = {
  __typename?: 'LayoutStats';
  countActive?: Maybe<Scalars['Int']>;
  countRealizedTrades?: Maybe<Scalars['Int']>;
  priceOfRealizedTrades?: Maybe<Scalars['Float']>;
};

export enum Locale {
  /** Czech */
  Cs = 'CS',
  /** English */
  En = 'EN',
  /** Slovak */
  Sk = 'SK'
}

export type MallPayResponse = {
  __typename?: 'MallPayResponse';
  gatewayRedirectUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  state?: Maybe<MallPayResponseState>;
};

export enum MallPayResponseState {
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** PROCESSING */
  Processing = 'PROCESSING',
  /** READY */
  Ready = 'READY',
  /** REJECTED */
  Rejected = 'REJECTED'
}

export enum MarketingConsentOrigin {
  /** Admin */
  Admin = 'ADMIN',
  /** Bezrealitky blog */
  Blog = 'BLOG',
  /** Comfort service page */
  Comfort = 'COMFORT',
  /** Consent landing-page */
  Consent = 'CONSENT',
  /** Contract rent service page */
  ContractRent = 'CONTRACT_RENT',
  /** Contract sale service page */
  ContractSale = 'CONTRACT_SALE',
  /** Advert detail */
  Detail = 'DETAIL',
  /** Express service page */
  Express = 'EXPRESS',
  /** Guide */
  Guide = 'GUIDE',
  /** Homepage */
  Hp = 'HP',
  /** Advert list */
  List = 'LIST',
  /** Login page */
  Login = 'LOGIN',
  /** PENB service page */
  Penb = 'PENB',
  /** User profile */
  Profile = 'PROFILE',
  /** Registration page */
  Registration = 'REGISTRATION',
  /** Services index */
  Services = 'SERVICES',
  /** Garance Najmu service page */
  TvujSpravce = 'TVUJ_SPRAVCE'
}

export type MenuCounts = {
  __typename?: 'MenuCounts';
  conversations?: Maybe<Scalars['Int']>;
  favourites?: Maybe<Scalars['Int']>;
  notifications?: Maybe<Scalars['Int']>;
  services?: Maybe<Scalars['Int']>;
  watchdogs?: Maybe<Scalars['Int']>;
};

export type Message = {
  __typename?: 'Message';
  author?: Maybe<User>;
  conversation?: Maybe<Conversation>;
  id?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeRead?: Maybe<Scalars['DateTime']>;
  unread?: Maybe<Scalars['Boolean']>;
};

export type MessageInput = {
  /**
   * Advert ID (Required if conversation argument is not used) Usage with advert ID can create new conversation if none exists
   *
   */
  advertId?: InputMaybe<Scalars['ID']>;
  /**
   * Conversation ID (Required if advert argument is not used)
   *
   */
  conversationId?: InputMaybe<Scalars['ID']>;
  /** Text of message */
  text: Scalars['String'];
};

export type MessageList = {
  __typename?: 'MessageList';
  list?: Maybe<Array<Maybe<Message>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MortgageData = {
  __typename?: 'MortgageData';
  loan?: Maybe<Scalars['Int']>;
  payment?: Maybe<Scalars['Int']>;
  paymentString?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['Float']>;
  years?: Maybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Activates advert
   *
   */
  activateAdvert?: Maybe<Advert>;
  /**
   * Adds calendar entry
   *
   */
  addCalendarEntry?: Maybe<CalendarEntry>;
  /**
   * Creates calendar event
   *
   */
  addCalendarEvent?: Maybe<CalendarEvent>;
  /**
   * Creates order and processed payment in case of an iOS In App Purchase
   *
   */
  addPaidOrder?: Maybe<Scalars['Boolean']>;
  applePayValidateMerchant?: Maybe<ApplePaySession>;
  /**
   * Gets user info from ARES
   *
   */
  aresInfo?: Maybe<UserAresInfo>;
  /**
   * Sends request to target user to perform creditcheck
   *
   */
  askForCreditCheck?: Maybe<Scalars['Boolean']>;
  changeImage?: Maybe<Image>;
  /**
   * Change password
   *
   */
  changePassword?: Maybe<Scalars['Boolean']>;
  /**
   * Requests password change for logged user
   *
   */
  changePasswordEmail?: Maybe<User>;
  /** Basic operations on photo */
  changeTmpImage?: Maybe<UploadTmpImageResponse>;
  /**
   * Check discount code validity
   *
   */
  checkDiscount?: Maybe<Scalars['Boolean']>;
  /** Closes all conversations */
  closeAllConversations?: Maybe<Scalars['Int']>;
  /** Close conversation */
  closeConversation?: Maybe<Conversation>;
  /** Owner confirmation of calendar event */
  confirmCalendarEvent?: Maybe<CalendarEvent>;
  /**
   * Connects a bank account via Budget Bakers
   *
   */
  connectBankAccount?: Maybe<Scalars['Boolean']>;
  /**
   * Connects facebook account with user
   *
   */
  connectFacebook?: Maybe<User>;
  /**
   * Connects google account with user
   *
   */
  connectGoogle?: Maybe<User>;
  /** Creates a new order */
  createOrder?: Maybe<OrderResponse>;
  /**
   * Request creditcheck on other person
   *
   */
  creditCheckAsService?: Maybe<Service>;
  /**
   * Requests creditcheck on self
   *
   */
  creditCheckForUser?: Maybe<User>;
  /**
   * Deactivates advert
   *
   */
  deactivateAdvert?: Maybe<Advert>;
  /** Deactivates project */
  deactivateProject?: Maybe<Project>;
  deleteAdvertVideo?: Maybe<Scalars['Boolean']>;
  /** Deletes all closed conversations */
  deleteAllConversations?: Maybe<Scalars['Boolean']>;
  /** Delete Broker */
  deleteBroker?: Maybe<Scalars['Boolean']>;
  /**
   * Deletes Broker photo
   *
   */
  deleteBrokerPhoto?: Maybe<Broker>;
  /** Deletes closed conversation */
  deleteConversation?: Maybe<Conversation>;
  /**
   * Deletes rent platform document
   *
   */
  deleteDocument?: Maybe<Scalars['Int']>;
  /**
   * Deletes image gallery
   *
   */
  deleteGallery?: Maybe<Scalars['ID']>;
  /**
   * Deletes notification
   *
   */
  deleteNotification?: Maybe<Scalars['Int']>;
  /** Deletes project photo */
  deleteProjectPhoto?: Maybe<Project>;
  /**
   * Deletes rent platform bank account
   *
   */
  deleteRentBankAccount?: Maybe<Scalars['Int']>;
  /**
   * Deletes rent platform cost
   *
   */
  deleteRentCost?: Maybe<Scalars['Int']>;
  /**
   * Deletes rent platform equipment
   *
   */
  deleteRentEquipment?: Maybe<Scalars['Int']>;
  /**
   * Deletes rent platform note
   *
   */
  deleteRentNote?: Maybe<Scalars['Int']>;
  /**
   * Deletes rent platform bank account
   *
   */
  deleteRentPayment?: Maybe<Scalars['Int']>;
  /**
   * Deletes rent platform repair
   *
   */
  deleteRentRepair?: Maybe<Scalars['Int']>;
  /**
   * Deletes rent platform service
   *
   */
  deleteRentService?: Maybe<Scalars['Int']>;
  /**
   * Deletes rent platform tenant
   *
   */
  deleteRentTenant?: Maybe<Scalars['Int']>;
  /**
   * Delete user photo
   *
   */
  deleteUserPhoto?: Maybe<User>;
  /**
   * Deletes watchdog
   *
   */
  deleteWatchdog?: Maybe<Scalars['Int']>;
  /** Duplicate advert */
  duplicateAdvert?: Maybe<Advert>;
  /** Add/Edit a Broker */
  editBroker?: Maybe<Broker>;
  /**
   * Edit image gallery
   *
   */
  editGallery?: Maybe<Gallery>;
  /**
   * Edit rent platform bank account
   *
   */
  editRentBankAccount?: Maybe<RentBankAccount>;
  /**
   * Edit rent platform contract
   *
   */
  editRentContract?: Maybe<RentContract>;
  /**
   * Edit rent platform cost
   *
   */
  editRentCost?: Maybe<RentCost>;
  /**
   * Edit rent platform equipment
   *
   */
  editRentEquipment?: Maybe<RentEquipment>;
  /**
   * Edit rent platform note
   *
   */
  editRentNote?: Maybe<RentNote>;
  /**
   * Edit rent platform bank account
   *
   */
  editRentPayment?: Maybe<RentPayment>;
  /**
   * Edit rent platform repair
   *
   */
  editRentRepair?: Maybe<RentRepair>;
  /**
   * Edit rent platform service
   *
   */
  editRentService?: Maybe<RentService>;
  /**
   * Edit rent platform tenant
   *
   */
  editRentTenant?: Maybe<RentTenant>;
  /**
   * Edits user
   *
   */
  editUser?: Maybe<User>;
  endRentContract?: Maybe<Scalars['Boolean']>;
  extendRentContract?: Maybe<Scalars['Boolean']>;
  /** Send forgotten password email */
  forgotPasswordEmail?: Maybe<Scalars['Boolean']>;
  freeActivateProperty?: Maybe<Scalars['Boolean']>;
  /**
   * Generates calendar token
   *
   */
  generateCalendarToken?: Maybe<User>;
  /** Log advert visit */
  logAdvertVisit?: Maybe<Advert>;
  /** Marks conversation as important */
  markImportantConversation?: Maybe<Conversation>;
  /** Marks conversation as read */
  markReadConversation?: Maybe<Conversation>;
  /**
   * Marks notifications as read
   *
   */
  markReadNotifications?: Maybe<NotificationList>;
  /** Marks conversation as unread */
  markUnreadConversation?: Maybe<Conversation>;
  /**
   * Marks watchdog as read
   *
   */
  markWatchdogSeen?: Maybe<Watchdog>;
  /** Subscribe to newsletter by email */
  newsletterSubscribe?: Maybe<Scalars['Boolean']>;
  /** Unsubscribe from newsletter */
  newsletterUnsubscribe?: Maybe<Scalars['Boolean']>;
  orderService?: Maybe<Scalars['Boolean']>;
  /** Advert action */
  projectAdvertAction?: Maybe<Project>;
  /** Re-opens closed conversation */
  reactivateConversation?: Maybe<Conversation>;
  /** Reactivates project */
  reactivateProject?: Maybe<Project>;
  /** User registration */
  registration?: Maybe<AuthData>;
  /**
   * Removes calendar entry
   *
   */
  removeCalendarEntry?: Maybe<Scalars['Boolean']>;
  /**
   * Removes calendar event
   *
   */
  removeCalendarEvent?: Maybe<Scalars['Boolean']>;
  /**
   * Remove contact information from advert description
   *
   */
  removeContacts?: Maybe<Scalars['Boolean']>;
  /**
   * Remove logged user
   *
   */
  removeUser?: Maybe<Scalars['Boolean']>;
  /** Reports conversation */
  reportConversation?: Maybe<Conversation>;
  /**
   * Requests password change
   *
   */
  resetPassword?: Maybe<Scalars['Boolean']>;
  /** Saves advert */
  saveAdvert?: Maybe<Advert>;
  /** Save note for conversation */
  saveConversationNote?: Maybe<Conversation>;
  /** Edit project */
  saveProject?: Maybe<Project>;
  /** Save tele-sale item */
  saveTeleSale?: Maybe<TeleSale>;
  /**
   * Edits watchdog
   *
   */
  saveWatchdog?: Maybe<Watchdog>;
  /** Send advert lead instead of message */
  sendAdvertLead?: Maybe<AdvertLead>;
  /** Sends entire conversation to user defined email */
  sendConversationByEmail?: Maybe<Scalars['Boolean']>;
  /** Sends new message */
  sendMessage?: Maybe<Message>;
  /** Requests SMS for phone verification */
  sendPhoneVerificationSms?: Maybe<Scalars['Boolean']>;
  /**
   * Send rent payment reminder
   *
   */
  sendRentPaymentReminder?: Maybe<Scalars['Boolean']>;
  /** Send service lead from form */
  sendServiceLead?: Maybe<ServiceLead>;
  /** Advert set project */
  setAdvertProject?: Maybe<Advert>;
  /**
   * Marks advert for rent platform
   *
   */
  setAdvertRentPlatform?: Maybe<Advert>;
  /**
   * Set advert platform status
   *
   */
  setAdvertRentPlatformStatus?: Maybe<Advert>;
  /** Sets advert reservation state */
  setAdvertReserved?: Maybe<Advert>;
  /** Set a comfort specialist for advert */
  setBroker?: Maybe<Broker>;
  /**
   * Sets advert favorite state
   *
   */
  setFavoriteAdvert?: Maybe<AdvertUserstate>;
  /**
   * Set new time due for Top AdvertEvent
   *
   */
  setTopTimeDue?: Maybe<AdvertEvent>;
  /**
   * Shares advert calendar for this conversation
   *
   */
  shareCalendar?: Maybe<Conversation>;
  /**
   * Shares advert calendar for this conversation
   *
   */
  shareCalendarBulk?: Maybe<ConversationList>;
  /**
   * Updates account settings
   *
   */
  updateAccountSettings?: Maybe<User>;
  /**
   * Updates user additional info
   *
   */
  updateAdditionalInfo?: Maybe<User>;
  /**
   * Updates basic user info
   *
   */
  updateBasicInfo?: Maybe<User>;
  /**
   * Updates settings for email/push notifications
   *
   */
  updateNotificationSettings?: Maybe<User>;
  updateUserProfileSettings?: Maybe<UserProfileSettings>;
  /**
   * Uploads Broker photo
   *
   */
  uploadBrokerPhoto?: Maybe<Broker>;
  /**
   * Upload and save a document
   *
   */
  uploadDocument?: Maybe<Document>;
  /** Upload and save image */
  uploadImage?: Maybe<Image>;
  /** Uploads project photo */
  uploadProjectPhoto?: Maybe<Project>;
  /** Uploads temporary image */
  uploadTmpImage?: Maybe<UploadTmpImageResponse>;
  /** Upload user photo */
  uploadUserPhoto?: Maybe<User>;
  verifyPhone?: Maybe<User>;
  /**
   * Request return of remaining wallet credit
   *
   */
  walletWithdraw?: Maybe<User>;
};


export type MutationActivateAdvertArgs = {
  advertId: Scalars['ID'];
};


export type MutationAddCalendarEntryArgs = {
  advert: Scalars['Int'];
  timeDue: Scalars['DateTime'];
};


export type MutationAddCalendarEventArgs = {
  calendarEntry: Scalars['Int'];
};


export type MutationAddPaidOrderArgs = {
  packages: Array<InputMaybe<SelectedPackageInput>>;
};


export type MutationApplePayValidateMerchantArgs = {
  hostname: Scalars['String'];
  merchantId: Scalars['String'];
  merchantName: Scalars['String'];
  validationUrl: Scalars['String'];
};


export type MutationAresInfoArgs = {
  ic: Scalars['String'];
};


export type MutationAskForCreditCheckArgs = {
  user: Scalars['ID'];
};


export type MutationChangeImageArgs = {
  action: ImageAction;
  id: Scalars['ID'];
};


export type MutationChangePasswordArgs = {
  email: Scalars['String'];
  hash: Scalars['String'];
  password1: Scalars['String'];
  password2: Scalars['String'];
};


export type MutationChangeTmpImageArgs = {
  action: ImageAction;
  filter: ImageFilter;
  url: Scalars['String'];
};


export type MutationCheckDiscountArgs = {
  code: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  package: Scalars['String'];
  price?: InputMaybe<Scalars['Int']>;
};


export type MutationCloseAllConversationsArgs = {
  advertId?: InputMaybe<Scalars['ID']>;
  closed?: InputMaybe<Scalars['Boolean']>;
  fulltext?: InputMaybe<Scalars['String']>;
  important?: InputMaybe<Scalars['Boolean']>;
  premium?: InputMaybe<Scalars['Boolean']>;
  role: ConversationRole;
  unread?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCloseConversationArgs = {
  conversationId: Scalars['ID'];
};


export type MutationConfirmCalendarEventArgs = {
  id: Scalars['Int'];
};


export type MutationConnectBankAccountArgs = {
  bankCode: Scalars['String'];
};


export type MutationConnectFacebookArgs = {
  facebookAccessToken: Scalars['String'];
};


export type MutationConnectGoogleArgs = {
  googleIdToken: Scalars['String'];
};


export type MutationCreateOrderArgs = {
  orderInput: OrderInput;
};


export type MutationCreditCheckAsServiceArgs = {
  creditCheckAsService: CreditCheckAsServiceInput;
};


export type MutationCreditCheckForUserArgs = {
  creditCheckForUser: CreditCheckForUserInput;
};


export type MutationDeactivateAdvertArgs = {
  advertDeactivate: AdvertDeactivateInput;
};


export type MutationDeactivateProjectArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAdvertVideoArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBrokerArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBrokerPhotoArgs = {
  brokerId: Scalars['Int'];
};


export type MutationDeleteConversationArgs = {
  conversationId: Scalars['ID'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteGalleryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNotificationArgs = {
  id?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteProjectPhotoArgs = {
  projectId: Scalars['ID'];
};


export type MutationDeleteRentBankAccountArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRentCostArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRentEquipmentArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRentNoteArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRentPaymentArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRentRepairArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRentServiceArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRentTenantArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteWatchdogArgs = {
  id: Scalars['ID'];
};


export type MutationDuplicateAdvertArgs = {
  id: Scalars['ID'];
};


export type MutationEditBrokerArgs = {
  email: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  lastName: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationEditGalleryArgs = {
  advertId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  images?: InputMaybe<Array<InputMaybe<UploadedImageInput>>>;
  note?: InputMaybe<Scalars['String']>;
  public: Scalars['Boolean'];
  title: Scalars['String'];
};


export type MutationEditRentBankAccountArgs = {
  bankName: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  number: Scalars['String'];
};


export type MutationEditRentContractArgs = {
  cotenants?: InputMaybe<Array<InputMaybe<RentCotenantInput>>>;
  currency: Currency;
  dayPaymentDue: Scalars['Int'];
  deposit: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
  price: Scalars['Int'];
  priceServices?: InputMaybe<Scalars['Int']>;
  property: Scalars['Int'];
  tenant: Scalars['Int'];
  timeEnd?: InputMaybe<Scalars['DateTime']>;
  timeSigned: Scalars['DateTime'];
  timeStart: Scalars['DateTime'];
};


export type MutationEditRentCostArgs = {
  advertId?: InputMaybe<Scalars['Int']>;
  currency: Currency;
  frequency: RentPlatformCostFrequency;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  price: Scalars['Int'];
  timeDue?: InputMaybe<Scalars['DateTime']>;
  timeFirstPayment?: InputMaybe<Scalars['DateTime']>;
  timePaid?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};


export type MutationEditRentEquipmentArgs = {
  advertId?: InputMaybe<Scalars['Int']>;
  currency: Currency;
  discarded: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<InputMaybe<UploadedImageInput>>>;
  price: Scalars['Int'];
  timeDiscarded?: InputMaybe<Scalars['DateTime']>;
  timePurchased?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};


export type MutationEditRentNoteArgs = {
  advertId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
  title: Scalars['String'];
};


export type MutationEditRentPaymentArgs = {
  amount: Scalars['Float'];
  bankAccountId?: InputMaybe<Scalars['Int']>;
  currency: Currency;
  id?: InputMaybe<Scalars['Int']>;
  identifier: Scalars['String'];
  method: RentPlatformPaymentMethod;
  propertyId: Scalars['Int'];
  tenantId: Scalars['Int'];
  timeDue?: InputMaybe<Scalars['DateTime']>;
  timePaid?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: RentPlatformPaymentType;
};


export type MutationEditRentRepairArgs = {
  advertId?: InputMaybe<Scalars['Int']>;
  currency: Currency;
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<InputMaybe<UploadedImageInput>>>;
  note?: InputMaybe<Scalars['String']>;
  payer?: InputMaybe<RentPlatformRepairPayer>;
  price: Scalars['Int'];
  timePaid?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};


export type MutationEditRentServiceArgs = {
  advertId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  payer?: InputMaybe<RentPlatformServicePayer>;
  status: Scalars['Int'];
  timeSubscribed?: InputMaybe<Scalars['DateTime']>;
  type: RentPlatformServiceType;
};


export type MutationEditRentTenantArgs = {
  birthNumber?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  dateBirth?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstname: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  lastname: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  paymentIdentifier?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RentPlatformTenantStatus>;
  street: Scalars['String'];
  streetNumber: Scalars['String'];
  tenantCount?: InputMaybe<Scalars['Int']>;
  zip: Scalars['String'];
};


export type MutationEditUserArgs = {
  editUser: EditUserInput;
};


export type MutationEndRentContractArgs = {
  contractId: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationExtendRentContractArgs = {
  contractId: Scalars['Int'];
  timeEnd: Scalars['DateTime'];
};


export type MutationForgotPasswordEmailArgs = {
  email: Scalars['String'];
  recaptcha: Scalars['String'];
};


export type MutationFreeActivatePropertyArgs = {
  advertId: Scalars['Int'];
};


export type MutationGenerateCalendarTokenArgs = {
  userId: Scalars['Int'];
};


export type MutationLogAdvertVisitArgs = {
  id: Scalars['ID'];
};


export type MutationMarkImportantConversationArgs = {
  conversationId: Scalars['ID'];
  important: Scalars['Boolean'];
};


export type MutationMarkReadConversationArgs = {
  conversationId: Scalars['ID'];
};


export type MutationMarkUnreadConversationArgs = {
  conversationId: Scalars['ID'];
};


export type MutationMarkWatchdogSeenArgs = {
  id: Scalars['ID'];
};


export type MutationNewsletterSubscribeArgs = {
  email: Scalars['String'];
  origin: MarketingConsentOrigin;
  recaptcha: Scalars['String'];
};


export type MutationNewsletterUnsubscribeArgs = {
  email: Scalars['String'];
  token: Scalars['String'];
};


export type MutationOrderServiceArgs = {
  form: Scalars['String'];
  serviceType: ServiceType;
};


export type MutationProjectAdvertActionArgs = {
  action: ProjectAdvertAction;
  id: Scalars['ID'];
};


export type MutationReactivateConversationArgs = {
  conversationId: Scalars['ID'];
};


export type MutationReactivateProjectArgs = {
  id: Scalars['ID'];
};


export type MutationRegistrationArgs = {
  registrationInput: RegistrationInput;
};


export type MutationRemoveCalendarEntryArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveCalendarEventArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveContactsArgs = {
  recordId: Scalars['Int'];
};


export type MutationReportConversationArgs = {
  conversationId: Scalars['ID'];
  message: Scalars['String'];
  type: UserReportType;
};


export type MutationResetPasswordArgs = {
  login: Scalars['String'];
};


export type MutationSaveAdvertArgs = {
  advertSave: SaveAdvertInput;
};


export type MutationSaveConversationNoteArgs = {
  conversationId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationSaveProjectArgs = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationSaveTeleSaleArgs = {
  advertId: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  status: TeleSaleStatus;
  subStatus?: InputMaybe<TeleSaleSubStatus>;
};


export type MutationSaveWatchdogArgs = {
  saveWatchdog: SaveWatchdogInput;
};


export type MutationSendAdvertLeadArgs = {
  advertLead: AdvertLeadInput;
};


export type MutationSendConversationByEmailArgs = {
  conversationId: Scalars['ID'];
  email: Scalars['String'];
};


export type MutationSendMessageArgs = {
  message: MessageInput;
};


export type MutationSendPhoneVerificationSmsArgs = {
  locale: Locale;
  phone: Scalars['String'];
  phoneCountry: Scalars['String'];
  phonePrefix: Scalars['Int'];
};


export type MutationSendRentPaymentReminderArgs = {
  paymentId: Scalars['Int'];
  text: Scalars['String'];
};


export type MutationSendServiceLeadArgs = {
  serviceLead: ServiceLeadInput;
};


export type MutationSetAdvertProjectArgs = {
  advertId: Scalars['ID'];
  code?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
};


export type MutationSetAdvertRentPlatformArgs = {
  advert: Scalars['ID'];
  platform: Scalars['Boolean'];
};


export type MutationSetAdvertRentPlatformStatusArgs = {
  advert: Scalars['ID'];
  status: RentPlatformAdvertStatus;
};


export type MutationSetAdvertReservedArgs = {
  advertId: Scalars['ID'];
  alertTime?: InputMaybe<Scalars['Int']>;
  reserved: Scalars['Boolean'];
  reservedUserId?: InputMaybe<Scalars['ID']>;
};


export type MutationSetBrokerArgs = {
  advertId: Scalars['Int'];
  brokerId: Scalars['Int'];
};


export type MutationSetFavoriteAdvertArgs = {
  advertId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  state: Scalars['Boolean'];
};


export type MutationSetTopTimeDueArgs = {
  advertEventId: Scalars['ID'];
  timeDue: Scalars['DateTime'];
};


export type MutationShareCalendarArgs = {
  conversation: Scalars['Int'];
};


export type MutationShareCalendarBulkArgs = {
  conversations?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type MutationUpdateAccountSettingsArgs = {
  locale: Locale;
  newsletter: Scalars['Boolean'];
  user: Scalars['ID'];
};


export type MutationUpdateAdditionalInfoArgs = {
  education?: InputMaybe<Education>;
  familyMembers?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  pets?: InputMaybe<Scalars['String']>;
  smoker?: InputMaybe<Scalars['Boolean']>;
  user: Scalars['ID'];
  workplace?: InputMaybe<Scalars['String']>;
  yearBorn?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateBasicInfoArgs = {
  city?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneCountry?: InputMaybe<Scalars['String']>;
  phonePrefix?: InputMaybe<Scalars['Int']>;
  street?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<UserGroupType>;
  user: Scalars['ID'];
  userGroupDic?: InputMaybe<Scalars['String']>;
  userGroupIc?: InputMaybe<Scalars['String']>;
  userGroupName?: InputMaybe<Scalars['String']>;
  userGroupType?: InputMaybe<UserGroupKeyType>;
  zip?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateNotificationSettingsArgs = {
  emailMessage?: InputMaybe<Scalars['Boolean']>;
  emailWatchdog?: InputMaybe<Scalars['Boolean']>;
  pushMessage?: InputMaybe<Scalars['Boolean']>;
  pushWatchdog?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateUserProfileSettingsArgs = {
  rentPlatformDashboardOrder?: InputMaybe<Scalars['String']>;
  rentPlatformReminderText?: InputMaybe<Scalars['String']>;
};


export type MutationUploadBrokerPhotoArgs = {
  brokerId: Scalars['Int'];
  fileData: Scalars['String'];
};


export type MutationUploadDocumentArgs = {
  entityId: Scalars['Int'];
  entityType: EntityType;
  fileData: Scalars['String'];
  fileName: Scalars['String'];
};


export type MutationUploadImageArgs = {
  entityId: Scalars['ID'];
  entityType: EntityType;
  file: Scalars['ImageUpload'];
};


export type MutationUploadProjectPhotoArgs = {
  fileData: Scalars['String'];
  projectId: Scalars['ID'];
};


export type MutationUploadTmpImageArgs = {
  file: Scalars['ImageUpload'];
  filter: ImageFilter;
};


export type MutationUploadUserPhotoArgs = {
  file: Scalars['ImageUpload'];
};


export type MutationVerifyPhoneArgs = {
  code: Scalars['String'];
  locale: Locale;
  phone: Scalars['String'];
  phoneCountry: Scalars['String'];
  phonePrefix: Scalars['Int'];
};


export type MutationWalletWithdrawArgs = {
  action: WalletWithdrawAction;
  payment?: InputMaybe<Scalars['ID']>;
};

export type Notification = {
  __typename?: 'Notification';
  /**
   * Target url containing referenced entity
   *
   */
  href?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  reference?: Maybe<NotificationReference>;
  service?: Maybe<NotificationService>;
  status?: Maybe<NotificationStatus>;
  text?: Maybe<Scalars['String']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<NotificationType>;
  user?: Maybe<User>;
};

export type NotificationList = {
  __typename?: 'NotificationList';
  list?: Maybe<Array<Maybe<Notification>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Interface for types that can be used as notification reference */
export type NotificationReference = {
  /** ID */
  id?: Maybe<Scalars['ID']>;
};

export enum NotificationService {
  /** Všichni aktivní */
  AllActive = 'ALL_ACTIVE',
  /** Potvrzení prohlídky */
  CalendarConfirmed = 'CALENDAR_CONFIRMED',
  /** Sdílení kalendáře */
  CalendarShared = 'CALENDAR_SHARED',
  /** Služba Komfort */
  Comfort = 'COMFORT',
  /** Podpis smlouvy */
  ContractSigned = 'CONTRACT_SIGNED',
  /** Žádost o ověření přes creditcheck */
  DemandCreditcheck = 'DEMAND_CREDITCHECK',
  /** Nízké hodnocení profilu */
  LowProfileScore = 'LOW_PROFILE_SCORE',
  /** Hypotéka */
  Mortgage = 'MORTGAGE',
  /** Testovací */
  Test = 'TEST',
  /** Garance nájmu */
  TvujSpravce = 'TVUJ_SPRAVCE',
  /** Garance nájmu */
  TvujSpravce_21 = 'TVUJ_SPRAVCE_21'
}

export enum NotificationStatus {
  Hidden = 'HIDDEN',
  New = 'NEW',
  Read = 'READ'
}

export enum NotificationType {
  /** Automatická */
  Auto = 'AUTO',
  /** Manuální */
  Manual = 'MANUAL'
}

export enum OfferType {
  /** Prodej */
  Prodej = 'PRODEJ',
  /** Pronájem */
  Pronajem = 'PRONAJEM',
  /** Spolubydlení */
  Spolubydleni = 'SPOLUBYDLENI',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export type OrderInput = {
  /** Amount */
  amount: Scalars['Int'];
  /** Apple Pay token */
  applePayToken?: InputMaybe<Scalars['String']>;
  /** Payment channel */
  channel: PaymentChannel;
  /** Currency */
  currency: Currency;
  /** Google Pay auth code */
  googlePayAuthCode?: InputMaybe<Scalars['String']>;
  /** Payment method */
  method: PaymentMethod;
  /** Locale where the order was created */
  originLocale: Locale;
  /** Purchased packages */
  packages: Array<InputMaybe<SelectedPackageInput>>;
  /** PayU card token */
  payUCardToken?: InputMaybe<Scalars['String']>;
  /** Voucher name */
  voucherName?: InputMaybe<Scalars['String']>;
};

export type OrderPackage = {
  __typename?: 'OrderPackage';
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['ID']>;
  locale?: Maybe<Locale>;
  paymentPrice?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  referenceId?: Maybe<Scalars['ID']>;
  referenceType?: Maybe<OrderPackageReferenceType>;
  title?: Maybe<Scalars['String']>;
};


export type OrderPackageTitleArgs = {
  locale: Locale;
};

export enum OrderPackageReferenceType {
  /** Inzerát */
  Advert = 'ADVERT',
  /** Projekt */
  Project = 'PROJECT',
  /** Žádný */
  Undefined = 'UNDEFINED',
  /** Uživatel */
  User = 'USER'
}

export type OrderResponse = {
  __typename?: 'OrderResponse';
  amount?: Maybe<Scalars['Int']>;
  channel?: Maybe<PaymentChannel>;
  error?: Maybe<Scalars['String']>;
  intention?: Maybe<PaymentIntention>;
  mallPay?: Maybe<MallPayResponse>;
  method?: Maybe<PaymentMethod>;
  packages?: Maybe<Array<Maybe<SelectedPackage>>>;
  paymentId?: Maybe<Scalars['ID']>;
  payu?: Maybe<PayUResponse>;
  status?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['ID']>;
  voucherDiscount?: Maybe<Scalars['Int']>;
  voucherName?: Maybe<Scalars['String']>;
};

export enum Ownership {
  /** Družstevní */
  Druzstevni = 'DRUZSTEVNI',
  /** Obecní */
  Obecni = 'OBECNI',
  /** Osobní */
  Osobni = 'OSOBNI',
  /** Ostatní */
  Ostatni = 'OSTATNI',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export enum Penb {
  /** A - mimořádně úsporná */
  A = 'A',
  /** B - velmi úsporná */
  B = 'B',
  /** C - úsporná */
  C = 'C',
  /** D - méně úsporná */
  D = 'D',
  /** E - nehospodárná */
  E = 'E',
  /** F - velmi nehospodárná */
  F = 'F',
  /** G - mimořádně nehospodárná */
  G = 'G',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export type Package = {
  __typename?: 'Package';
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  freeTopCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  intention?: Maybe<PaymentIntention>;
  keyFeatures?: Maybe<Array<Maybe<PackageKeyFeature>>>;
  price?: Maybe<Scalars['Int']>;
  promokitAvailable?: Maybe<Scalars['Boolean']>;
  promokitFreeDelivery?: Maybe<Scalars['Boolean']>;
  referenceOptions?: Maybe<Array<Maybe<PackageReferenceOption>>>;
  title?: Maybe<Scalars['String']>;
  titleShort?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};


export type PackageDescriptionArgs = {
  locale: Locale;
};


export type PackageKeyFeaturesArgs = {
  locale: Locale;
};


export type PackageReferenceOptionsArgs = {
  locale: Locale;
};


export type PackageTitleArgs = {
  locale: Locale;
};


export type PackageTitleShortArgs = {
  locale: Locale;
};

export enum PackageCategory {
  /** Account packages */
  Account = 'ACCOUNT',
  /** Advert packages */
  Advert = 'ADVERT',
  /** Advert rent packages */
  AdvertRent = 'ADVERT_RENT',
  /** Advert sale packages */
  AdvertSale = 'ADVERT_SALE',
  /** Advert top packages for given advert */
  AdvertTop = 'ADVERT_TOP',
  /** Advert top packages */
  AdvertTopAll = 'ADVERT_TOP_ALL',
  /** Contract rent packages */
  ContractRent = 'CONTRACT_RENT',
  /** Contract sale packages */
  ContractSale = 'CONTRACT_SALE',
  /** Project */
  Project = 'PROJECT',
  /** Project activation */
  ProjectActivation = 'PROJECT_ACTIVATION',
  /** Project in attractive listings */
  ProjectAttractive = 'PROJECT_ATTRACTIVE',
  /** Project top */
  ProjectTop = 'PROJECT_TOP',
  /** Promokit delivery */
  PromokitDelivery = 'PROMOKIT_DELIVERY',
  /** Promokit print */
  PromokitPrint = 'PROMOKIT_PRINT',
  /** Rent platform */
  RentPlatform = 'RENT_PLATFORM',
  /** Service center packages */
  ServiceCenter = 'SERVICE_CENTER'
}

export enum PackageFeatureIcon {
  /** Check icon */
  Check = 'CHECK',
  /** Cross icon */
  Cross = 'CROSS'
}

export type PackageKeyFeature = {
  __typename?: 'PackageKeyFeature';
  content?: Maybe<Scalars['String']>;
  contentExpanded?: Maybe<Scalars['String']>;
  icon?: Maybe<PackageFeatureIcon>;
  key?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PackageReferenceOption = {
  __typename?: 'PackageReferenceOption';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type Page = NotificationReference & {
  __typename?: 'Page';
  header?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaKeywords?: Maybe<Scalars['String']>;
  suburi?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export enum PageInfoType {
  /** Privacy policy */
  PrivacyPolicy = 'PRIVACY_POLICY',
  /** Privacy policy - advert */
  PrivacyPolicyAdvert = 'PRIVACY_POLICY_ADVERT',
  /** Privacy policy - advert - Comfort */
  PrivacyPolicyAdvertComfort = 'PRIVACY_POLICY_ADVERT_COMFORT',
  /** Privacy policy - advert - Optimal/Complete */
  PrivacyPolicyAdvertOptimalComplete = 'PRIVACY_POLICY_ADVERT_OPTIMAL_COMPLETE',
  /** Privacy policy - cleanup */
  PrivacyPolicyCleanup = 'PRIVACY_POLICY_CLEANUP',
  /** Privacy policy - contract rent online */
  PrivacyPolicyContractRentOnline = 'PRIVACY_POLICY_CONTRACT_RENT_ONLINE',
  /** Privacy policy - photo */
  PrivacyPolicyPhoto = 'PRIVACY_POLICY_PHOTO',
  /** Privacy policy - registration */
  PrivacyPolicyRegistration = 'PRIVACY_POLICY_REGISTRATION',
  /** Privacy policy - paid registration */
  PrivacyPolicyRegistrationPaid = 'PRIVACY_POLICY_REGISTRATION_PAID',
  /** Privacy policy - service */
  PrivacyPolicyService = 'PRIVACY_POLICY_SERVICE',
  /** Terms and conditions */
  TermsAndConditions = 'TERMS_AND_CONDITIONS'
}

export type PageList = {
  __typename?: 'PageList';
  list?: Maybe<Array<Maybe<Page>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum PayUMethodStatus {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** DISABLED */
  Disabled = 'DISABLED',
  /** ENABLED */
  Enabled = 'ENABLED',
  /** EXPIRED */
  Expired = 'EXPIRED',
  /** TEMPORARY_DISABLED */
  TemporaryDisabled = 'TEMPORARY_DISABLED'
}

export type PayUOrderResponse = {
  __typename?: 'PayUOrderResponse';
  orderId?: Maybe<Scalars['String']>;
  redirectUri?: Maybe<Scalars['String']>;
  status?: Maybe<PayUOrderResponseStatus>;
};

export type PayUOrderResponseStatus = {
  __typename?: 'PayUOrderResponseStatus';
  statusCode?: Maybe<PayUOrderResponseStatusCode>;
};

export enum PayUOrderResponseStatusCode {
  /** ERROR */
  Error = 'ERROR',
  /** ERROR_CARD */
  ErrorCard = 'ERROR_CARD',
  /** ERROR_PBL */
  ErrorPbl = 'ERROR_PBL',
  /** SUCCESS_3DS */
  Success_3Ds = 'SUCCESS_3DS',
  /** SUCCESS_PBL */
  SuccessPbl = 'SUCCESS_PBL',
  /** WARNING_CONTINUE_3DS */
  WarningContinue_3Ds = 'WARNING_CONTINUE_3DS',
  /** WARNING_CONTINUE_CVV */
  WarningContinueCvv = 'WARNING_CONTINUE_CVV',
  /** WARNING_CONTINUE_PBL */
  WarningContinuePbl = 'WARNING_CONTINUE_PBL'
}

export type PayUResponse = {
  __typename?: 'PayUResponse';
  action?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  client_ip?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
  pay_type?: Maybe<Scalars['String']>;
  payu_order_response?: Maybe<PayUOrderResponse>;
  pos_auth_key?: Maybe<Scalars['String']>;
  pos_id?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['Int']>;
  sig?: Maybe<Scalars['String']>;
  ts?: Maybe<Scalars['String']>;
};

export type PayUResponseStatus = {
  __typename?: 'PayUResponseStatus';
  statusCode?: Maybe<PayUResponseStatusCode>;
  statusDesc?: Maybe<Scalars['String']>;
};

export enum PayUResponseStatusCode {
  /** CANCELED */
  Canceled = 'CANCELED',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** NEW */
  New = 'NEW',
  /** PENDING */
  Pending = 'PENDING',
  /** REJECTED */
  Rejected = 'REJECTED',
  /** SUCCESS */
  Success = 'SUCCESS',
  /** WAITING_FOR_CONFIRMATION */
  WaitingForConfirmation = 'WAITING_FOR_CONFIRMATION'
}

export type Payment = {
  __typename?: 'Payment';
  channel?: Maybe<PaymentChannel>;
  currency?: Maybe<Currency>;
  dataLayerJson?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  intention?: Maybe<PaymentIntention>;
  intentionStr?: Maybe<Scalars['String']>;
  isWalletWithdrawRequest?: Maybe<Scalars['Boolean']>;
  mainPackage?: Maybe<SelectedPackage>;
  method?: Maybe<PaymentMethod>;
  pdfUrl?: Maybe<Scalars['String']>;
  signedAmount?: Maybe<Scalars['Int']>;
  status?: Maybe<PaymentStatus>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeProcessed?: Maybe<Scalars['DateTime']>;
};


export type PaymentIntentionStrArgs = {
  locale: Locale;
};

export enum PaymentChannel {
  /** Google Pay */
  Ap = 'AP',
  /** PayU-bt (Bankovní převod) */
  Bt = 'BT',
  /** PayU-c (Platební karta) */
  C = 'C',
  /** PayU-cb (ČSOB) */
  Cb = 'CB',
  /** PayU-ceko (Československá obchodná banka) */
  Ceko = 'CEKO',
  /** PayU-cs (Platba 24) */
  Cs = 'CS',
  /** PayU-era (ERA) */
  Era = 'ERA',
  /** Apple Pay */
  Jp = 'JP',
  /** PayU-kb (Komerční banka) */
  Kb = 'KB',
  /** Masterpass */
  Ma = 'MA',
  /** PayU-mo (Mobito) */
  Mo = 'MO',
  /** PayU-mb (mPeníze) */
  Mp = 'MP',
  /** PayU-pf (FIO banka) */
  Pf = 'PF',
  /** PayU-pg (Moneta Money Bank) */
  Pg = 'PG',
  /** PayU-posta (Poštová banka) */
  Posta = 'POSTA',
  /** PayU-pt (Složenka) */
  Pt = 'PT',
  /** PayU-pv (Sberbank) */
  Pv = 'PV',
  /** PayU-rf (ePlatba) */
  Rf = 'RF',
  /** PayU-sporo (Sporopay) */
  Sporo = 'SPORO',
  /** PayU-t (Testovací) */
  T = 'T',
  /** PayU-tatra (Tatrabank) */
  Tatra = 'TATRA',
  /** PayU-uc (Unicredi) */
  Uc = 'UC',
  /** Undefined */
  Undefined = 'UNDEFINED',
  /** PayU-uni (UniCredit) */
  Uni = 'UNI',
  /** PayU-viamo (Viamo) */
  Viamo = 'VIAMO',
  /** PayU-vub (ePlatby VÚB) */
  Vub = 'VUB'
}

export enum PaymentIntention {
  /** Pay for account */
  PayAccount = 'PAY_ACCOUNT',
  /** Activate or highlight an advert */
  PayAdvert = 'PAY_ADVERT',
  /** Pay for a Premium account */
  PayPremiumAccount = 'PAY_PREMIUM_ACCOUNT',
  /** Pay for a project */
  PayProject = 'PAY_PROJECT',
  /** Rent platform */
  PayRentPlatform = 'PAY_RENT_PLATFORM',
  /** Pay for a package from Service Center */
  PayService = 'PAY_SERVICE',
  /** Charge wallet */
  WalletCharge = 'WALLET_CHARGE',
  /** Withdraw wallet */
  WalletWithdraw = 'WALLET_WITHDRAW'
}

export type PaymentList = {
  __typename?: 'PaymentList';
  list?: Maybe<Array<Maybe<Payment>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum PaymentListType {
  /** Wallet type payments */
  Wallet = 'WALLET'
}

export enum PaymentMethod {
  Campaign = 'CAMPAIGN',
  Cash = 'CASH',
  Invoice = 'INVOICE',
  InvoiceProforma = 'INVOICE_PROFORMA',
  MallPay = 'MALL_PAY',
  Payu = 'PAYU',
  ProblemSolved = 'PROBLEM_SOLVED',
  Reclaim = 'RECLAIM',
  ReclaimBasicAccount = 'RECLAIM_BASIC_ACCOUNT',
  ReclaimPremiumAccount = 'RECLAIM_PREMIUM_ACCOUNT',
  ReclaimService = 'RECLAIM_SERVICE',
  Sms = 'SMS',
  Wallet = 'WALLET'
}

export type PaymentSettings = {
  __typename?: 'PaymentSettings';
  testPaymentAvailable?: Maybe<Scalars['Boolean']>;
};

export enum PaymentStatus {
  Canceled = 'CANCELED',
  Error = 'ERROR',
  NotProcessed = 'NOT_PROCESSED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type PayuCardToken = {
  __typename?: 'PayuCardToken';
  brandImageUrl?: Maybe<Scalars['String']>;
  cardExpirationMonth?: Maybe<Scalars['String']>;
  cardExpirationYear?: Maybe<Scalars['String']>;
  cardNumberMasked?: Maybe<Scalars['String']>;
  cardScheme?: Maybe<Scalars['String']>;
  preferred?: Maybe<Scalars['Boolean']>;
  status?: Maybe<PayUMethodStatus>;
  value?: Maybe<Scalars['String']>;
};

export enum PayuOrderType {
  /** Last user account order */
  Account = 'ACCOUNT',
  /** Advert activation order */
  Advert = 'ADVERT'
}

export type PayuPayByLink = {
  __typename?: 'PayuPayByLink';
  brandImageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<PayUMethodStatus>;
  value?: Maybe<PaymentChannel>;
};

export enum ProfileScoreType {
  /** Valid additional info */
  ValidAdditional = 'VALID_ADDITIONAL',
  /** Valid basic info */
  ValidBasic = 'VALID_BASIC',
  /** Valid Credticheck */
  ValidCreditcheck = 'VALID_CREDITCHECK',
  /** Valid phone */
  ValidPhone = 'VALID_PHONE',
  /** Valid photo */
  ValidPhoto = 'VALID_PHOTO'
}

export type Project = {
  __typename?: 'Project';
  active?: Maybe<Scalars['Boolean']>;
  adverts?: Maybe<AdvertList>;
  dataJson?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gps?: Maybe<GpsPoint>;
  id?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  photoFilename?: Maybe<Scalars['String']>;
  stats?: Maybe<ProjectStats>;
  timeActivated?: Maybe<Scalars['DateTime']>;
  timeArchived?: Maybe<Scalars['DateTime']>;
  timeAttractiveExpiration?: Maybe<Scalars['DateTime']>;
  timeExpiration?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};


export type ProjectPhotoArgs = {
  filter: ImageFilter;
};

export enum ProjectAdvertAction {
  /** Deactivate */
  Deactivate = 'DEACTIVATE',
  /** Reactivate */
  Reactivate = 'REACTIVATE',
  /** Reserve */
  Reserve = 'RESERVE',
  /** Top */
  Top = 'TOP',
  /** Unreserve */
  Unreserve = 'UNRESERVE'
}

export type ProjectStats = {
  __typename?: 'ProjectStats';
  conversationCount?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['Int']>;
  statsDaily?: Maybe<Array<Maybe<AdvertStatsDaily>>>;
  topCount?: Maybe<Scalars['Float']>;
  visitCount?: Maybe<Scalars['Int']>;
};

export enum PromokitDeliveryType {
  /** No promokit */
  No = 'NO',
  /** Send by post */
  Post = 'POST',
  /** User will collect the promokit by himself */
  Visit = 'VISIT'
}

export type Query = {
  __typename?: 'Query';
  advert?: Maybe<Advert>;
  advertEvent?: Maybe<AdvertEvent>;
  advertEventList?: Maybe<AdvertEventList>;
  advertFilterOptions?: Maybe<AdvertFilterOptions>;
  advertMarkers?: Maybe<Array<Maybe<AdvertMarker>>>;
  advertParameters?: Maybe<Array<Maybe<AdvertParameter>>>;
  advertPriceRange?: Maybe<Array<Maybe<AdvertPriceRange>>>;
  advertUserstate?: Maybe<AdvertUserstate>;
  advertUserstateList?: Maybe<AdvertUserstateList>;
  /**
   * Get authenticated user
   *
   */
  authUser?: Maybe<User>;
  availablePaymentMethods?: Maybe<AvailablePaymentMethods>;
  availableServices?: Maybe<Array<Maybe<ServiceType>>>;
  brokerList?: Maybe<BrokerList>;
  calendarEntryList?: Maybe<CalendarEntryList>;
  calendarEventList?: Maybe<CalendarEventList>;
  checkEmail?: Maybe<Scalars['Boolean']>;
  contractGeneratorInfo?: Maybe<Scalars['String']>;
  conversation?: Maybe<Conversation>;
  conversationList?: Maybe<ConversationList>;
  customerAdverts?: Maybe<Array<Maybe<Advert>>>;
  czechRegions?: Maybe<Array<Maybe<Region>>>;
  documentList?: Maybe<DocumentList>;
  email?: Maybe<Scalars['String']>;
  /** Estimates adverts price */
  estimateAdvertPrice?: Maybe<AdvertPriceEstimation>;
  gallery?: Maybe<Gallery>;
  galleryList?: Maybe<Array<Maybe<Gallery>>>;
  getLastSearchCount?: Maybe<Scalars['Int']>;
  getUserIdByDevice?: Maybe<Scalars['Int']>;
  layoutStats?: Maybe<LayoutStats>;
  listAdverts?: Maybe<AdvertList>;
  listHrefLangs?: Maybe<Array<Maybe<HrefLang>>>;
  listRegions?: Maybe<Array<Maybe<Region>>>;
  listServices?: Maybe<ServiceList>;
  message?: Maybe<Message>;
  messageList?: Maybe<MessageList>;
  notification?: Maybe<Notification>;
  notificationList?: Maybe<NotificationList>;
  package?: Maybe<Package>;
  packageList?: Maybe<Array<Maybe<Package>>>;
  pageInfo?: Maybe<Page>;
  pageList?: Maybe<PageList>;
  payment?: Maybe<Payment>;
  paymentList?: Maybe<PaymentList>;
  paymentScheduledTotalPrice?: Maybe<Scalars['Int']>;
  paymentSettings?: Maybe<PaymentSettings>;
  payuOrderStatus?: Maybe<PayUResponseStatus>;
  pragueCounties?: Maybe<Array<Maybe<Region>>>;
  project?: Maybe<Project>;
  projectList?: Maybe<Array<Maybe<Project>>>;
  region?: Maybe<Region>;
  rentBankAccount?: Maybe<RentBankAccount>;
  rentBankAccountList?: Maybe<RentBankAccountList>;
  rentContract?: Maybe<RentContract>;
  rentCost?: Maybe<RentCost>;
  rentEquipment?: Maybe<RentEquipment>;
  rentNote?: Maybe<RentNote>;
  rentPayment?: Maybe<RentPayment>;
  rentPaymentList?: Maybe<RentPaymentList>;
  rentProperty?: Maybe<Advert>;
  rentPropertyList?: Maybe<RentPropertyList>;
  rentRepair?: Maybe<RentRepair>;
  rentService?: Maybe<RentService>;
  rentStats?: Maybe<RentStats>;
  rentTenant?: Maybe<RentTenant>;
  rentTenantList?: Maybe<RentTenantList>;
  /**
   * Returns server time (for time sync)
   *
   */
  serverTimestamp?: Maybe<Scalars['Int']>;
  service?: Maybe<Service>;
  shortUrl?: Maybe<Scalars['String']>;
  supportedBanks?: Maybe<Array<Maybe<SupportedBank>>>;
  tipList?: Maybe<TipList>;
  upcLink?: Maybe<FormattedParameter>;
  user?: Maybe<User>;
  voucherDiscount?: Maybe<Scalars['Int']>;
  watchdog?: Maybe<Watchdog>;
  watchdogAppResults?: Maybe<AdvertList>;
  watchdogList?: Maybe<WatchdogList>;
};


export type QueryAdvertArgs = {
  id: Scalars['ID'];
};


export type QueryAdvertEventArgs = {
  id: Scalars['ID'];
};


export type QueryAdvertEventListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAdvertMarkersArgs = {
  activationAction?: InputMaybe<Array<InputMaybe<ActivationAction>>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  balcony?: InputMaybe<Scalars['Boolean']>;
  boundary?: InputMaybe<Scalars['String']>;
  boundaryPoints?: InputMaybe<Array<InputMaybe<GpsPointInput>>>;
  broker?: InputMaybe<Scalars['Int']>;
  cellar?: InputMaybe<Scalars['Boolean']>;
  charity?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<Array<InputMaybe<Condition>>>;
  construction?: InputMaybe<Array<InputMaybe<Construction>>>;
  developer?: InputMaybe<Scalars['Boolean']>;
  disposition?: InputMaybe<Array<InputMaybe<Disposition>>>;
  equipped?: InputMaybe<Array<InputMaybe<Equipped>>>;
  estateType?: InputMaybe<Array<InputMaybe<EstateType>>>;
  garage?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  importType?: InputMaybe<AdvertImportType>;
  includeImports?: InputMaybe<Scalars['Boolean']>;
  landType?: InputMaybe<Array<InputMaybe<LandType>>>;
  lift?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationPoint?: InputMaybe<GpsPointInput>;
  locationRadius?: InputMaybe<Scalars['Int']>;
  loggia?: InputMaybe<Scalars['Boolean']>;
  newBuilding?: InputMaybe<Scalars['Boolean']>;
  offerType?: InputMaybe<Array<InputMaybe<OfferType>>>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResultOrder>;
  ownership?: InputMaybe<Array<InputMaybe<Ownership>>>;
  parking?: InputMaybe<Scalars['Boolean']>;
  priceFrom?: InputMaybe<Scalars['Int']>;
  priceTo?: InputMaybe<Scalars['Int']>;
  project?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  regionId?: InputMaybe<Scalars['ID']>;
  regionOsmId?: InputMaybe<Scalars['ID']>;
  roommate?: InputMaybe<Scalars['Boolean']>;
  surfaceFrom?: InputMaybe<Scalars['Int']>;
  surfaceTo?: InputMaybe<Scalars['Int']>;
  terrace?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAdvertParametersArgs = {
  locale: Locale;
  type: AdvertParameterName;
};


export type QueryAdvertPriceRangeArgs = {
  locale: Locale;
};


export type QueryAdvertUserstateArgs = {
  id: Scalars['ID'];
};


export type QueryAdvertUserstateListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<AdvertUserstateState>;
  user: Scalars['ID'];
};


export type QueryAvailablePaymentMethodsArgs = {
  advertId?: InputMaybe<Scalars['ID']>;
  locale: Locale;
};


export type QueryCalendarEntryListArgs = {
  conversation: Scalars['Int'];
  free?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  upcoming?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCalendarEventListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<CalendarEventRole>;
  upcoming?: InputMaybe<Scalars['Boolean']>;
  user: Scalars['Int'];
};


export type QueryCheckEmailArgs = {
  email: Scalars['String'];
};


export type QueryConversationArgs = {
  advertId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryConversationListArgs = {
  advertId?: InputMaybe<Scalars['ID']>;
  closed?: InputMaybe<Scalars['Boolean']>;
  fulltext?: InputMaybe<Scalars['String']>;
  important?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  premium?: InputMaybe<Scalars['Boolean']>;
  unread?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
  userRole?: InputMaybe<ConversationRole>;
};


export type QueryCzechRegionsArgs = {
  locale: Locale;
};


export type QueryDocumentListArgs = {
  entityId: Scalars['ID'];
  entityType: EntityType;
};


export type QueryEmailArgs = {
  ulid: Scalars['String'];
};


export type QueryEstimateAdvertPriceArgs = {
  address?: InputMaybe<Scalars['String']>;
  balcony?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<Condition>;
  construction?: InputMaybe<Construction>;
  disposition?: InputMaybe<Disposition>;
  equipped?: InputMaybe<Equipped>;
  estateType: EstateType;
  etage?: InputMaybe<Scalars['Int']>;
  gps?: InputMaybe<GpsPointInput>;
  houseNumber?: InputMaybe<Scalars['String']>;
  landType?: InputMaybe<LandType>;
  newBuilding?: InputMaybe<Scalars['Boolean']>;
  offerType: OfferType;
  ownership?: InputMaybe<Ownership>;
  penb?: InputMaybe<Penb>;
  roommate?: InputMaybe<Scalars['Boolean']>;
  street?: InputMaybe<Scalars['String']>;
  surface?: InputMaybe<Scalars['Int']>;
  surfaceLand?: InputMaybe<Scalars['Int']>;
  terrace?: InputMaybe<Scalars['Boolean']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type QueryGalleryArgs = {
  id: Scalars['ID'];
};


export type QueryGalleryListArgs = {
  propertyId: Scalars['ID'];
};


export type QueryGetLastSearchCountArgs = {
  boundary?: InputMaybe<Scalars['String']>;
  estateType?: InputMaybe<Array<InputMaybe<EstateType>>>;
  location?: InputMaybe<Scalars['String']>;
  offerType?: InputMaybe<Array<InputMaybe<OfferType>>>;
  timeActivatedFrom?: InputMaybe<Scalars['Int']>;
};


export type QueryGetUserIdByDeviceArgs = {
  deviceId: Scalars['String'];
};


export type QueryListAdvertsArgs = {
  activationAction?: InputMaybe<Array<InputMaybe<ActivationAction>>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  balcony?: InputMaybe<Scalars['Boolean']>;
  boundary?: InputMaybe<Scalars['String']>;
  boundaryPoints?: InputMaybe<Array<InputMaybe<GpsPointInput>>>;
  broker?: InputMaybe<Scalars['Int']>;
  cellar?: InputMaybe<Scalars['Boolean']>;
  charity?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<Array<InputMaybe<Condition>>>;
  construction?: InputMaybe<Array<InputMaybe<Construction>>>;
  developer?: InputMaybe<Scalars['Boolean']>;
  disposition?: InputMaybe<Array<InputMaybe<Disposition>>>;
  equipped?: InputMaybe<Array<InputMaybe<Equipped>>>;
  estateType?: InputMaybe<Array<InputMaybe<EstateType>>>;
  garage?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  importType?: InputMaybe<AdvertImportType>;
  includeImports?: InputMaybe<Scalars['Boolean']>;
  landType?: InputMaybe<Array<InputMaybe<LandType>>>;
  lift?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationPoint?: InputMaybe<GpsPointInput>;
  locationRadius?: InputMaybe<Scalars['Int']>;
  loggia?: InputMaybe<Scalars['Boolean']>;
  newBuilding?: InputMaybe<Scalars['Boolean']>;
  offerType?: InputMaybe<Array<InputMaybe<OfferType>>>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ResultOrder>;
  ownership?: InputMaybe<Array<InputMaybe<Ownership>>>;
  parking?: InputMaybe<Scalars['Boolean']>;
  priceFrom?: InputMaybe<Scalars['Int']>;
  priceTo?: InputMaybe<Scalars['Int']>;
  project?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  regionId?: InputMaybe<Scalars['ID']>;
  regionOsmId?: InputMaybe<Scalars['ID']>;
  roommate?: InputMaybe<Scalars['Boolean']>;
  surfaceFrom?: InputMaybe<Scalars['Int']>;
  surfaceTo?: InputMaybe<Scalars['Int']>;
  terrace?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};


export type QueryListHrefLangsArgs = {
  disposition?: InputMaybe<Disposition>;
  estateType: EstateType;
  offerType: OfferType;
  regionId?: InputMaybe<Scalars['ID']>;
};


export type QueryListRegionsArgs = {
  cached: Scalars['Boolean'];
  locale: Locale;
};


export type QueryListServicesArgs = {
  category?: InputMaybe<PackageCategory>;
  includeFree?: InputMaybe<Scalars['Boolean']>;
  packageUri?: InputMaybe<Scalars['String']>;
};


export type QueryMessageArgs = {
  id: Scalars['ID'];
};


export type QueryMessageListArgs = {
  conversation: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryNotificationListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<NotificationStatus>;
  user: Scalars['Int'];
};


export type QueryPackageArgs = {
  uri: Scalars['String'];
};


export type QueryPackageListArgs = {
  category?: InputMaybe<PackageCategory>;
  locale: Locale;
  recordId?: InputMaybe<Scalars['ID']>;
};


export type QueryPageInfoArgs = {
  locale: Locale;
  type?: InputMaybe<PageInfoType>;
};


export type QueryPageListArgs = {
  locale: Locale;
  suburi?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentListArgs = {
  type?: InputMaybe<PaymentListType>;
};


export type QueryPaymentScheduledTotalPriceArgs = {
  user: Scalars['Int'];
};


export type QueryPayuOrderStatusArgs = {
  recordId?: InputMaybe<Scalars['ID']>;
  type: PayuOrderType;
};


export type QueryProjectArgs = {
  id: Scalars['ID'];
};


export type QueryProjectListArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  authUser?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRegionArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Locale>;
};


export type QueryRentBankAccountArgs = {
  id: Scalars['ID'];
};


export type QueryRentContractArgs = {
  id: Scalars['ID'];
};


export type QueryRentCostArgs = {
  id: Scalars['ID'];
};


export type QueryRentEquipmentArgs = {
  id: Scalars['ID'];
};


export type QueryRentNoteArgs = {
  id: Scalars['ID'];
};


export type QueryRentPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryRentPaymentListArgs = {
  advertId?: InputMaybe<Scalars['ID']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  tenantId?: InputMaybe<Scalars['ID']>;
  timeFrom?: InputMaybe<Scalars['DateTime']>;
  timeTo?: InputMaybe<Scalars['DateTime']>;
};


export type QueryRentPropertyArgs = {
  id: Scalars['ID'];
};


export type QueryRentPropertyListArgs = {
  hasContract?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRentRepairArgs = {
  id: Scalars['ID'];
};


export type QueryRentServiceArgs = {
  id: Scalars['ID'];
};


export type QueryRentStatsArgs = {
  advertId?: InputMaybe<Scalars['ID']>;
  year: Scalars['Int'];
};


export type QueryRentTenantArgs = {
  id: Scalars['ID'];
};


export type QueryRentTenantListArgs = {
  advert?: InputMaybe<Scalars['Int']>;
  contractStatus?: InputMaybe<RentPlatformContractStatus>;
  hasContract?: InputMaybe<Scalars['Boolean']>;
  tenantStatus?: InputMaybe<RentPlatformTenantStatus>;
};


export type QueryServiceArgs = {
  id: Scalars['ID'];
};


export type QueryShortUrlArgs = {
  longUrl: Scalars['String'];
};


export type QueryTipListArgs = {
  user: Scalars['Int'];
};


export type QueryUpcLinkArgs = {
  advertId: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryVoucherDiscountArgs = {
  packages: Array<InputMaybe<SelectedPackageInput>>;
  voucherName: Scalars['String'];
};


export type QueryWatchdogArgs = {
  id: Scalars['ID'];
};


export type QueryWatchdogAppResultsArgs = {
  id: Scalars['ID'];
  interval?: InputMaybe<DateIntervalEnum>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  polygonFormatted?: InputMaybe<GpsPolygonInput>;
};


export type QueryWatchdogListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum Reconstruction {
  /** vše */
  All = 'ALL',
  /** jádro */
  Core = 'CORE',
  /** exteriér */
  External = 'EXTERNAL',
  /** interiér */
  Internal = 'INTERNAL',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export type Region = {
  __typename?: 'Region';
  boundary?: Maybe<Scalars['String']>;
  boundaryGeoJson?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<Region>>>;
  googleName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  idPath?: Maybe<Array<Maybe<Scalars['Int']>>>;
  locative?: Maybe<Scalars['String']>;
  lvl?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<Region>;
  simplifiedMapBoundary?: Maybe<Scalars['String']>;
  subType?: Maybe<RegionSubtype>;
  type?: Maybe<RegionType>;
  uri?: Maybe<Scalars['String']>;
};

export enum RegionSubtype {
  City = 'CITY',
  CityDistrict = 'CITY_DISTRICT',
  Country = 'COUNTRY',
  County = 'COUNTY',
  Municipality = 'MUNICIPALITY',
  Region = 'REGION',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export enum RegionType {
  Administrative = 'ADMINISTRATIVE',
  CityDistrict = 'CITY_DISTRICT',
  Geographic = 'GEOGRAPHIC',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export type RegistrationInput = {
  /** Broker checkbox */
  broker: Scalars['Boolean'];
  /** City name */
  city?: InputMaybe<Scalars['String']>;
  /** Company DIC */
  companyDic?: InputMaybe<Scalars['String']>;
  /** Company IC */
  companyIc?: InputMaybe<Scalars['Int']>;
  /** Company name */
  companyName?: InputMaybe<Scalars['String']>;
  /** Company type */
  companyType?: InputMaybe<UserGroupKeyType>;
  /** Company URL */
  companyUrl?: InputMaybe<Scalars['String']>;
  /** Conditions checkbox */
  conditions: Scalars['Boolean'];
  /** Email address */
  email: Scalars['String'];
  /** Facebook access token */
  facebookAccessToken?: InputMaybe<Scalars['String']>;
  /** First name */
  firstname: Scalars['String'];
  /** Google ID token */
  googleIdToken?: InputMaybe<Scalars['String']>;
  /** House number */
  houseNumber?: InputMaybe<Scalars['String']>;
  /** User is owner */
  isOwner?: InputMaybe<Scalars['Boolean']>;
  /** Last name */
  lastname: Scalars['String'];
  /** Locale */
  locale: Locale;
  /** Newsletter checkbox */
  newsletter?: InputMaybe<Scalars['Boolean']>;
  /** User password */
  password?: InputMaybe<Scalars['String']>;
  /** Phone number */
  phone: Scalars['String'];
  /** Phone verification code */
  phoneVerificationCode?: InputMaybe<Scalars['String']>;
  /** Phone verification record ID */
  phoneVerificationId?: InputMaybe<Scalars['Int']>;
  /** Street name */
  street?: InputMaybe<Scalars['String']>;
  /** Type */
  type: RegistrationType;
  /** Zip code */
  zip?: InputMaybe<Scalars['String']>;
};

export enum RegistrationType {
  /** Právnická osoba */
  Legal = 'LEGAL',
  /** Fyzická osoba */
  Private = 'PRIVATE'
}

export type RelatedAdvertParameters = {
  __typename?: 'RelatedAdvertParameters';
  advertType?: Maybe<AdvertType>;
  disposition?: Maybe<Array<Maybe<Disposition>>>;
  estateType?: Maybe<EstateType>;
  offerType?: Maybe<OfferType>;
  polygon?: Maybe<Scalars['String']>;
  priceMax?: Maybe<Scalars['Int']>;
  priceMin?: Maybe<Scalars['Int']>;
};

export type RentBankAccount = {
  __typename?: 'RentBankAccount';
  bankName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  number?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<Maybe<RentPayment>>>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type RentBankAccountList = {
  __typename?: 'RentBankAccountList';
  list?: Maybe<Array<Maybe<RentBankAccount>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RentContract = {
  __typename?: 'RentContract';
  advert?: Maybe<Advert>;
  cotenants?: Maybe<Array<Maybe<RentCotenant>>>;
  currency?: Maybe<Currency>;
  dayPaymentDue?: Maybe<Scalars['Int']>;
  deposit?: Maybe<Scalars['Float']>;
  documents?: Maybe<Array<Maybe<RentContractDocument>>>;
  id?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  priceServices?: Maybe<Scalars['Float']>;
  property?: Maybe<Advert>;
  rentPayments?: Maybe<Array<Maybe<RentPayment>>>;
  tenant?: Maybe<RentTenant>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeEnd?: Maybe<Scalars['DateTime']>;
  timeSigned?: Maybe<Scalars['DateTime']>;
  timeStart?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
};

export type RentContractDocument = {
  __typename?: 'RentContractDocument';
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  reference?: Maybe<RentContract>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
};

export type RentCost = {
  __typename?: 'RentCost';
  advert?: Maybe<Advert>;
  currency?: Maybe<Currency>;
  frequency?: Maybe<RentPlatformCostFrequency>;
  id?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeDue?: Maybe<Scalars['DateTime']>;
  timeFirstPayment?: Maybe<Scalars['DateTime']>;
  timePaid?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
};

export type RentCotenant = {
  __typename?: 'RentCotenant';
  dateBirth?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
};

export type RentCotenantInput = {
  dateBirth: Scalars['DateTime'];
  name: Scalars['String'];
};

export type RentDocument = {
  __typename?: 'RentDocument';
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  reference?: Maybe<Advert>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
};

export type RentEquipment = DocumentReference & GalleryReference & {
  __typename?: 'RentEquipment';
  advert?: Maybe<Advert>;
  currency?: Maybe<Currency>;
  discarded?: Maybe<Scalars['Boolean']>;
  documents?: Maybe<Array<Maybe<RentEquipmentDocument>>>;
  galleries?: Maybe<Array<Maybe<Gallery>>>;
  id?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeDiscarded?: Maybe<Scalars['DateTime']>;
  timePurchased?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
};

export type RentEquipmentDocument = {
  __typename?: 'RentEquipmentDocument';
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  reference?: Maybe<RentEquipment>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
};

export type RentNote = {
  __typename?: 'RentNote';
  advert?: Maybe<Advert>;
  id?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
};

export type RentPayment = {
  __typename?: 'RentPayment';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['ID']>;
  identifier?: Maybe<Scalars['String']>;
  method?: Maybe<RentPlatformPaymentMethod>;
  rentBankAccount?: Maybe<RentBankAccount>;
  rentContract?: Maybe<RentContract>;
  rentPaymentReminders?: Maybe<Array<Maybe<RentPaymentReminder>>>;
  status?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeDue?: Maybe<Scalars['DateTime']>;
  timePaid?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<RentPlatformPaymentType>;
};

export type RentPaymentList = {
  __typename?: 'RentPaymentList';
  list?: Maybe<Array<Maybe<RentPayment>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RentPaymentReminder = {
  __typename?: 'RentPaymentReminder';
  id?: Maybe<Scalars['ID']>;
  order?: Maybe<Scalars['Int']>;
  rentPayment?: Maybe<RentPayment>;
  text?: Maybe<Scalars['String']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
};

export enum RentPlatformAdvertStatus {
  /** Nepronajata */
  NotRented = 'NOT_RENTED',
  /** V přípravě */
  Preparation = 'PREPARATION',
  /** Připravena */
  Ready = 'READY',
  /** Pronajata */
  Rented = 'RENTED'
}

export enum RentPlatformContractStatus {
  /** Aktivní */
  Active = 'ACTIVE',
  /** Ukončena */
  Expired = 'EXPIRED'
}

export enum RentPlatformCostFrequency {
  /** Pololetně */
  HalfYear = 'HALF_YEAR',
  /** Měsíčně */
  Month = 'MONTH',
  /** Jednorázově */
  Once = 'ONCE',
  /** Čtvrtletně */
  QuarterYear = 'QUARTER_YEAR',
  /** Týdně */
  Week = 'WEEK',
  /** Ročně */
  Year = 'YEAR'
}

export enum RentPlatformPaymentMethod {
  /** Předem na účet */
  Bt = 'BT',
  /** Hotově */
  Cash = 'CASH'
}

export enum RentPlatformPaymentType {
  /** Záloha */
  Advance = 'ADVANCE',
  /** Kauce */
  Deposit = 'DEPOSIT',
  /** Jiné */
  Other = 'OTHER',
  /** Nájem */
  Rent = 'RENT',
  /** Za pokažení */
  Repair = 'REPAIR'
}

export enum RentPlatformRepairPayer {
  /** Majitel */
  Owner = 'OWNER',
  /** Nájemce */
  Tenant = 'TENANT'
}

export enum RentPlatformServicePayer {
  /** Majitel */
  Owner = 'OWNER',
  /** Nájemce */
  Tenant = 'TENANT'
}

export enum RentPlatformServiceType {
  /** Režie */
  Administration = 'ADMINISTRATION',
  /** Úklid budovy */
  Cleanup = 'CLEANUP',
  /** Elektřina */
  Electricity = 'ELECTRICITY',
  /** Odvoz odpadu */
  Garbage = 'GARBAGE',
  /** Plyn */
  Gas = 'GAS',
  /** Výtah */
  Lift = 'LIFT',
  /** Správa domu */
  Management = 'MANAGEMENT',
  /** Jiné */
  Other = 'OTHER',
  /** Vode */
  Water = 'WATER'
}

export enum RentPlatformTenantStatus {
  /** Platí se zpožděním */
  Delayed = 'DELAYED',
  /** Platí včas */
  OnTime = 'ON_TIME',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export type RentPropertyList = {
  __typename?: 'RentPropertyList';
  list?: Maybe<Array<Maybe<Advert>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RentRepair = DocumentReference & GalleryReference & {
  __typename?: 'RentRepair';
  advert?: Maybe<Advert>;
  currency?: Maybe<Currency>;
  documents?: Maybe<Array<Maybe<RentRepairDocument>>>;
  galleries?: Maybe<Array<Maybe<Gallery>>>;
  id?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  payer?: Maybe<RentPlatformRepairPayer>;
  price?: Maybe<Scalars['Float']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timePaid?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
};

export type RentRepairDocument = {
  __typename?: 'RentRepairDocument';
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  reference?: Maybe<RentRepair>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
};

export type RentService = {
  __typename?: 'RentService';
  advert?: Maybe<Advert>;
  id?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  payer?: Maybe<RentPlatformServicePayer>;
  status?: Maybe<Scalars['Float']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeSubscribed?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
  type?: Maybe<RentPlatformServiceType>;
};

export type RentStats = {
  __typename?: 'RentStats';
  loss?: Maybe<RentStatsLoss>;
  profit?: Maybe<RentStatsProfit>;
};

export type RentStatsLoss = {
  __typename?: 'RentStatsLoss';
  cost?: Maybe<Scalars['Int']>;
  equipment?: Maybe<Scalars['Int']>;
  repair?: Maybe<Scalars['Int']>;
};

export type RentStatsProfit = {
  __typename?: 'RentStatsProfit';
  rent?: Maybe<Scalars['Int']>;
};

export type RentTenant = {
  __typename?: 'RentTenant';
  birthNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  currentRentContract?: Maybe<RentContract>;
  dateBirth?: Maybe<Scalars['DateTime']>;
  documents?: Maybe<Array<Maybe<RentTenantDocument>>>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastname?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rentContracts?: Maybe<Array<Maybe<RentContract>>>;
  rentRepairs?: Maybe<Array<Maybe<RentRepair>>>;
  rentServices?: Maybe<Array<Maybe<RentService>>>;
  status?: Maybe<RentPlatformTenantStatus>;
  street?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  tenantCount?: Maybe<Scalars['Int']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  zip?: Maybe<Scalars['String']>;
};

export type RentTenantDocument = {
  __typename?: 'RentTenantDocument';
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  reference?: Maybe<RentTenant>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
};

export type RentTenantList = {
  __typename?: 'RentTenantList';
  list?: Maybe<Array<Maybe<RentTenant>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum ResultOrder {
  /** Nejlevnější */
  PriceAsc = 'PRICE_ASC',
  /** Nejdražší */
  PriceDesc = 'PRICE_DESC',
  /** Nejmenší */
  SurfaceAsc = 'SURFACE_ASC',
  /** Největší */
  SurfaceDesc = 'SURFACE_DESC',
  /** Nejnovější */
  TimeorderDesc = 'TIMEORDER_DESC'
}

export type SaveAdvertInput = {
  /**
   * Additional action to perform after saving changes
   *
   */
  action?: InputMaybe<ActivationAction>;
  /**
   * User defined address
   *
   */
  address?: InputMaybe<Scalars['String']>;
  /**
   * Age
   *
   */
  age?: InputMaybe<Age>;
  /**
   * Time of possible move in
   *
   */
  availableFrom?: InputMaybe<Scalars['DateTime']>;
  /**
   * Balcony
   *
   */
  balcony?: InputMaybe<Scalars['Boolean']>;
  /**
   * Location boundary in JSON
   *
   */
  boundary?: InputMaybe<Scalars['String']>;
  /**
   * ID of broker
   *
   */
  broker?: InputMaybe<Scalars['ID']>;
  /**
   * Cellar
   *
   */
  cellar?: InputMaybe<Scalars['Boolean']>;
  /**
   * Monthly charges
   *
   */
  charges?: InputMaybe<Scalars['Int']>;
  /**
   * Charity - Help Ukraine
   *
   */
  charity?: InputMaybe<Scalars['Boolean']>;
  /**
   * City name
   *
   */
  city?: InputMaybe<Scalars['String']>;
  /**
   * Developers code
   *
   */
  code?: InputMaybe<Scalars['String']>;
  /**
   * Condition
   *
   */
  condition?: InputMaybe<Condition>;
  /**
   * Construction type
   *
   */
  construction?: InputMaybe<Construction>;
  /**
   * Currency
   *
   */
  currency?: InputMaybe<Currency>;
  /**
   * Bail
   *
   */
  deposit?: InputMaybe<Scalars['Int']>;
  /**
   * Advert description
   *
   */
  description: Scalars['String'];
  /**
   * Advert description in english
   *
   */
  descriptionEnglish?: InputMaybe<Scalars['String']>;
  /**
   * Disposition
   *
   */
  disposition?: InputMaybe<Disposition>;
  /**
   * State of equipment
   *
   */
  equipped?: InputMaybe<Equipped>;
  /**
   * Type of estate
   *
   */
  estateType: EstateType;
  /**
   * Floor
   *
   */
  etage?: InputMaybe<Scalars['Int']>;
  /**
   * Execution
   *
   */
  execution?: InputMaybe<Execution>;
  /**
   * Floor
   *
   */
  floor?: InputMaybe<Floor>;
  /**
   * Front garden
   *
   */
  frontGarden?: InputMaybe<Scalars['Int']>;
  /**
   * Garage
   *
   */
  garage?: InputMaybe<Scalars['Boolean']>;
  /** GPS location */
  gps?: InputMaybe<GpsPointInput>;
  /**
   * Heating
   *
   */
  heating?: InputMaybe<Heating>;
  /**
   * House number
   *
   */
  houseNumber?: InputMaybe<Scalars['String']>;
  /**
   * Advert ID (optional - can be used to insert new advert)
   *
   */
  id?: InputMaybe<Scalars['ID']>;
  /**
   * Advert images containing array of uploaded images
   *
   */
  images?: InputMaybe<Array<InputMaybe<UploadedTmpImageInput>>>;
  /**
   * Land type
   *
   */
  landType?: InputMaybe<LandType>;
  /**
   * Lift
   *
   */
  lift?: InputMaybe<Scalars['Boolean']>;
  /**
   * Loggia
   *
   */
  loggia?: InputMaybe<Scalars['Boolean']>;
  /**
   * New building
   *
   */
  newBuilding?: InputMaybe<Scalars['Boolean']>;
  /**
   * Offer type
   *
   */
  offerType: OfferType;
  /**
   * Ownership
   *
   */
  ownership?: InputMaybe<Ownership>;
  /**
   * Parking
   *
   */
  parking?: InputMaybe<Scalars['Boolean']>;
  /**
   * PENB class
   *
   */
  penb?: InputMaybe<Penb>;
  /**
   * Price
   *
   */
  price?: InputMaybe<Scalars['Int']>;
  /**
   * ID of project for assignment
   *
   */
  project?: InputMaybe<Scalars['ID']>;
  /**
   * Reconstruction
   *
   */
  reconstruction?: InputMaybe<Reconstruction>;
  /**
   * Roommate
   *
   */
  roommate?: InputMaybe<Scalars['Boolean']>;
  /**
   * Sewage
   *
   */
  sewage?: InputMaybe<Sewage>;
  /**
   * Street name
   *
   */
  street?: InputMaybe<Scalars['String']>;
  /**
   * Surface
   *
   */
  surface?: InputMaybe<Scalars['Int']>;
  /**
   * Land surface
   *
   */
  surfaceLand?: InputMaybe<Scalars['Int']>;
  /**
   * Terrace
   *
   */
  terrace?: InputMaybe<Scalars['Boolean']>;
  /**
   * Total number of floors
   *
   */
  totalFloors?: InputMaybe<Scalars['Int']>;
  /**
   * Water
   *
   */
  water?: InputMaybe<Water>;
  /**
   * Zip code
   *
   */
  zip?: InputMaybe<Scalars['String']>;
};

export type SaveWatchdogInput = {
  /**
   * Desired advert type
   *
   */
  advertType: AdvertType;
  /**
   * Requires balcony
   *
   */
  balcony?: InputMaybe<Scalars['Boolean']>;
  /**
   * Requires cellar
   *
   */
  cellar?: InputMaybe<Scalars['Boolean']>;
  /**
   * Construction type
   *
   */
  construction?: InputMaybe<Array<InputMaybe<Construction>>>;
  /**
   * Phrase to search in description
   *
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Possible dispositions
   *
   */
  disposition?: InputMaybe<Array<InputMaybe<Disposition>>>;
  /**
   * Emailing frequency
   *
   */
  emailFrequency: WatchdogFrequency;
  /**
   * Equipped state
   *
   */
  equipped?: InputMaybe<Array<InputMaybe<Equipped>>>;
  /**
   * Possible estate types
   *
   */
  estateType?: InputMaybe<Array<InputMaybe<EstateType>>>;
  /**
   * Requires garage
   *
   */
  garage?: InputMaybe<Scalars['Boolean']>;
  /**
   * GeoJSON encoded geometry
   *
   */
  geometryGeoJson?: InputMaybe<Scalars['String']>;
  /**
   * Watchdog is specified using a map or a place-picker
   *
   */
  isSelectedOnMap?: InputMaybe<Scalars['Boolean']>;
  /**
   * Requires lift
   *
   */
  lift?: InputMaybe<Scalars['Boolean']>;
  /**
   * Requires loggia
   *
   */
  loggia?: InputMaybe<Scalars['Boolean']>;
  /**
   * Requires new building
   *
   */
  newBuilding?: InputMaybe<Scalars['Boolean']>;
  /**
   * Desired offer type
   *
   */
  offerType: OfferType;
  /**
   * Ownership
   *
   */
  ownership?: InputMaybe<Array<InputMaybe<Ownership>>>;
  /**
   * Requires parking
   *
   */
  parking?: InputMaybe<Scalars['Boolean']>;
  /**
   * Formatted polygon - mobile app
   *
   */
  polygonFormatted?: InputMaybe<GpsPolygonInput>;
  /**
   * JSON encoded polygons
   *
   */
  polygons?: InputMaybe<Scalars['GPSMultipolygon']>;
  /**
   * Maximal price
   *
   */
  priceMax?: InputMaybe<Scalars['Int']>;
  /**
   * Minimal price
   *
   */
  priceMin?: InputMaybe<Scalars['Int']>;
  /**
   * Desired region
   *
   */
  region?: InputMaybe<Scalars['ID']>;
  /**
   * User-selected address (mobile app)
   *
   */
  selectedAddress?: InputMaybe<Scalars['String']>;
  /**
   * Maximal surface
   *
   */
  surfaceMax?: InputMaybe<Scalars['Int']>;
  /**
   * Minimal surface
   *
   */
  surfaceMin?: InputMaybe<Scalars['Int']>;
  /**
   * Requires terrace
   *
   */
  terrace?: InputMaybe<Scalars['Boolean']>;
  /**
   * Watchdog ID
   *
   */
  watchdogId?: InputMaybe<Scalars['ID']>;
};

export type SelectedPackage = {
  __typename?: 'SelectedPackage';
  currency: Currency;
  form?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  promokit?: Maybe<SelectedPackagePromokit>;
  referenceId: Scalars['ID'];
  referenceType: OrderPackageReferenceType;
  /**
   * Formatted date: unix timestamp
   *
   */
  timeDue?: Maybe<Scalars['Int']>;
  /**
   * Time expiration
   *
   */
  timeExpiration?: Maybe<Scalars['DateTime']>;
  timeNow?: Maybe<Scalars['Boolean']>;
  /**
   * Formatted top dates: unix timestamp
   *
   */
  topTimes?: Maybe<Array<Maybe<Scalars['Int']>>>;
  uri?: Maybe<Scalars['String']>;
};

export type SelectedPackageInput = {
  currency: Currency;
  form?: InputMaybe<Scalars['String']>;
  price: Scalars['Int'];
  promokit?: InputMaybe<SelectedPackagePromokitInput>;
  referenceId: Scalars['ID'];
  referenceType: OrderPackageReferenceType;
  /**
   * Formatted date: unix timestamp
   *
   */
  timeDue?: InputMaybe<Scalars['Int']>;
  /**
   * Time expiration
   *
   */
  timeExpiration?: InputMaybe<Scalars['DateTime']>;
  timeNow?: InputMaybe<Scalars['Boolean']>;
  /**
   * Formatted top dates: unix timestamp
   *
   */
  topTimes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  uri?: InputMaybe<Scalars['String']>;
};

export type SelectedPackagePromokit = {
  __typename?: 'SelectedPackagePromokit';
  address?: Maybe<Scalars['String']>;
  delivery?: Maybe<PromokitDeliveryType>;
  name?: Maybe<Scalars['String']>;
};

export type SelectedPackagePromokitInput = {
  address?: InputMaybe<Scalars['String']>;
  delivery?: InputMaybe<PromokitDeliveryType>;
  name?: InputMaybe<Scalars['String']>;
};

export type Service = {
  __typename?: 'Service';
  creditcheck?: Maybe<Creditcheck>;
  id?: Maybe<Scalars['ID']>;
  locale?: Maybe<Locale>;
  timeProcessed?: Maybe<Scalars['DateTime']>;
  timeUserProcessed?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  titleShort?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ServiceLead = {
  __typename?: 'ServiceLead';
  /** Email */
  email?: Maybe<Scalars['String']>;
  /** Name */
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** Name */
  lastName?: Maybe<Scalars['String']>;
  /** Message */
  message?: Maybe<Scalars['String']>;
  /** Phone */
  phone?: Maybe<Scalars['String']>;
  /** Service type */
  service?: Maybe<ServiceType>;
};

export type ServiceLeadInput = {
  /** JSON encoded additional parameters */
  data?: InputMaybe<Scalars['String']>;
  /** Email */
  email: Scalars['String'];
  /** Name */
  firstName: Scalars['String'];
  /** Name */
  lastName: Scalars['String'];
  /** Marketing consent */
  marketingConsent?: InputMaybe<Scalars['Boolean']>;
  /** Message */
  message?: InputMaybe<Scalars['String']>;
  /** Phone */
  phone: Scalars['String'];
  /** Recaptcha token */
  recaptcha: Scalars['String'];
  /** Advert ID */
  service: ServiceType;
};

export type ServiceList = {
  __typename?: 'ServiceList';
  list?: Maybe<Array<Maybe<Service>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum ServiceType {
  /** Uživatelské účty */
  Accounts = 'ACCOUNTS',
  /** Bezrealitky nájem */
  BzrRent = 'BZR_RENT',
  /** Komfort */
  Comfort = 'COMFORT',
  /** Nájemní smlouva */
  ContractRent = 'CONTRACT_RENT',
  /** Kupní smlouva */
  ContractSale = 'CONTRACT_SALE',
  /** Ověření uživatele */
  Creditcheck = 'CREDITCHECK',
  /** Odhad ceny */
  Estimation = 'ESTIMATION',
  /** Expres */
  Express = 'EXPRESS',
  /** Průvodce */
  Guide = 'GUIDE',
  /** Hypotéka */
  Mortgage = 'MORTGAGE',
  /** Okay nábytek */
  Okay = 'OKAY',
  /** PENB */
  Penb = 'PENB',
  /** Fotografie */
  Photo = 'PHOTO',
  /** Virtuální prohlídka */
  Tour_360 = 'TOUR_360',
  /** Tvůj správce */
  TvujSpravce = 'TVUJ_SPRAVCE'
}

export enum Sewage {
  /** ČOV */
  Cov = 'COV',
  /** veřejná kanalizace */
  Public = 'PUBLIC',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export type Size = {
  __typename?: 'Size';
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

export type SupportedBank = {
  __typename?: 'SupportedBank';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type TeleSale = {
  __typename?: 'TeleSale';
  advert?: Maybe<Advert>;
  id?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<TeleSaleStatus>;
  subStatus?: Maybe<TeleSaleSubStatus>;
};

export enum TeleSaleStatus {
  /** Volat později */
  CallLater = 'CALL_LATER',
  /** Nedovoláno */
  Ignored = 'IGNORED',
  /** Nemá zájem */
  NotInterested = 'NOT_INTERESTED',
  /** Ostatní */
  Other = 'OTHER',
  /** K navolání */
  ToCall = 'TO_CALL',
  /** K předání kontaktu */
  ToContact = 'TO_CONTACT'
}

export enum TeleSaleSubStatus {
  /** Uzavřeno */
  Closed = 'CLOSED'
}

export type Tip = {
  __typename?: 'Tip';
  action?: Maybe<Scalars['String']>;
  advertId?: Maybe<Scalars['ID']>;
  category?: Maybe<TipCategory>;
  desc?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
  status?: Maybe<NotificationStatus>;
  title?: Maybe<Scalars['String']>;
};

export enum TipCategory {
  /** Doprovodné služby */
  Acompanying = 'ACOMPANYING',
  /** Popisek inzerátu */
  Description = 'DESCRIPTION',
  /** Expirace inzerátu */
  Expiration = 'EXPIRATION',
  /** Obrázky inzerátu */
  Image = 'IMAGE',
  /** Aktivace inzerátu */
  NotActivated = 'NOT_ACTIVATED',
  /** Ověření uživatele */
  Verified = 'VERIFIED',
  /** Upozornění pro uživatele */
  Warning = 'WARNING'
}

export type TipList = {
  __typename?: 'TipList';
  accompanying?: Maybe<Array<Maybe<Tip>>>;
  description?: Maybe<Array<Maybe<Tip>>>;
  expiration?: Maybe<Array<Maybe<Tip>>>;
  image?: Maybe<Array<Maybe<Tip>>>;
  notActivated?: Maybe<Array<Maybe<Tip>>>;
  verified?: Maybe<Array<Maybe<Tip>>>;
  warning?: Maybe<Array<Maybe<Tip>>>;
};

export type UploadTmpImageResponse = {
  __typename?: 'UploadTmpImageResponse';
  error?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type UploadedImageInput = {
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  main?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UploadedTmpImageInput = {
  error?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  main?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export type User = NotificationReference & {
  __typename?: 'User';
  /**
   * Check if an order for account activation has been created in the last 10 minutes.
   *
   */
  accountActivationPending?: Maybe<Scalars['Boolean']>;
  accountType?: Maybe<AccountType>;
  address?: Maybe<Scalars['String']>;
  advertToExpire?: Maybe<Advert>;
  adverts?: Maybe<AdvertList>;
  appSettingsMessage?: Maybe<Scalars['Boolean']>;
  appSettingsWatchdog?: Maybe<Scalars['Boolean']>;
  /** List of Brokers */
  brokers?: Maybe<Array<Maybe<Broker>>>;
  calendarToken?: Maybe<Scalars['String']>;
  calendarUrl?: Maybe<Scalars['String']>;
  canAddWatchdog?: Maybe<Scalars['Boolean']>;
  canShowProfile?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  creditcheck?: Maybe<Creditcheck>;
  education?: Maybe<Education>;
  email?: Maybe<Scalars['String']>;
  emailSettingsMessage?: Maybe<Scalars['Boolean']>;
  emailSettingsNews?: Maybe<Scalars['Boolean']>;
  emailSettingsWatchdog?: Maybe<Scalars['Boolean']>;
  facebook?: Maybe<Scalars['String']>;
  familyMembers?: Maybe<Scalars['Int']>;
  firstname?: Maybe<Scalars['String']>;
  formattedParameters?: Maybe<Array<Maybe<FormattedParameter>>>;
  formattedParametersPublic?: Maybe<Array<Maybe<FormattedParameter>>>;
  google?: Maybe<Scalars['String']>;
  hasAdditionalInfo?: Maybe<Scalars['Boolean']>;
  hasBasicInfo?: Maybe<Scalars['Boolean']>;
  hasFullAddress?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  /** Is Broker admin */
  isBrokerAdmin?: Maybe<Scalars['Boolean']>;
  isChecked?: Maybe<Scalars['Boolean']>;
  isDeveloper?: Maybe<Scalars['Boolean']>;
  isLegalEntity?: Maybe<Scalars['Boolean']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  lastAdvertVisits?: Maybe<Array<Maybe<AdvertUserVisit>>>;
  lastname?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  manualInvoices?: Maybe<Scalars['Boolean']>;
  menuCounts?: Maybe<MenuCounts>;
  newsletter?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  notificationSettings?: Maybe<UserNotificationSettings>;
  pets?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneCountry?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberInternationalFormatted?: Maybe<Scalars['String']>;
  phonePrefix?: Maybe<Scalars['Int']>;
  phoneValid?: Maybe<Scalars['Boolean']>;
  photo?: Maybe<Scalars['String']>;
  photoFilename?: Maybe<Scalars['String']>;
  photoFilenameBig?: Maybe<Scalars['String']>;
  photoFilenameSmall?: Maybe<Scalars['String']>;
  premium?: Maybe<Scalars['Boolean']>;
  profileScore?: Maybe<Array<Maybe<UserProfileScore>>>;
  profileScoreSum?: Maybe<Scalars['Int']>;
  profileSettings?: Maybe<UserProfileSettings>;
  projects?: Maybe<Array<Maybe<Project>>>;
  removed?: Maybe<Scalars['Boolean']>;
  showAd?: Maybe<Scalars['Boolean']>;
  smoker?: Maybe<Scalars['Boolean']>;
  street?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  timeAccountExpiration?: Maybe<Scalars['DateTime']>;
  timeAccountUpgraded?: Maybe<Scalars['DateTime']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timePasswordUpdated?: Maybe<Scalars['DateTime']>;
  tipInfo?: Maybe<UserTipInfo>;
  type?: Maybe<UserGroupType>;
  unreadMessagesCount?: Maybe<Scalars['Int']>;
  unreadWatchdogAdvertsCount?: Maybe<Scalars['Int']>;
  userGroup?: Maybe<UserGroup>;
  verified?: Maybe<Scalars['Boolean']>;
  walletBalance?: Maybe<Scalars['Int']>;
  walletCurrency?: Maybe<Currency>;
  watchdogCount?: Maybe<Scalars['String']>;
  watchdogFrequency?: Maybe<WatchdogFrequency>;
  workplace?: Maybe<Scalars['String']>;
  yearBorn?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
};


export type UserLastAdvertVisitsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  unique?: InputMaybe<Scalars['Boolean']>;
};


export type UserPhotoArgs = {
  filter: ImageFilter;
};

export type UserAresInfo = {
  __typename?: 'UserAresInfo';
  city?: Maybe<Scalars['String']>;
  dic?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  ic?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  street?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  active?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  dic?: Maybe<Scalars['String']>;
  ic?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  isPSN?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nameShow?: Maybe<Scalars['String']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeLastUpdate?: Maybe<Scalars['DateTime']>;
  type?: Maybe<UserGroupKeyType>;
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export enum UserGroupKeyType {
  /** Bytové družstvo */
  BytoveDruzstvo = 'BYTOVE_DRUZSTVO',
  /** Církev */
  Cirkev = 'CIRKEV',
  /** Developer */
  Developer = 'DEVELOPER',
  /** Nezisková organizace */
  NeziskovaOrganizace = 'NEZISKOVA_ORGANIZACE',
  /** Obce a města */
  ObceAMesta = 'OBCE_A_MESTA',
  /** Ostatní */
  Ostatni = 'OSTATNI',
  /** Společenství vlastníků jednotek */
  SpolecenstviClastnikuJednotek = 'SPOLECENSTVI_CLASTNIKU_JEDNOTEK',
  /** Správa nemovitostí */
  SpravaNemovitosti = 'SPRAVA_NEMOVITOSTI',
  /** Stavební společnost */
  StavebniSpolecnost = 'STAVEBNI_SPOLECNOST',
  /** Nevyplněno */
  Undefined = 'UNDEFINED'
}

export enum UserGroupType {
  /** Legal */
  Legal = 'LEGAL',
  /** Private */
  Private = 'PRIVATE'
}

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  emailMessage?: Maybe<Scalars['Boolean']>;
  emailWatchdog?: Maybe<Scalars['Boolean']>;
  pushMessage?: Maybe<Scalars['Boolean']>;
  pushWatchdog?: Maybe<Scalars['Boolean']>;
};

export type UserProfileScore = {
  __typename?: 'UserProfileScore';
  id?: Maybe<Scalars['ID']>;
  percent?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<ProfileScoreType>;
  value?: Maybe<Scalars['Boolean']>;
};

export type UserProfileSettings = {
  __typename?: 'UserProfileSettings';
  rentPlatformDashboardOrder?: Maybe<Array<Maybe<Scalars['String']>>>;
  rentPlatformReminderText?: Maybe<Scalars['String']>;
};

export enum UserReportType {
  /** Realitní makléř */
  Broker = 'BROKER',
  /** Špatně umístěný inzerát */
  Locality = 'LOCALITY',
  /** Jiná chyba */
  Other = 'OTHER'
}

export type UserTipInfo = {
  __typename?: 'UserTipInfo';
  hasActiveAdvertComfort?: Maybe<Scalars['Boolean']>;
  hasActiveAdvertComfortWithReactions?: Maybe<Scalars['Boolean']>;
  hasActiveAdvertRent?: Maybe<Scalars['Boolean']>;
  hasActiveAdvertSale?: Maybe<Scalars['Boolean']>;
  hasAdvert?: Maybe<Scalars['Boolean']>;
  hasAdvertService?: Maybe<Scalars['Boolean']>;
  hasAnyAdvertComfort?: Maybe<Scalars['Boolean']>;
  hasPragueRentAdvert?: Maybe<Scalars['Boolean']>;
  hasPragueSaleAdvert?: Maybe<Scalars['Boolean']>;
  hasRentPlatformAdvert?: Maybe<Scalars['Boolean']>;
  hasReservedAdvert?: Maybe<Scalars['Boolean']>;
  mortgageRate?: Maybe<Scalars['Float']>;
  respondedToRent?: Maybe<Scalars['Boolean']>;
  respondedToSale?: Maybe<Scalars['Boolean']>;
  shouldBuyRentContract?: Maybe<Scalars['Boolean']>;
  shouldBuySaleContract?: Maybe<Scalars['Boolean']>;
  shouldShowTvujSpravce?: Maybe<Scalars['Boolean']>;
  shouldShowTvujSpravce21days?: Maybe<Scalars['Boolean']>;
  shouldShowTvujSpravceInactive?: Maybe<Scalars['Boolean']>;
  shouldShowTvujSpravceWithReactions?: Maybe<Scalars['Boolean']>;
};

export enum WalletWithdrawAction {
  /** Zrušení žádosti o vrácení */
  Cancel = 'CANCEL',
  /** Žádost o vrácení */
  Withdraw = 'WITHDRAW'
}

export type Watchdog = {
  __typename?: 'Watchdog';
  adverts?: Maybe<AdvertList>;
  criteria?: Maybe<WatchdogCriteria>;
  emailFrequency?: Maybe<WatchdogFrequency>;
  geometryGeoJson?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  timeChecked?: Maybe<Scalars['DateTime']>;
  timeCreated?: Maybe<Scalars['DateTime']>;
  timeUpdated?: Maybe<Scalars['DateTime']>;
  unreadCount?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};


export type WatchdogAdvertsArgs = {
  interval?: InputMaybe<DateIntervalEnum>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type WatchdogQueryStringArgs = {
  locale: Locale;
};

/** Watchdog criteria interface used for advert search */
export type WatchdogCriteria = {
  /** Type of advert */
  advertType?: Maybe<AdvertType>;
  /** Identifies if balcony is required */
  balcony?: Maybe<Scalars['Boolean']>;
  /** Identifies if cellar is required */
  cellar?: Maybe<Scalars['Boolean']>;
  /** Construction type */
  construction?: Maybe<Array<Maybe<Construction>>>;
  /** Part of description that must be contained in search */
  description?: Maybe<Scalars['String']>;
  /** Array of dispositions to be searched for */
  disposition?: Maybe<Array<Maybe<Disposition>>>;
  /** State of equipment */
  equipped?: Maybe<Array<Maybe<Equipped>>>;
  /** Array of estate types used for search */
  estateType?: Maybe<Array<Maybe<EstateType>>>;
  /** Identifies if garage is required */
  garage?: Maybe<Scalars['Boolean']>;
  includeImports?: Maybe<Scalars['Boolean']>;
  isSelectedOnMap?: Maybe<Scalars['Boolean']>;
  /** Identifies if lift is required */
  lift?: Maybe<Scalars['Boolean']>;
  /** Identifies if loggia is required */
  loggia?: Maybe<Scalars['Boolean']>;
  /** Identifies if newBuilding is required */
  newBuilding?: Maybe<Scalars['Boolean']>;
  /** Offer type */
  offerType?: Maybe<OfferType>;
  /** Type of ownership */
  ownership?: Maybe<Array<Maybe<Ownership>>>;
  /** Identifies if parking is required */
  parking?: Maybe<Scalars['Boolean']>;
  /**
   * Single polygon used in geometry search
   * @deprecated Unified field processing
   */
  polygon?: Maybe<Scalars['String']>;
  /** Formatted polygon for mobile app */
  polygonFormatted?: Maybe<GpsPolygon>;
  /** Multipolygon used in geometry search (used if region is not set) */
  polygons?: Maybe<Scalars['GPSMultipolygon']>;
  /** Max price of advert */
  priceMax?: Maybe<Scalars['Int']>;
  /** Min price of advert */
  priceMin?: Maybe<Scalars['Int']>;
  /** Region used for search */
  region?: Maybe<Region>;
  roommate?: Maybe<Scalars['Boolean']>;
  selectedAddress?: Maybe<Scalars['String']>;
  /**
   * Square object to be used in geometry search
   * @deprecated Unified field processing
   */
  square?: Maybe<Scalars['String']>;
  /** Max surface of advert */
  surfaceMax?: Maybe<Scalars['Int']>;
  /** Min surface of advert */
  surfaceMin?: Maybe<Scalars['Int']>;
  /** Identifies if terrace is required */
  terrace?: Maybe<Scalars['Boolean']>;
};

export type WatchdogCriteriaOffer = WatchdogCriteria & {
  __typename?: 'WatchdogCriteriaOffer';
  advertType?: Maybe<AdvertType>;
  balcony?: Maybe<Scalars['Boolean']>;
  cellar?: Maybe<Scalars['Boolean']>;
  construction?: Maybe<Array<Maybe<Construction>>>;
  description?: Maybe<Scalars['String']>;
  disposition?: Maybe<Array<Maybe<Disposition>>>;
  equipped?: Maybe<Array<Maybe<Equipped>>>;
  estateType?: Maybe<Array<Maybe<EstateType>>>;
  garage?: Maybe<Scalars['Boolean']>;
  includeImports?: Maybe<Scalars['Boolean']>;
  isSelectedOnMap?: Maybe<Scalars['Boolean']>;
  lift?: Maybe<Scalars['Boolean']>;
  loggia?: Maybe<Scalars['Boolean']>;
  newBuilding?: Maybe<Scalars['Boolean']>;
  offerType?: Maybe<OfferType>;
  ownership?: Maybe<Array<Maybe<Ownership>>>;
  parking?: Maybe<Scalars['Boolean']>;
  polygon?: Maybe<Scalars['String']>;
  polygonFormatted?: Maybe<GpsPolygon>;
  polygons?: Maybe<Scalars['GPSMultipolygon']>;
  priceMax?: Maybe<Scalars['Int']>;
  priceMin?: Maybe<Scalars['Int']>;
  region?: Maybe<Region>;
  roommate?: Maybe<Scalars['Boolean']>;
  selectedAddress?: Maybe<Scalars['String']>;
  square?: Maybe<Scalars['String']>;
  surfaceMax?: Maybe<Scalars['Int']>;
  surfaceMin?: Maybe<Scalars['Int']>;
  terrace?: Maybe<Scalars['Boolean']>;
};

export enum WatchdogFrequency {
  /** Denně */
  Daily = 'DAILY',
  /** Ihned (jen premium uživatel) */
  Hourly = 'HOURLY',
  /** Neposílat */
  None = 'NONE',
  /** Týdně */
  Weekly = 'WEEKLY'
}

export type WatchdogList = {
  __typename?: 'WatchdogList';
  list?: Maybe<Array<Maybe<Watchdog>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum Water {
  /** veřejná síť */
  Public = 'PUBLIC',
  /** Nevyplněno */
  Undefined = 'UNDEFINED',
  /** studna */
  Well = 'WELL'
}



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> = LegacyStitchingResolver<TResult, TParent, TContext, TArgs> | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AccountType: AccountType;
  ActivationAction: ActivationAction;
  Advert: ResolverTypeWrapper<Advert>;
  AdvertBadge: ResolverTypeWrapper<AdvertBadge>;
  AdvertBadgeClass: AdvertBadgeClass;
  AdvertDeactivateInput: AdvertDeactivateInput;
  AdvertEvent: ResolverTypeWrapper<AdvertEvent>;
  AdvertEventList: ResolverTypeWrapper<AdvertEventList>;
  AdvertEventType: AdvertEventType;
  AdvertFilterOptions: ResolverTypeWrapper<AdvertFilterOptions>;
  AdvertImportType: AdvertImportType;
  AdvertLead: ResolverTypeWrapper<AdvertLead>;
  AdvertLeadInput: AdvertLeadInput;
  AdvertList: ResolverTypeWrapper<AdvertList>;
  AdvertMarker: ResolverTypeWrapper<AdvertMarker>;
  AdvertMessageData: ResolverTypeWrapper<AdvertMessageData>;
  AdvertMessageType: AdvertMessageType;
  AdvertParameter: ResolverTypeWrapper<AdvertParameter>;
  AdvertParameterName: AdvertParameterName;
  AdvertPriceEstimation: ResolverTypeWrapper<AdvertPriceEstimation>;
  AdvertPriceRange: ResolverTypeWrapper<AdvertPriceRange>;
  AdvertStatsDaily: ResolverTypeWrapper<AdvertStatsDaily>;
  AdvertType: AdvertType;
  AdvertUserVisit: ResolverTypeWrapper<AdvertUserVisit>;
  AdvertUserstate: ResolverTypeWrapper<AdvertUserstate>;
  AdvertUserstateList: ResolverTypeWrapper<AdvertUserstateList>;
  AdvertUserstateState: AdvertUserstateState;
  AdvertVideo: ResolverTypeWrapper<AdvertVideo>;
  AdvertVideoStatus: AdvertVideoStatus;
  Age: Age;
  ApplePaySession: ResolverTypeWrapper<ApplePaySession>;
  AuthData: ResolverTypeWrapper<AuthData>;
  AvailablePaymentMethods: ResolverTypeWrapper<AvailablePaymentMethods>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BreadcrumbItem: ResolverTypeWrapper<BreadcrumbItem>;
  Broker: ResolverTypeWrapper<Broker>;
  BrokerList: ResolverTypeWrapper<BrokerList>;
  CalendarEntry: ResolverTypeWrapper<CalendarEntry>;
  CalendarEntryList: ResolverTypeWrapper<CalendarEntryList>;
  CalendarEvent: ResolverTypeWrapper<CalendarEvent>;
  CalendarEventList: ResolverTypeWrapper<CalendarEventList>;
  CalendarEventRole: CalendarEventRole;
  Condition: Condition;
  Construction: Construction;
  Conversation: ResolverTypeWrapper<Conversation>;
  ConversationList: ResolverTypeWrapper<ConversationList>;
  ConversationLockedReason: ConversationLockedReason;
  ConversationRole: ConversationRole;
  ConversationStatus: ConversationStatus;
  CreditCheckAsServiceInput: CreditCheckAsServiceInput;
  CreditCheckForUserInput: CreditCheckForUserInput;
  Creditcheck: ResolverTypeWrapper<Creditcheck>;
  CreditcheckIdType: CreditcheckIdType;
  CreditcheckStatus: CreditcheckStatus;
  Currency: Currency;
  DateIntervalEnum: DateIntervalEnum;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  DeactivationAction: DeactivationAction;
  Disposition: Disposition;
  Document: ResolverTypeWrapper<Document>;
  DocumentList: ResolverTypeWrapper<DocumentList>;
  DocumentReference: ResolversTypes['Advert'] | ResolversTypes['RentEquipment'] | ResolversTypes['RentRepair'];
  EditUserInput: EditUserInput;
  Education: Education;
  EntityType: EntityType;
  Equipped: Equipped;
  EstateType: EstateType;
  Execution: Execution;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Floor: Floor;
  FormError: ResolverTypeWrapper<FormError>;
  FormattedBoolParameter: ResolverTypeWrapper<FormattedBoolParameter>;
  FormattedParameter: ResolverTypeWrapper<FormattedParameter>;
  GPSMultipolygon: ResolverTypeWrapper<Scalars['GPSMultipolygon']>;
  GPSPoint: ResolverTypeWrapper<GpsPoint>;
  GPSPointInput: GpsPointInput;
  GPSPolygon: ResolverTypeWrapper<GpsPolygon>;
  GPSPolygonInput: GpsPolygonInput;
  Gallery: ResolverTypeWrapper<Gallery>;
  GalleryReference: ResolversTypes['Advert'] | ResolversTypes['RentEquipment'] | ResolversTypes['RentRepair'];
  Heating: Heating;
  HouseType: HouseType;
  HrefLang: ResolverTypeWrapper<HrefLang>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Image: ResolverTypeWrapper<Image>;
  ImageAction: ImageAction;
  ImageFilter: ImageFilter;
  ImageUpload: ResolverTypeWrapper<Scalars['ImageUpload']>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  LandType: LandType;
  LayoutStats: ResolverTypeWrapper<LayoutStats>;
  Locale: Locale;
  MallPayResponse: ResolverTypeWrapper<MallPayResponse>;
  MallPayResponseState: MallPayResponseState;
  MarketingConsentOrigin: MarketingConsentOrigin;
  MenuCounts: ResolverTypeWrapper<MenuCounts>;
  Message: ResolverTypeWrapper<Message>;
  MessageInput: MessageInput;
  MessageList: ResolverTypeWrapper<MessageList>;
  MortgageData: ResolverTypeWrapper<MortgageData>;
  Mutation: ResolverTypeWrapper<{}>;
  Notification: ResolverTypeWrapper<Notification>;
  NotificationList: ResolverTypeWrapper<NotificationList>;
  NotificationReference: ResolversTypes['Advert'] | ResolversTypes['Conversation'] | ResolversTypes['Page'] | ResolversTypes['User'];
  NotificationService: NotificationService;
  NotificationStatus: NotificationStatus;
  NotificationType: NotificationType;
  OfferType: OfferType;
  OrderInput: OrderInput;
  OrderPackage: ResolverTypeWrapper<OrderPackage>;
  OrderPackageReferenceType: OrderPackageReferenceType;
  OrderResponse: ResolverTypeWrapper<OrderResponse>;
  Ownership: Ownership;
  PENB: Penb;
  Package: ResolverTypeWrapper<Package>;
  PackageCategory: PackageCategory;
  PackageFeatureIcon: PackageFeatureIcon;
  PackageKeyFeature: ResolverTypeWrapper<PackageKeyFeature>;
  PackageReferenceOption: ResolverTypeWrapper<PackageReferenceOption>;
  Page: ResolverTypeWrapper<Page>;
  PageInfoType: PageInfoType;
  PageList: ResolverTypeWrapper<PageList>;
  PayUMethodStatus: PayUMethodStatus;
  PayUOrderResponse: ResolverTypeWrapper<PayUOrderResponse>;
  PayUOrderResponseStatus: ResolverTypeWrapper<PayUOrderResponseStatus>;
  PayUOrderResponseStatusCode: PayUOrderResponseStatusCode;
  PayUResponse: ResolverTypeWrapper<PayUResponse>;
  PayUResponseStatus: ResolverTypeWrapper<PayUResponseStatus>;
  PayUResponseStatusCode: PayUResponseStatusCode;
  Payment: ResolverTypeWrapper<Payment>;
  PaymentChannel: PaymentChannel;
  PaymentIntention: PaymentIntention;
  PaymentList: ResolverTypeWrapper<PaymentList>;
  PaymentListType: PaymentListType;
  PaymentMethod: PaymentMethod;
  PaymentSettings: ResolverTypeWrapper<PaymentSettings>;
  PaymentStatus: PaymentStatus;
  PayuCardToken: ResolverTypeWrapper<PayuCardToken>;
  PayuOrderType: PayuOrderType;
  PayuPayByLink: ResolverTypeWrapper<PayuPayByLink>;
  ProfileScoreType: ProfileScoreType;
  Project: ResolverTypeWrapper<Project>;
  ProjectAdvertAction: ProjectAdvertAction;
  ProjectStats: ResolverTypeWrapper<ProjectStats>;
  PromokitDeliveryType: PromokitDeliveryType;
  Query: ResolverTypeWrapper<{}>;
  Reconstruction: Reconstruction;
  Region: ResolverTypeWrapper<Region>;
  RegionSubtype: RegionSubtype;
  RegionType: RegionType;
  RegistrationInput: RegistrationInput;
  RegistrationType: RegistrationType;
  RelatedAdvertParameters: ResolverTypeWrapper<RelatedAdvertParameters>;
  RentBankAccount: ResolverTypeWrapper<RentBankAccount>;
  RentBankAccountList: ResolverTypeWrapper<RentBankAccountList>;
  RentContract: ResolverTypeWrapper<RentContract>;
  RentContractDocument: ResolverTypeWrapper<RentContractDocument>;
  RentCost: ResolverTypeWrapper<RentCost>;
  RentCotenant: ResolverTypeWrapper<RentCotenant>;
  RentCotenantInput: RentCotenantInput;
  RentDocument: ResolverTypeWrapper<RentDocument>;
  RentEquipment: ResolverTypeWrapper<RentEquipment>;
  RentEquipmentDocument: ResolverTypeWrapper<RentEquipmentDocument>;
  RentNote: ResolverTypeWrapper<RentNote>;
  RentPayment: ResolverTypeWrapper<RentPayment>;
  RentPaymentList: ResolverTypeWrapper<RentPaymentList>;
  RentPaymentReminder: ResolverTypeWrapper<RentPaymentReminder>;
  RentPlatformAdvertStatus: RentPlatformAdvertStatus;
  RentPlatformContractStatus: RentPlatformContractStatus;
  RentPlatformCostFrequency: RentPlatformCostFrequency;
  RentPlatformPaymentMethod: RentPlatformPaymentMethod;
  RentPlatformPaymentType: RentPlatformPaymentType;
  RentPlatformRepairPayer: RentPlatformRepairPayer;
  RentPlatformServicePayer: RentPlatformServicePayer;
  RentPlatformServiceType: RentPlatformServiceType;
  RentPlatformTenantStatus: RentPlatformTenantStatus;
  RentPropertyList: ResolverTypeWrapper<RentPropertyList>;
  RentRepair: ResolverTypeWrapper<RentRepair>;
  RentRepairDocument: ResolverTypeWrapper<RentRepairDocument>;
  RentService: ResolverTypeWrapper<RentService>;
  RentStats: ResolverTypeWrapper<RentStats>;
  RentStatsLoss: ResolverTypeWrapper<RentStatsLoss>;
  RentStatsProfit: ResolverTypeWrapper<RentStatsProfit>;
  RentTenant: ResolverTypeWrapper<RentTenant>;
  RentTenantDocument: ResolverTypeWrapper<RentTenantDocument>;
  RentTenantList: ResolverTypeWrapper<RentTenantList>;
  ResultOrder: ResultOrder;
  SaveAdvertInput: SaveAdvertInput;
  SaveWatchdogInput: SaveWatchdogInput;
  SelectedPackage: ResolverTypeWrapper<SelectedPackage>;
  SelectedPackageInput: SelectedPackageInput;
  SelectedPackagePromokit: ResolverTypeWrapper<SelectedPackagePromokit>;
  SelectedPackagePromokitInput: SelectedPackagePromokitInput;
  Service: ResolverTypeWrapper<Service>;
  ServiceLead: ResolverTypeWrapper<ServiceLead>;
  ServiceLeadInput: ServiceLeadInput;
  ServiceList: ResolverTypeWrapper<ServiceList>;
  ServiceType: ServiceType;
  Sewage: Sewage;
  Size: ResolverTypeWrapper<Size>;
  String: ResolverTypeWrapper<Scalars['String']>;
  SupportedBank: ResolverTypeWrapper<SupportedBank>;
  TeleSale: ResolverTypeWrapper<TeleSale>;
  TeleSaleStatus: TeleSaleStatus;
  TeleSaleSubStatus: TeleSaleSubStatus;
  Tip: ResolverTypeWrapper<Tip>;
  TipCategory: TipCategory;
  TipList: ResolverTypeWrapper<TipList>;
  UploadTmpImageResponse: ResolverTypeWrapper<UploadTmpImageResponse>;
  UploadedImageInput: UploadedImageInput;
  UploadedTmpImageInput: UploadedTmpImageInput;
  User: ResolverTypeWrapper<User>;
  UserAresInfo: ResolverTypeWrapper<UserAresInfo>;
  UserGroup: ResolverTypeWrapper<UserGroup>;
  UserGroupKeyType: UserGroupKeyType;
  UserGroupType: UserGroupType;
  UserNotificationSettings: ResolverTypeWrapper<UserNotificationSettings>;
  UserProfileScore: ResolverTypeWrapper<UserProfileScore>;
  UserProfileSettings: ResolverTypeWrapper<UserProfileSettings>;
  UserReportType: UserReportType;
  UserTipInfo: ResolverTypeWrapper<UserTipInfo>;
  WalletWithdrawAction: WalletWithdrawAction;
  Watchdog: ResolverTypeWrapper<Watchdog>;
  WatchdogCriteria: ResolversTypes['WatchdogCriteriaOffer'];
  WatchdogCriteriaOffer: ResolverTypeWrapper<WatchdogCriteriaOffer>;
  WatchdogFrequency: WatchdogFrequency;
  WatchdogList: ResolverTypeWrapper<WatchdogList>;
  Water: Water;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Advert: Advert;
  AdvertBadge: AdvertBadge;
  AdvertDeactivateInput: AdvertDeactivateInput;
  AdvertEvent: AdvertEvent;
  AdvertEventList: AdvertEventList;
  AdvertFilterOptions: AdvertFilterOptions;
  AdvertLead: AdvertLead;
  AdvertLeadInput: AdvertLeadInput;
  AdvertList: AdvertList;
  AdvertMarker: AdvertMarker;
  AdvertMessageData: AdvertMessageData;
  AdvertParameter: AdvertParameter;
  AdvertPriceEstimation: AdvertPriceEstimation;
  AdvertPriceRange: AdvertPriceRange;
  AdvertStatsDaily: AdvertStatsDaily;
  AdvertUserVisit: AdvertUserVisit;
  AdvertUserstate: AdvertUserstate;
  AdvertUserstateList: AdvertUserstateList;
  AdvertVideo: AdvertVideo;
  ApplePaySession: ApplePaySession;
  AuthData: AuthData;
  AvailablePaymentMethods: AvailablePaymentMethods;
  Boolean: Scalars['Boolean'];
  BreadcrumbItem: BreadcrumbItem;
  Broker: Broker;
  BrokerList: BrokerList;
  CalendarEntry: CalendarEntry;
  CalendarEntryList: CalendarEntryList;
  CalendarEvent: CalendarEvent;
  CalendarEventList: CalendarEventList;
  Conversation: Conversation;
  ConversationList: ConversationList;
  CreditCheckAsServiceInput: CreditCheckAsServiceInput;
  CreditCheckForUserInput: CreditCheckForUserInput;
  Creditcheck: Creditcheck;
  DateTime: Scalars['DateTime'];
  Document: Document;
  DocumentList: DocumentList;
  DocumentReference: ResolversParentTypes['Advert'] | ResolversParentTypes['RentEquipment'] | ResolversParentTypes['RentRepair'];
  EditUserInput: EditUserInput;
  Float: Scalars['Float'];
  FormError: FormError;
  FormattedBoolParameter: FormattedBoolParameter;
  FormattedParameter: FormattedParameter;
  GPSMultipolygon: Scalars['GPSMultipolygon'];
  GPSPoint: GpsPoint;
  GPSPointInput: GpsPointInput;
  GPSPolygon: GpsPolygon;
  GPSPolygonInput: GpsPolygonInput;
  Gallery: Gallery;
  GalleryReference: ResolversParentTypes['Advert'] | ResolversParentTypes['RentEquipment'] | ResolversParentTypes['RentRepair'];
  HrefLang: HrefLang;
  ID: Scalars['ID'];
  Image: Image;
  ImageUpload: Scalars['ImageUpload'];
  Int: Scalars['Int'];
  LayoutStats: LayoutStats;
  MallPayResponse: MallPayResponse;
  MenuCounts: MenuCounts;
  Message: Message;
  MessageInput: MessageInput;
  MessageList: MessageList;
  MortgageData: MortgageData;
  Mutation: {};
  Notification: Notification;
  NotificationList: NotificationList;
  NotificationReference: ResolversParentTypes['Advert'] | ResolversParentTypes['Conversation'] | ResolversParentTypes['Page'] | ResolversParentTypes['User'];
  OrderInput: OrderInput;
  OrderPackage: OrderPackage;
  OrderResponse: OrderResponse;
  Package: Package;
  PackageKeyFeature: PackageKeyFeature;
  PackageReferenceOption: PackageReferenceOption;
  Page: Page;
  PageList: PageList;
  PayUOrderResponse: PayUOrderResponse;
  PayUOrderResponseStatus: PayUOrderResponseStatus;
  PayUResponse: PayUResponse;
  PayUResponseStatus: PayUResponseStatus;
  Payment: Payment;
  PaymentList: PaymentList;
  PaymentSettings: PaymentSettings;
  PayuCardToken: PayuCardToken;
  PayuPayByLink: PayuPayByLink;
  Project: Project;
  ProjectStats: ProjectStats;
  Query: {};
  Region: Region;
  RegistrationInput: RegistrationInput;
  RelatedAdvertParameters: RelatedAdvertParameters;
  RentBankAccount: RentBankAccount;
  RentBankAccountList: RentBankAccountList;
  RentContract: RentContract;
  RentContractDocument: RentContractDocument;
  RentCost: RentCost;
  RentCotenant: RentCotenant;
  RentCotenantInput: RentCotenantInput;
  RentDocument: RentDocument;
  RentEquipment: RentEquipment;
  RentEquipmentDocument: RentEquipmentDocument;
  RentNote: RentNote;
  RentPayment: RentPayment;
  RentPaymentList: RentPaymentList;
  RentPaymentReminder: RentPaymentReminder;
  RentPropertyList: RentPropertyList;
  RentRepair: RentRepair;
  RentRepairDocument: RentRepairDocument;
  RentService: RentService;
  RentStats: RentStats;
  RentStatsLoss: RentStatsLoss;
  RentStatsProfit: RentStatsProfit;
  RentTenant: RentTenant;
  RentTenantDocument: RentTenantDocument;
  RentTenantList: RentTenantList;
  SaveAdvertInput: SaveAdvertInput;
  SaveWatchdogInput: SaveWatchdogInput;
  SelectedPackage: SelectedPackage;
  SelectedPackageInput: SelectedPackageInput;
  SelectedPackagePromokit: SelectedPackagePromokit;
  SelectedPackagePromokitInput: SelectedPackagePromokitInput;
  Service: Service;
  ServiceLead: ServiceLead;
  ServiceLeadInput: ServiceLeadInput;
  ServiceList: ServiceList;
  Size: Size;
  String: Scalars['String'];
  SupportedBank: SupportedBank;
  TeleSale: TeleSale;
  Tip: Tip;
  TipList: TipList;
  UploadTmpImageResponse: UploadTmpImageResponse;
  UploadedImageInput: UploadedImageInput;
  UploadedTmpImageInput: UploadedTmpImageInput;
  User: User;
  UserAresInfo: UserAresInfo;
  UserGroup: UserGroup;
  UserNotificationSettings: UserNotificationSettings;
  UserProfileScore: UserProfileScore;
  UserProfileSettings: UserProfileSettings;
  UserTipInfo: UserTipInfo;
  Watchdog: Watchdog;
  WatchdogCriteria: ResolversParentTypes['WatchdogCriteriaOffer'];
  WatchdogCriteriaOffer: WatchdogCriteriaOffer;
  WatchdogList: WatchdogList;
};

export type AdvertResolvers<ContextType = any, ParentType extends ResolversParentTypes['Advert'] = ResolversParentTypes['Advert']> = {
  activationAction?: Resolver<Maybe<ResolversTypes['ActivationAction']>, ParentType, ContextType>;
  activationPending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<AdvertAddressArgs, 'locale'>>;
  addressInput?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressUserInput?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advertStatsDaily?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdvertStatsDaily']>>>, ParentType, ContextType>;
  advertUserstate?: Resolver<Maybe<ResolversTypes['AdvertUserstate']>, ParentType, ContextType, RequireFields<AdvertAdvertUserstateArgs, 'state'>>;
  age?: Resolver<Maybe<ResolversTypes['Age']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  availableFrom?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  badge?: Resolver<Maybe<ResolversTypes['AdvertBadge']>, ParentType, ContextType>;
  balcony?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['BreadcrumbItem']>>>, ParentType, ContextType, RequireFields<AdvertBreadcrumbsArgs, 'locale'>>;
  broker?: Resolver<Maybe<ResolversTypes['Broker']>, ParentType, ContextType>;
  calendarEntries?: Resolver<Maybe<ResolversTypes['CalendarEntryList']>, ParentType, ContextType, RequireFields<AdvertCalendarEntriesArgs, never>>;
  cellar?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  charges?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  charity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cityDistrict?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  condition?: Resolver<Maybe<ResolversTypes['Condition']>, ParentType, ContextType>;
  construction?: Resolver<Maybe<ResolversTypes['Construction']>, ParentType, ContextType>;
  conversations?: Resolver<Maybe<ResolversTypes['ConversationList']>, ParentType, ContextType, RequireFields<AdvertConversationsArgs, never>>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  currentRentContract?: Resolver<Maybe<ResolversTypes['RentContract']>, ParentType, ContextType>;
  dataJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daysActive?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deposit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descriptionEnglish?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disposition?: Resolver<Maybe<ResolversTypes['Disposition']>, ParentType, ContextType>;
  equipped?: Resolver<Maybe<ResolversTypes['Equipped']>, ParentType, ContextType>;
  estateType?: Resolver<Maybe<ResolversTypes['EstateType']>, ParentType, ContextType>;
  etage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  execution?: Resolver<Maybe<ResolversTypes['Execution']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fivesome?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  floor?: Resolver<Maybe<ResolversTypes['Floor']>, ParentType, ContextType>;
  formattedAds?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormattedParameter']>>>, ParentType, ContextType, RequireFields<AdvertFormattedAdsArgs, 'locale'>>;
  formattedBoolParameters?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormattedBoolParameter']>>>, ParentType, ContextType, RequireFields<AdvertFormattedBoolParametersArgs, 'locale'>>;
  formattedParameters?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormattedParameter']>>>, ParentType, ContextType, RequireFields<AdvertFormattedParametersArgs, 'locale'>>;
  frontGarden?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  galleries?: Resolver<Maybe<Array<Maybe<ResolversTypes['Gallery']>>>, ParentType, ContextType>;
  garage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  gps?: Resolver<Maybe<ResolversTypes['GPSPoint']>, ParentType, ContextType>;
  hasContractRent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heating?: Resolver<Maybe<ResolversTypes['Heating']>, ParentType, ContextType>;
  highlighted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  houseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  houseType?: Resolver<Maybe<ResolversTypes['HouseType']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  imageAltText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<AdvertImageAltTextArgs, 'locale'>>;
  incomplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEditable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isNew?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  landType?: Resolver<Maybe<ResolversTypes['LandType']>, ParentType, ContextType>;
  lastMonthHighlights?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdvertEvent']>>>, ParentType, ContextType>;
  lastUserVisit?: Resolver<Maybe<ResolversTypes['AdvertUserVisit']>, ParentType, ContextType>;
  lift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['Locale']>, ParentType, ContextType>;
  loggia?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mainImage?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  messageData?: Resolver<Maybe<ResolversTypes['AdvertMessageData']>, ParentType, ContextType, RequireFields<AdvertMessageDataArgs, 'locale'>>;
  mortgageData?: Resolver<Maybe<ResolversTypes['MortgageData']>, ParentType, ContextType, RequireFields<AdvertMortgageDataArgs, 'locale'>>;
  new?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  newBuilding?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  offerType?: Resolver<Maybe<ResolversTypes['OfferType']>, ParentType, ContextType>;
  ownership?: Resolver<Maybe<ResolversTypes['Ownership']>, ParentType, ContextType>;
  parking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  penb?: Resolver<Maybe<ResolversTypes['PENB']>, ParentType, ContextType>;
  poiData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  positionCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  positionCounty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  positionRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<AdvertPriceFormattedArgs, 'locale'>>;
  project?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  publicGalleries?: Resolver<Maybe<Array<Maybe<ResolversTypes['Gallery']>>>, ParentType, ContextType>;
  publicImages?: Resolver<Maybe<Array<Maybe<ResolversTypes['Image']>>>, ParentType, ContextType, RequireFields<AdvertPublicImagesArgs, never>>;
  reconstruction?: Resolver<Maybe<ResolversTypes['Reconstruction']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['Region']>, ParentType, ContextType>;
  regionTree?: Resolver<Maybe<Array<Maybe<ResolversTypes['Region']>>>, ParentType, ContextType, RequireFields<AdvertRegionTreeArgs, 'locale'>>;
  relatedAdvertParameters?: Resolver<Maybe<ResolversTypes['RelatedAdvertParameters']>, ParentType, ContextType>;
  relatedAdverts?: Resolver<Maybe<ResolversTypes['AdvertList']>, ParentType, ContextType, RequireFields<AdvertRelatedAdvertsArgs, never>>;
  rentContracts?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentContract']>>>, ParentType, ContextType>;
  rentCosts?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentCost']>>>, ParentType, ContextType>;
  rentDocuments?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentDocument']>>>, ParentType, ContextType>;
  rentEquipments?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentEquipment']>>>, ParentType, ContextType>;
  rentNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentNote']>>>, ParentType, ContextType>;
  rentPlatform?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rentPlatformOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentPlatformStatus?: Resolver<Maybe<ResolversTypes['RentPlatformAdvertStatus']>, ParentType, ContextType>;
  rentPlatformTimeExpiration?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rentRepairs?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentRepair']>>>, ParentType, ContextType>;
  rentServices?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentService']>>>, ParentType, ContextType>;
  reserved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reservedUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  roommate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sewage?: Resolver<Maybe<ResolversTypes['Sewage']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  surface?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  surfaceLand?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType, RequireFields<AdvertTagsArgs, 'locale'>>;
  terrace?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  threesome?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  timeActivated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeDeactivated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeExpiration?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeOrder?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  topHistoryLog?: Resolver<Maybe<Array<Maybe<ResolversTypes['DateTime']>>>, ParentType, ContextType>;
  totalFloors?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tour360?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['AdvertImportType']>, ParentType, ContextType>;
  uri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  videos?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdvertVideo']>>>, ParentType, ContextType>;
  visitCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  water?: Resolver<Maybe<ResolversTypes['Water']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertBadgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertBadge'] = ResolversParentTypes['AdvertBadge']> = {
  class?: Resolver<Maybe<ResolversTypes['AdvertBadgeClass']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertEvent'] = ResolversParentTypes['AdvertEvent']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  orderPackage?: Resolver<Maybe<ResolversTypes['OrderPackage']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeDue?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeProcessed?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['AdvertEventType']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertEventListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertEventList'] = ResolversParentTypes['AdvertEventList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdvertEvent']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertFilterOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertFilterOptions'] = ResolversParentTypes['AdvertFilterOptions']> = {
  estateType?: Resolver<Maybe<Array<Maybe<ResolversTypes['EstateType']>>>, ParentType, ContextType>;
  offerType?: Resolver<Maybe<Array<Maybe<ResolversTypes['OfferType']>>>, ParentType, ContextType>;
  visible?: Resolver<Maybe<Array<Maybe<ResolversTypes['Boolean']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertLeadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertLead'] = ResolversParentTypes['AdvertLead']> = {
  advertId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertList'] = ResolversParentTypes['AdvertList']> = {
  envelopePolygon?: Resolver<Maybe<ResolversTypes['GPSPolygon']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Advert']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertMarkerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertMarker'] = ResolversParentTypes['AdvertMarker']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  charges?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  deposit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  disposition?: Resolver<Maybe<ResolversTypes['Disposition']>, ParentType, ContextType>;
  estateType?: Resolver<Maybe<ResolversTypes['EstateType']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  gps?: Resolver<Maybe<ResolversTypes['GPSPoint']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  mainImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offerType?: Resolver<Maybe<ResolversTypes['OfferType']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roommate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  surface?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  surfaceLand?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeOrder?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['AdvertImportType']>, ParentType, ContextType>;
  uri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertMessageDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertMessageData'] = ResolversParentTypes['AdvertMessageData']> = {
  messageType?: Resolver<Maybe<ResolversTypes['AdvertMessageType']>, ParentType, ContextType>;
  requireLogin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertParameterResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertParameter'] = ResolversParentTypes['AdvertParameter']> = {
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertPriceEstimationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertPriceEstimation'] = ResolversParentTypes['AdvertPriceEstimation']> = {
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceMax?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceMin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  relatedAdverts?: Resolver<Maybe<ResolversTypes['AdvertList']>, ParentType, ContextType>;
  relatedAdvertsExpired?: Resolver<Maybe<ResolversTypes['AdvertList']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertPriceRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertPriceRange'] = ResolversParentTypes['AdvertPriceRange']> = {
  estateType?: Resolver<Maybe<ResolversTypes['EstateType']>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offerType?: Resolver<Maybe<ResolversTypes['OfferType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertStatsDailyResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertStatsDaily'] = ResolversParentTypes['AdvertStatsDaily']> = {
  contactCounter?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  day?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  viewCounter?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertUserVisitResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertUserVisit'] = ResolversParentTypes['AdvertUserVisit']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertUserstateResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertUserstate'] = ResolversParentTypes['AdvertUserstate']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['AdvertUserstateState']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertUserstateListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertUserstateList'] = ResolversParentTypes['AdvertUserstateList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdvertUserstate']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvertVideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvertVideo'] = ResolversParentTypes['AdvertVideo']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['AdvertVideoStatus']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplePaySessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplePaySession'] = ResolversParentTypes['ApplePaySession']> = {
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  epochTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantSessionIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonce?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthData'] = ResolversParentTypes['AuthData']> = {
  accountType?: Resolver<Maybe<ResolversTypes['AccountType']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormError']>>>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailablePaymentMethodsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailablePaymentMethods'] = ResolversParentTypes['AvailablePaymentMethods']> = {
  cardTokens?: Resolver<Maybe<Array<Maybe<ResolversTypes['PayuCardToken']>>>, ParentType, ContextType>;
  merchantId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  payByLinks?: Resolver<Maybe<Array<Maybe<ResolversTypes['PayuPayByLink']>>>, ParentType, ContextType>;
  posIdRest?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PayUResponseStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BreadcrumbItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['BreadcrumbItem'] = ResolversParentTypes['BreadcrumbItem']> = {
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrokerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Broker'] = ResolversParentTypes['Broker']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<BrokerPhotoArgs, 'filter'>>;
  photoFilename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrokerListResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerList'] = ResolversParentTypes['BrokerList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Broker']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CalendarEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CalendarEntry'] = ResolversParentTypes['CalendarEntry']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  calendarEvent?: Resolver<Maybe<ResolversTypes['CalendarEvent']>, ParentType, ContextType>;
  free?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  timeDue?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CalendarEntryListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CalendarEntryList'] = ResolversParentTypes['CalendarEntryList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['CalendarEntry']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CalendarEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['CalendarEvent'] = ResolversParentTypes['CalendarEvent']> = {
  calendarEntry?: Resolver<Maybe<ResolversTypes['CalendarEntry']>, ParentType, ContextType>;
  confirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  conversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  visitor?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CalendarEventListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CalendarEventList'] = ResolversParentTypes['CalendarEventList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['CalendarEvent']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConversationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Conversation'] = ResolversParentTypes['Conversation']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  calendarEvent?: Resolver<Maybe<ResolversTypes['CalendarEvent']>, ParentType, ContextType>;
  calendarShared?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  customer?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  customerNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerStatus?: Resolver<Maybe<ResolversTypes['ConversationStatus']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  important?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  importantCustomer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  importantSeller?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lockedReason?: Resolver<Maybe<ResolversTypes['ConversationLockedReason']>, ParentType, ContextType>;
  messages?: Resolver<Maybe<ResolversTypes['MessageList']>, ParentType, ContextType, RequireFields<ConversationMessagesArgs, never>>;
  ownerAnswered?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  seller?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  sellerNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerStatus?: Resolver<Maybe<ResolversTypes['ConversationStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConversationListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConversationList'] = ResolversParentTypes['ConversationList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Conversation']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditcheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['Creditcheck'] = ResolversParentTypes['Creditcheck']> = {
  addressMatch?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  bankruptcy?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  debtSp?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  debtVzp?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  dph?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  executionEvidence?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  executionSkov?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  hledaniPcr?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  idValid?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  insolvencyRegister?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['Locale']>, ParentType, ContextType>;
  reportUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestBirthNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestDateBirth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestHouseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestIdNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestIdType?: Resolver<Maybe<ResolversTypes['CreditcheckIdType']>, ParentType, ContextType>;
  requestLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestLocale?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  requestStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestStreetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rnDb?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  skUrad?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  vzpDebtors?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  zpmvcrDebtors?: Resolver<Maybe<ResolversTypes['CreditcheckStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']> = {
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['DocumentReference']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentListResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentList'] = ResolversParentTypes['DocumentList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentReferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentReference'] = ResolversParentTypes['DocumentReference']> = {
  __resolveType: TypeResolveFn<'Advert' | 'RentEquipment' | 'RentRepair', ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type FormErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormError'] = ResolversParentTypes['FormError']> = {
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormattedBoolParameterResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormattedBoolParameter'] = ResolversParentTypes['FormattedBoolParameter']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormattedParameterResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormattedParameter'] = ResolversParentTypes['FormattedParameter']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackPixelSrc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueHref?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface GpsMultipolygonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GPSMultipolygon'], any> {
  name: 'GPSMultipolygon';
}

export type GpsPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['GPSPoint'] = ResolversParentTypes['GPSPoint']> = {
  lat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lng?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GpsPolygonResolvers<ContextType = any, ParentType extends ResolversParentTypes['GPSPolygon'] = ResolversParentTypes['GPSPolygon']> = {
  points?: Resolver<Maybe<Array<Maybe<ResolversTypes['GPSPoint']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GalleryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Gallery'] = ResolversParentTypes['Gallery']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['Image']>>>, ParentType, ContextType>;
  mainImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<GalleryMainImageUrlArgs, 'filter'>>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  public?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['GalleryReference']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GalleryReferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['GalleryReference'] = ResolversParentTypes['GalleryReference']> = {
  __resolveType: TypeResolveFn<'Advert' | 'RentEquipment' | 'RentRepair', ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type HrefLangResolvers<ContextType = any, ParentType extends ResolversParentTypes['HrefLang'] = ResolversParentTypes['HrefLang']> = {
  locale?: Resolver<Maybe<ResolversTypes['Locale']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Image'] = ResolversParentTypes['Image']> = {
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  main?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['Gallery']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Size']>, ParentType, ContextType, RequireFields<ImageSizeArgs, 'filter'>>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<ImageUrlArgs, 'filter'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ImageUploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ImageUpload'], any> {
  name: 'ImageUpload';
}

export type LayoutStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayoutStats'] = ResolversParentTypes['LayoutStats']> = {
  countActive?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  countRealizedTrades?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceOfRealizedTrades?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MallPayResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MallPayResponse'] = ResolversParentTypes['MallPayResponse']> = {
  gatewayRedirectUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['MallPayResponseState']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MenuCountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MenuCounts'] = ResolversParentTypes['MenuCounts']> = {
  conversations?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  favourites?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notifications?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  services?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  watchdogs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  author?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  conversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeRead?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  unread?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageListResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageList'] = ResolversParentTypes['MessageList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Message']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MortgageDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MortgageData'] = ResolversParentTypes['MortgageData']> = {
  loan?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  paymentString?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  years?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  activateAdvert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType, RequireFields<MutationActivateAdvertArgs, 'advertId'>>;
  addCalendarEntry?: Resolver<Maybe<ResolversTypes['CalendarEntry']>, ParentType, ContextType, RequireFields<MutationAddCalendarEntryArgs, 'advert' | 'timeDue'>>;
  addCalendarEvent?: Resolver<Maybe<ResolversTypes['CalendarEvent']>, ParentType, ContextType, RequireFields<MutationAddCalendarEventArgs, 'calendarEntry'>>;
  addPaidOrder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAddPaidOrderArgs, 'packages'>>;
  applePayValidateMerchant?: Resolver<Maybe<ResolversTypes['ApplePaySession']>, ParentType, ContextType, RequireFields<MutationApplePayValidateMerchantArgs, 'hostname' | 'merchantId' | 'merchantName' | 'validationUrl'>>;
  aresInfo?: Resolver<Maybe<ResolversTypes['UserAresInfo']>, ParentType, ContextType, RequireFields<MutationAresInfoArgs, 'ic'>>;
  askForCreditCheck?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAskForCreditCheckArgs, 'user'>>;
  changeImage?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType, RequireFields<MutationChangeImageArgs, 'action' | 'id'>>;
  changePassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationChangePasswordArgs, 'email' | 'hash' | 'password1' | 'password2'>>;
  changePasswordEmail?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  changeTmpImage?: Resolver<Maybe<ResolversTypes['UploadTmpImageResponse']>, ParentType, ContextType, RequireFields<MutationChangeTmpImageArgs, 'action' | 'filter' | 'url'>>;
  checkDiscount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCheckDiscountArgs, 'code' | 'firstname' | 'lastname' | 'package'>>;
  closeAllConversations?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationCloseAllConversationsArgs, 'role'>>;
  closeConversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationCloseConversationArgs, 'conversationId'>>;
  confirmCalendarEvent?: Resolver<Maybe<ResolversTypes['CalendarEvent']>, ParentType, ContextType, RequireFields<MutationConfirmCalendarEventArgs, 'id'>>;
  connectBankAccount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationConnectBankAccountArgs, 'bankCode'>>;
  connectFacebook?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationConnectFacebookArgs, 'facebookAccessToken'>>;
  connectGoogle?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationConnectGoogleArgs, 'googleIdToken'>>;
  createOrder?: Resolver<Maybe<ResolversTypes['OrderResponse']>, ParentType, ContextType, RequireFields<MutationCreateOrderArgs, 'orderInput'>>;
  creditCheckAsService?: Resolver<Maybe<ResolversTypes['Service']>, ParentType, ContextType, RequireFields<MutationCreditCheckAsServiceArgs, 'creditCheckAsService'>>;
  creditCheckForUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationCreditCheckForUserArgs, 'creditCheckForUser'>>;
  deactivateAdvert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType, RequireFields<MutationDeactivateAdvertArgs, 'advertDeactivate'>>;
  deactivateProject?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<MutationDeactivateProjectArgs, 'id'>>;
  deleteAdvertVideo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteAdvertVideoArgs, 'id'>>;
  deleteAllConversations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  deleteBroker?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteBrokerArgs, 'id'>>;
  deleteBrokerPhoto?: Resolver<Maybe<ResolversTypes['Broker']>, ParentType, ContextType, RequireFields<MutationDeleteBrokerPhotoArgs, 'brokerId'>>;
  deleteConversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationDeleteConversationArgs, 'conversationId'>>;
  deleteDocument?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteDocumentArgs, 'id'>>;
  deleteGallery?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<MutationDeleteGalleryArgs, 'id'>>;
  deleteNotification?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteNotificationArgs, never>>;
  deleteProjectPhoto?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<MutationDeleteProjectPhotoArgs, 'projectId'>>;
  deleteRentBankAccount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteRentBankAccountArgs, 'id'>>;
  deleteRentCost?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteRentCostArgs, 'id'>>;
  deleteRentEquipment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteRentEquipmentArgs, 'id'>>;
  deleteRentNote?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteRentNoteArgs, 'id'>>;
  deleteRentPayment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteRentPaymentArgs, 'id'>>;
  deleteRentRepair?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteRentRepairArgs, 'id'>>;
  deleteRentService?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteRentServiceArgs, 'id'>>;
  deleteRentTenant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteRentTenantArgs, 'id'>>;
  deleteUserPhoto?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  deleteWatchdog?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteWatchdogArgs, 'id'>>;
  duplicateAdvert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType, RequireFields<MutationDuplicateAdvertArgs, 'id'>>;
  editBroker?: Resolver<Maybe<ResolversTypes['Broker']>, ParentType, ContextType, RequireFields<MutationEditBrokerArgs, 'email' | 'firstName' | 'lastName' | 'phone'>>;
  editGallery?: Resolver<Maybe<ResolversTypes['Gallery']>, ParentType, ContextType, RequireFields<MutationEditGalleryArgs, 'advertId' | 'public' | 'title'>>;
  editRentBankAccount?: Resolver<Maybe<ResolversTypes['RentBankAccount']>, ParentType, ContextType, RequireFields<MutationEditRentBankAccountArgs, 'bankName' | 'number'>>;
  editRentContract?: Resolver<Maybe<ResolversTypes['RentContract']>, ParentType, ContextType, RequireFields<MutationEditRentContractArgs, 'currency' | 'dayPaymentDue' | 'deposit' | 'number' | 'price' | 'property' | 'tenant' | 'timeSigned' | 'timeStart'>>;
  editRentCost?: Resolver<Maybe<ResolversTypes['RentCost']>, ParentType, ContextType, RequireFields<MutationEditRentCostArgs, 'currency' | 'frequency' | 'price' | 'title'>>;
  editRentEquipment?: Resolver<Maybe<ResolversTypes['RentEquipment']>, ParentType, ContextType, RequireFields<MutationEditRentEquipmentArgs, 'currency' | 'discarded' | 'price' | 'title'>>;
  editRentNote?: Resolver<Maybe<ResolversTypes['RentNote']>, ParentType, ContextType, RequireFields<MutationEditRentNoteArgs, 'text' | 'title'>>;
  editRentPayment?: Resolver<Maybe<ResolversTypes['RentPayment']>, ParentType, ContextType, RequireFields<MutationEditRentPaymentArgs, 'amount' | 'currency' | 'identifier' | 'method' | 'propertyId' | 'tenantId' | 'title' | 'type'>>;
  editRentRepair?: Resolver<Maybe<ResolversTypes['RentRepair']>, ParentType, ContextType, RequireFields<MutationEditRentRepairArgs, 'currency' | 'price' | 'title'>>;
  editRentService?: Resolver<Maybe<ResolversTypes['RentService']>, ParentType, ContextType, RequireFields<MutationEditRentServiceArgs, 'status' | 'type'>>;
  editRentTenant?: Resolver<Maybe<ResolversTypes['RentTenant']>, ParentType, ContextType, RequireFields<MutationEditRentTenantArgs, 'city' | 'firstname' | 'lastname' | 'street' | 'streetNumber' | 'zip'>>;
  editUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationEditUserArgs, 'editUser'>>;
  endRentContract?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationEndRentContractArgs, 'contractId'>>;
  extendRentContract?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationExtendRentContractArgs, 'contractId' | 'timeEnd'>>;
  forgotPasswordEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationForgotPasswordEmailArgs, 'email' | 'recaptcha'>>;
  freeActivateProperty?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationFreeActivatePropertyArgs, 'advertId'>>;
  generateCalendarToken?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationGenerateCalendarTokenArgs, 'userId'>>;
  logAdvertVisit?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType, RequireFields<MutationLogAdvertVisitArgs, 'id'>>;
  markImportantConversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationMarkImportantConversationArgs, 'conversationId' | 'important'>>;
  markReadConversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationMarkReadConversationArgs, 'conversationId'>>;
  markReadNotifications?: Resolver<Maybe<ResolversTypes['NotificationList']>, ParentType, ContextType>;
  markUnreadConversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationMarkUnreadConversationArgs, 'conversationId'>>;
  markWatchdogSeen?: Resolver<Maybe<ResolversTypes['Watchdog']>, ParentType, ContextType, RequireFields<MutationMarkWatchdogSeenArgs, 'id'>>;
  newsletterSubscribe?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationNewsletterSubscribeArgs, 'email' | 'origin' | 'recaptcha'>>;
  newsletterUnsubscribe?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationNewsletterUnsubscribeArgs, 'email' | 'token'>>;
  orderService?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationOrderServiceArgs, 'form' | 'serviceType'>>;
  projectAdvertAction?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<MutationProjectAdvertActionArgs, 'action' | 'id'>>;
  reactivateConversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationReactivateConversationArgs, 'conversationId'>>;
  reactivateProject?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<MutationReactivateProjectArgs, 'id'>>;
  registration?: Resolver<Maybe<ResolversTypes['AuthData']>, ParentType, ContextType, RequireFields<MutationRegistrationArgs, 'registrationInput'>>;
  removeCalendarEntry?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationRemoveCalendarEntryArgs, 'id'>>;
  removeCalendarEvent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationRemoveCalendarEventArgs, 'id'>>;
  removeContacts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationRemoveContactsArgs, 'recordId'>>;
  removeUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reportConversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationReportConversationArgs, 'conversationId' | 'message' | 'type'>>;
  resetPassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationResetPasswordArgs, 'login'>>;
  saveAdvert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType, RequireFields<MutationSaveAdvertArgs, 'advertSave'>>;
  saveConversationNote?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationSaveConversationNoteArgs, 'conversationId'>>;
  saveProject?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<MutationSaveProjectArgs, 'id'>>;
  saveTeleSale?: Resolver<Maybe<ResolversTypes['TeleSale']>, ParentType, ContextType, RequireFields<MutationSaveTeleSaleArgs, 'advertId' | 'status'>>;
  saveWatchdog?: Resolver<Maybe<ResolversTypes['Watchdog']>, ParentType, ContextType, RequireFields<MutationSaveWatchdogArgs, 'saveWatchdog'>>;
  sendAdvertLead?: Resolver<Maybe<ResolversTypes['AdvertLead']>, ParentType, ContextType, RequireFields<MutationSendAdvertLeadArgs, 'advertLead'>>;
  sendConversationByEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSendConversationByEmailArgs, 'conversationId' | 'email'>>;
  sendMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<MutationSendMessageArgs, 'message'>>;
  sendPhoneVerificationSms?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSendPhoneVerificationSmsArgs, 'locale' | 'phone' | 'phoneCountry' | 'phonePrefix'>>;
  sendRentPaymentReminder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSendRentPaymentReminderArgs, 'paymentId' | 'text'>>;
  sendServiceLead?: Resolver<Maybe<ResolversTypes['ServiceLead']>, ParentType, ContextType, RequireFields<MutationSendServiceLeadArgs, 'serviceLead'>>;
  setAdvertProject?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType, RequireFields<MutationSetAdvertProjectArgs, 'advertId'>>;
  setAdvertRentPlatform?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType, RequireFields<MutationSetAdvertRentPlatformArgs, 'advert' | 'platform'>>;
  setAdvertRentPlatformStatus?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType, RequireFields<MutationSetAdvertRentPlatformStatusArgs, 'advert' | 'status'>>;
  setAdvertReserved?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType, RequireFields<MutationSetAdvertReservedArgs, 'advertId' | 'reserved'>>;
  setBroker?: Resolver<Maybe<ResolversTypes['Broker']>, ParentType, ContextType, RequireFields<MutationSetBrokerArgs, 'advertId' | 'brokerId'>>;
  setFavoriteAdvert?: Resolver<Maybe<ResolversTypes['AdvertUserstate']>, ParentType, ContextType, RequireFields<MutationSetFavoriteAdvertArgs, 'advertId' | 'state'>>;
  setTopTimeDue?: Resolver<Maybe<ResolversTypes['AdvertEvent']>, ParentType, ContextType, RequireFields<MutationSetTopTimeDueArgs, 'advertEventId' | 'timeDue'>>;
  shareCalendar?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationShareCalendarArgs, 'conversation'>>;
  shareCalendarBulk?: Resolver<Maybe<ResolversTypes['ConversationList']>, ParentType, ContextType, RequireFields<MutationShareCalendarBulkArgs, never>>;
  updateAccountSettings?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateAccountSettingsArgs, 'locale' | 'newsletter' | 'user'>>;
  updateAdditionalInfo?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateAdditionalInfoArgs, 'user'>>;
  updateBasicInfo?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateBasicInfoArgs, 'user'>>;
  updateNotificationSettings?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateNotificationSettingsArgs, never>>;
  updateUserProfileSettings?: Resolver<Maybe<ResolversTypes['UserProfileSettings']>, ParentType, ContextType, RequireFields<MutationUpdateUserProfileSettingsArgs, never>>;
  uploadBrokerPhoto?: Resolver<Maybe<ResolversTypes['Broker']>, ParentType, ContextType, RequireFields<MutationUploadBrokerPhotoArgs, 'brokerId' | 'fileData'>>;
  uploadDocument?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<MutationUploadDocumentArgs, 'entityId' | 'entityType' | 'fileData' | 'fileName'>>;
  uploadImage?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType, RequireFields<MutationUploadImageArgs, 'entityId' | 'entityType' | 'file'>>;
  uploadProjectPhoto?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<MutationUploadProjectPhotoArgs, 'fileData' | 'projectId'>>;
  uploadTmpImage?: Resolver<Maybe<ResolversTypes['UploadTmpImageResponse']>, ParentType, ContextType, RequireFields<MutationUploadTmpImageArgs, 'file' | 'filter'>>;
  uploadUserPhoto?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUploadUserPhotoArgs, 'file'>>;
  verifyPhone?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationVerifyPhoneArgs, 'code' | 'locale' | 'phone' | 'phoneCountry' | 'phonePrefix'>>;
  walletWithdraw?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationWalletWithdrawArgs, 'action'>>;
};

export type NotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']> = {
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['NotificationReference']>, ParentType, ContextType>;
  service?: Resolver<Maybe<ResolversTypes['NotificationService']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['NotificationStatus']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['NotificationType']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationListResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationList'] = ResolversParentTypes['NotificationList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Notification']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationReferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationReference'] = ResolversParentTypes['NotificationReference']> = {
  __resolveType: TypeResolveFn<'Advert' | 'Conversation' | 'Page' | 'User', ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type OrderPackageResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPackage'] = ResolversParentTypes['OrderPackage']> = {
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['Locale']>, ParentType, ContextType>;
  paymentPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  referenceType?: Resolver<Maybe<ResolversTypes['OrderPackageReferenceType']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<OrderPackageTitleArgs, 'locale'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderResponse'] = ResolversParentTypes['OrderResponse']> = {
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  channel?: Resolver<Maybe<ResolversTypes['PaymentChannel']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intention?: Resolver<Maybe<ResolversTypes['PaymentIntention']>, ParentType, ContextType>;
  mallPay?: Resolver<Maybe<ResolversTypes['MallPayResponse']>, ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['PaymentMethod']>, ParentType, ContextType>;
  packages?: Resolver<Maybe<Array<Maybe<ResolversTypes['SelectedPackage']>>>, ParentType, ContextType>;
  paymentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  payu?: Resolver<Maybe<ResolversTypes['PayUResponse']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  voucherDiscount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  voucherName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Package'] = ResolversParentTypes['Package']> = {
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<PackageDescriptionArgs, 'locale'>>;
  freeTopCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  intention?: Resolver<Maybe<ResolversTypes['PaymentIntention']>, ParentType, ContextType>;
  keyFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['PackageKeyFeature']>>>, ParentType, ContextType, RequireFields<PackageKeyFeaturesArgs, 'locale'>>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  promokitAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  promokitFreeDelivery?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  referenceOptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['PackageReferenceOption']>>>, ParentType, ContextType, RequireFields<PackageReferenceOptionsArgs, 'locale'>>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<PackageTitleArgs, 'locale'>>;
  titleShort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<PackageTitleShortArgs, 'locale'>>;
  uri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackageKeyFeatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['PackageKeyFeature'] = ResolversParentTypes['PackageKeyFeature']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentExpanded?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['PackageFeatureIcon']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackageReferenceOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PackageReferenceOption'] = ResolversParentTypes['PackageReferenceOption']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Page'] = ResolversParentTypes['Page']> = {
  header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  metaDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metaKeywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  suburi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageListResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageList'] = ResolversParentTypes['PageList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Page']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayUOrderResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayUOrderResponse'] = ResolversParentTypes['PayUOrderResponse']> = {
  orderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  redirectUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PayUOrderResponseStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayUOrderResponseStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayUOrderResponseStatus'] = ResolversParentTypes['PayUOrderResponseStatus']> = {
  statusCode?: Resolver<Maybe<ResolversTypes['PayUOrderResponseStatusCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayUResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayUResponse'] = ResolversParentTypes['PayUResponse']> = {
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  client_ip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  desc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pay_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payu_order_response?: Resolver<Maybe<ResolversTypes['PayUOrderResponse']>, ParentType, ContextType>;
  pos_auth_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pos_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  session_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sig?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayUResponseStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayUResponseStatus'] = ResolversParentTypes['PayUResponseStatus']> = {
  statusCode?: Resolver<Maybe<ResolversTypes['PayUResponseStatusCode']>, ParentType, ContextType>;
  statusDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Payment'] = ResolversParentTypes['Payment']> = {
  channel?: Resolver<Maybe<ResolversTypes['PaymentChannel']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  dataLayerJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  intention?: Resolver<Maybe<ResolversTypes['PaymentIntention']>, ParentType, ContextType>;
  intentionStr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<PaymentIntentionStrArgs, 'locale'>>;
  isWalletWithdrawRequest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mainPackage?: Resolver<Maybe<ResolversTypes['SelectedPackage']>, ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['PaymentMethod']>, ParentType, ContextType>;
  pdfUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signedAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PaymentStatus']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeProcessed?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentListResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentList'] = ResolversParentTypes['PaymentList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Payment']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentSettings'] = ResolversParentTypes['PaymentSettings']> = {
  testPaymentAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayuCardTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayuCardToken'] = ResolversParentTypes['PayuCardToken']> = {
  brandImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardExpirationMonth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardExpirationYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardNumberMasked?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferred?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PayUMethodStatus']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayuPayByLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayuPayByLink'] = ResolversParentTypes['PayuPayByLink']> = {
  brandImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PayUMethodStatus']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['PaymentChannel']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['Project'] = ResolversParentTypes['Project']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  adverts?: Resolver<Maybe<ResolversTypes['AdvertList']>, ParentType, ContextType>;
  dataJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gps?: Resolver<Maybe<ResolversTypes['GPSPoint']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<ProjectPhotoArgs, 'filter'>>;
  photoFilename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stats?: Resolver<Maybe<ResolversTypes['ProjectStats']>, ParentType, ContextType>;
  timeActivated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeArchived?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeAttractiveExpiration?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeExpiration?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectStats'] = ResolversParentTypes['ProjectStats']> = {
  conversationCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cost?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statsDaily?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdvertStatsDaily']>>>, ParentType, ContextType>;
  topCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  visitCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType, RequireFields<QueryAdvertArgs, 'id'>>;
  advertEvent?: Resolver<Maybe<ResolversTypes['AdvertEvent']>, ParentType, ContextType, RequireFields<QueryAdvertEventArgs, 'id'>>;
  advertEventList?: Resolver<Maybe<ResolversTypes['AdvertEventList']>, ParentType, ContextType, RequireFields<QueryAdvertEventListArgs, never>>;
  advertFilterOptions?: Resolver<Maybe<ResolversTypes['AdvertFilterOptions']>, ParentType, ContextType>;
  advertMarkers?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdvertMarker']>>>, ParentType, ContextType, RequireFields<QueryAdvertMarkersArgs, never>>;
  advertParameters?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdvertParameter']>>>, ParentType, ContextType, RequireFields<QueryAdvertParametersArgs, 'locale' | 'type'>>;
  advertPriceRange?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdvertPriceRange']>>>, ParentType, ContextType, RequireFields<QueryAdvertPriceRangeArgs, 'locale'>>;
  advertUserstate?: Resolver<Maybe<ResolversTypes['AdvertUserstate']>, ParentType, ContextType, RequireFields<QueryAdvertUserstateArgs, 'id'>>;
  advertUserstateList?: Resolver<Maybe<ResolversTypes['AdvertUserstateList']>, ParentType, ContextType, RequireFields<QueryAdvertUserstateListArgs, 'user'>>;
  authUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  availablePaymentMethods?: Resolver<Maybe<ResolversTypes['AvailablePaymentMethods']>, ParentType, ContextType, RequireFields<QueryAvailablePaymentMethodsArgs, 'locale'>>;
  availableServices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ServiceType']>>>, ParentType, ContextType>;
  brokerList?: Resolver<Maybe<ResolversTypes['BrokerList']>, ParentType, ContextType>;
  calendarEntryList?: Resolver<Maybe<ResolversTypes['CalendarEntryList']>, ParentType, ContextType, RequireFields<QueryCalendarEntryListArgs, 'conversation'>>;
  calendarEventList?: Resolver<Maybe<ResolversTypes['CalendarEventList']>, ParentType, ContextType, RequireFields<QueryCalendarEventListArgs, 'user'>>;
  checkEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QueryCheckEmailArgs, 'email'>>;
  contractGeneratorInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<QueryConversationArgs, never>>;
  conversationList?: Resolver<Maybe<ResolversTypes['ConversationList']>, ParentType, ContextType, RequireFields<QueryConversationListArgs, 'userId'>>;
  customerAdverts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Advert']>>>, ParentType, ContextType>;
  czechRegions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Region']>>>, ParentType, ContextType, RequireFields<QueryCzechRegionsArgs, 'locale'>>;
  documentList?: Resolver<Maybe<ResolversTypes['DocumentList']>, ParentType, ContextType, RequireFields<QueryDocumentListArgs, 'entityId' | 'entityType'>>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryEmailArgs, 'ulid'>>;
  estimateAdvertPrice?: Resolver<Maybe<ResolversTypes['AdvertPriceEstimation']>, ParentType, ContextType, RequireFields<QueryEstimateAdvertPriceArgs, 'estateType' | 'offerType'>>;
  gallery?: Resolver<Maybe<ResolversTypes['Gallery']>, ParentType, ContextType, RequireFields<QueryGalleryArgs, 'id'>>;
  galleryList?: Resolver<Maybe<Array<Maybe<ResolversTypes['Gallery']>>>, ParentType, ContextType, RequireFields<QueryGalleryListArgs, 'propertyId'>>;
  getLastSearchCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<QueryGetLastSearchCountArgs, never>>;
  getUserIdByDevice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<QueryGetUserIdByDeviceArgs, 'deviceId'>>;
  layoutStats?: Resolver<Maybe<ResolversTypes['LayoutStats']>, ParentType, ContextType>;
  listAdverts?: Resolver<Maybe<ResolversTypes['AdvertList']>, ParentType, ContextType, RequireFields<QueryListAdvertsArgs, never>>;
  listHrefLangs?: Resolver<Maybe<Array<Maybe<ResolversTypes['HrefLang']>>>, ParentType, ContextType, RequireFields<QueryListHrefLangsArgs, 'estateType' | 'offerType'>>;
  listRegions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Region']>>>, ParentType, ContextType, RequireFields<QueryListRegionsArgs, 'cached' | 'locale'>>;
  listServices?: Resolver<Maybe<ResolversTypes['ServiceList']>, ParentType, ContextType, RequireFields<QueryListServicesArgs, never>>;
  message?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<QueryMessageArgs, 'id'>>;
  messageList?: Resolver<Maybe<ResolversTypes['MessageList']>, ParentType, ContextType, RequireFields<QueryMessageListArgs, 'conversation'>>;
  notification?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType, RequireFields<QueryNotificationArgs, 'id'>>;
  notificationList?: Resolver<Maybe<ResolversTypes['NotificationList']>, ParentType, ContextType, RequireFields<QueryNotificationListArgs, 'user'>>;
  package?: Resolver<Maybe<ResolversTypes['Package']>, ParentType, ContextType, RequireFields<QueryPackageArgs, 'uri'>>;
  packageList?: Resolver<Maybe<Array<Maybe<ResolversTypes['Package']>>>, ParentType, ContextType, RequireFields<QueryPackageListArgs, 'locale'>>;
  pageInfo?: Resolver<Maybe<ResolversTypes['Page']>, ParentType, ContextType, RequireFields<QueryPageInfoArgs, 'locale'>>;
  pageList?: Resolver<Maybe<ResolversTypes['PageList']>, ParentType, ContextType, RequireFields<QueryPageListArgs, 'locale'>>;
  payment?: Resolver<Maybe<ResolversTypes['Payment']>, ParentType, ContextType, RequireFields<QueryPaymentArgs, 'id'>>;
  paymentList?: Resolver<Maybe<ResolversTypes['PaymentList']>, ParentType, ContextType, RequireFields<QueryPaymentListArgs, never>>;
  paymentScheduledTotalPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<QueryPaymentScheduledTotalPriceArgs, 'user'>>;
  paymentSettings?: Resolver<Maybe<ResolversTypes['PaymentSettings']>, ParentType, ContextType>;
  payuOrderStatus?: Resolver<Maybe<ResolversTypes['PayUResponseStatus']>, ParentType, ContextType, RequireFields<QueryPayuOrderStatusArgs, 'type'>>;
  pragueCounties?: Resolver<Maybe<Array<Maybe<ResolversTypes['Region']>>>, ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<QueryProjectArgs, 'id'>>;
  projectList?: Resolver<Maybe<Array<Maybe<ResolversTypes['Project']>>>, ParentType, ContextType, RequireFields<QueryProjectListArgs, never>>;
  region?: Resolver<Maybe<ResolversTypes['Region']>, ParentType, ContextType, RequireFields<QueryRegionArgs, 'id'>>;
  rentBankAccount?: Resolver<Maybe<ResolversTypes['RentBankAccount']>, ParentType, ContextType, RequireFields<QueryRentBankAccountArgs, 'id'>>;
  rentBankAccountList?: Resolver<Maybe<ResolversTypes['RentBankAccountList']>, ParentType, ContextType>;
  rentContract?: Resolver<Maybe<ResolversTypes['RentContract']>, ParentType, ContextType, RequireFields<QueryRentContractArgs, 'id'>>;
  rentCost?: Resolver<Maybe<ResolversTypes['RentCost']>, ParentType, ContextType, RequireFields<QueryRentCostArgs, 'id'>>;
  rentEquipment?: Resolver<Maybe<ResolversTypes['RentEquipment']>, ParentType, ContextType, RequireFields<QueryRentEquipmentArgs, 'id'>>;
  rentNote?: Resolver<Maybe<ResolversTypes['RentNote']>, ParentType, ContextType, RequireFields<QueryRentNoteArgs, 'id'>>;
  rentPayment?: Resolver<Maybe<ResolversTypes['RentPayment']>, ParentType, ContextType, RequireFields<QueryRentPaymentArgs, 'id'>>;
  rentPaymentList?: Resolver<Maybe<ResolversTypes['RentPaymentList']>, ParentType, ContextType, RequireFields<QueryRentPaymentListArgs, never>>;
  rentProperty?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType, RequireFields<QueryRentPropertyArgs, 'id'>>;
  rentPropertyList?: Resolver<Maybe<ResolversTypes['RentPropertyList']>, ParentType, ContextType, RequireFields<QueryRentPropertyListArgs, never>>;
  rentRepair?: Resolver<Maybe<ResolversTypes['RentRepair']>, ParentType, ContextType, RequireFields<QueryRentRepairArgs, 'id'>>;
  rentService?: Resolver<Maybe<ResolversTypes['RentService']>, ParentType, ContextType, RequireFields<QueryRentServiceArgs, 'id'>>;
  rentStats?: Resolver<Maybe<ResolversTypes['RentStats']>, ParentType, ContextType, RequireFields<QueryRentStatsArgs, 'year'>>;
  rentTenant?: Resolver<Maybe<ResolversTypes['RentTenant']>, ParentType, ContextType, RequireFields<QueryRentTenantArgs, 'id'>>;
  rentTenantList?: Resolver<Maybe<ResolversTypes['RentTenantList']>, ParentType, ContextType, RequireFields<QueryRentTenantListArgs, never>>;
  serverTimestamp?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  service?: Resolver<Maybe<ResolversTypes['Service']>, ParentType, ContextType, RequireFields<QueryServiceArgs, 'id'>>;
  shortUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryShortUrlArgs, 'longUrl'>>;
  supportedBanks?: Resolver<Maybe<Array<Maybe<ResolversTypes['SupportedBank']>>>, ParentType, ContextType>;
  tipList?: Resolver<Maybe<ResolversTypes['TipList']>, ParentType, ContextType, RequireFields<QueryTipListArgs, 'user'>>;
  upcLink?: Resolver<Maybe<ResolversTypes['FormattedParameter']>, ParentType, ContextType, RequireFields<QueryUpcLinkArgs, 'advertId'>>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUserArgs, 'id'>>;
  voucherDiscount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<QueryVoucherDiscountArgs, 'packages' | 'voucherName'>>;
  watchdog?: Resolver<Maybe<ResolversTypes['Watchdog']>, ParentType, ContextType, RequireFields<QueryWatchdogArgs, 'id'>>;
  watchdogAppResults?: Resolver<Maybe<ResolversTypes['AdvertList']>, ParentType, ContextType, RequireFields<QueryWatchdogAppResultsArgs, 'id'>>;
  watchdogList?: Resolver<Maybe<ResolversTypes['WatchdogList']>, ParentType, ContextType, RequireFields<QueryWatchdogListArgs, never>>;
};

export type RegionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Region'] = ResolversParentTypes['Region']> = {
  boundary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  boundaryGeoJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  children?: Resolver<Maybe<Array<Maybe<ResolversTypes['Region']>>>, ParentType, ContextType>;
  googleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  idPath?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  locative?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lvl?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['Region']>, ParentType, ContextType>;
  simplifiedMapBoundary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['RegionSubtype']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['RegionType']>, ParentType, ContextType>;
  uri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelatedAdvertParametersResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelatedAdvertParameters'] = ResolversParentTypes['RelatedAdvertParameters']> = {
  advertType?: Resolver<Maybe<ResolversTypes['AdvertType']>, ParentType, ContextType>;
  disposition?: Resolver<Maybe<Array<Maybe<ResolversTypes['Disposition']>>>, ParentType, ContextType>;
  estateType?: Resolver<Maybe<ResolversTypes['EstateType']>, ParentType, ContextType>;
  offerType?: Resolver<Maybe<ResolversTypes['OfferType']>, ParentType, ContextType>;
  polygon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priceMax?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceMin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentBankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentBankAccount'] = ResolversParentTypes['RentBankAccount']> = {
  bankName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payments?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentPayment']>>>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentBankAccountListResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentBankAccountList'] = ResolversParentTypes['RentBankAccountList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentBankAccount']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentContractResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentContract'] = ResolversParentTypes['RentContract']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  cotenants?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentCotenant']>>>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  dayPaymentDue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deposit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  documents?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentContractDocument']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  priceServices?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  rentPayments?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentPayment']>>>, ParentType, ContextType>;
  tenant?: Resolver<Maybe<ResolversTypes['RentTenant']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeEnd?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeSigned?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeStart?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentContractDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentContractDocument'] = ResolversParentTypes['RentContractDocument']> = {
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['RentContract']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentCostResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentCost'] = ResolversParentTypes['RentCost']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['RentPlatformCostFrequency']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeDue?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeFirstPayment?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timePaid?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentCotenantResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentCotenant'] = ResolversParentTypes['RentCotenant']> = {
  dateBirth?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentDocument'] = ResolversParentTypes['RentDocument']> = {
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentEquipmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentEquipment'] = ResolversParentTypes['RentEquipment']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  discarded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  documents?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentEquipmentDocument']>>>, ParentType, ContextType>;
  galleries?: Resolver<Maybe<Array<Maybe<ResolversTypes['Gallery']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeDiscarded?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timePurchased?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentEquipmentDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentEquipmentDocument'] = ResolversParentTypes['RentEquipmentDocument']> = {
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['RentEquipment']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentNote'] = ResolversParentTypes['RentNote']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentPayment'] = ResolversParentTypes['RentPayment']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['RentPlatformPaymentMethod']>, ParentType, ContextType>;
  rentBankAccount?: Resolver<Maybe<ResolversTypes['RentBankAccount']>, ParentType, ContextType>;
  rentContract?: Resolver<Maybe<ResolversTypes['RentContract']>, ParentType, ContextType>;
  rentPaymentReminders?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentPaymentReminder']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeDue?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timePaid?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['RentPlatformPaymentType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentPaymentListResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentPaymentList'] = ResolversParentTypes['RentPaymentList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentPayment']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentPaymentReminderResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentPaymentReminder'] = ResolversParentTypes['RentPaymentReminder']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentPayment?: Resolver<Maybe<ResolversTypes['RentPayment']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentPropertyListResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentPropertyList'] = ResolversParentTypes['RentPropertyList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Advert']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentRepairResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentRepair'] = ResolversParentTypes['RentRepair']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  documents?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentRepairDocument']>>>, ParentType, ContextType>;
  galleries?: Resolver<Maybe<Array<Maybe<ResolversTypes['Gallery']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payer?: Resolver<Maybe<ResolversTypes['RentPlatformRepairPayer']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timePaid?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentRepairDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentRepairDocument'] = ResolversParentTypes['RentRepairDocument']> = {
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['RentRepair']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentServiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentService'] = ResolversParentTypes['RentService']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payer?: Resolver<Maybe<ResolversTypes['RentPlatformServicePayer']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeSubscribed?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['RentPlatformServiceType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentStats'] = ResolversParentTypes['RentStats']> = {
  loss?: Resolver<Maybe<ResolversTypes['RentStatsLoss']>, ParentType, ContextType>;
  profit?: Resolver<Maybe<ResolversTypes['RentStatsProfit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentStatsLossResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentStatsLoss'] = ResolversParentTypes['RentStatsLoss']> = {
  cost?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  equipment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  repair?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentStatsProfitResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentStatsProfit'] = ResolversParentTypes['RentStatsProfit']> = {
  rent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentTenantResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentTenant'] = ResolversParentTypes['RentTenant']> = {
  birthNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentRentContract?: Resolver<Maybe<ResolversTypes['RentContract']>, ParentType, ContextType>;
  dateBirth?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  documents?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentTenantDocument']>>>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentContracts?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentContract']>>>, ParentType, ContextType>;
  rentRepairs?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentRepair']>>>, ParentType, ContextType>;
  rentServices?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentService']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['RentPlatformTenantStatus']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentTenantDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentTenantDocument'] = ResolversParentTypes['RentTenantDocument']> = {
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['RentTenant']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentTenantListResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentTenantList'] = ResolversParentTypes['RentTenantList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentTenant']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedPackageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedPackage'] = ResolversParentTypes['SelectedPackage']> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  form?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  promokit?: Resolver<Maybe<ResolversTypes['SelectedPackagePromokit']>, ParentType, ContextType>;
  referenceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  referenceType?: Resolver<ResolversTypes['OrderPackageReferenceType'], ParentType, ContextType>;
  timeDue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeExpiration?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeNow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  topTimes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  uri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedPackagePromokitResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedPackagePromokit'] = ResolversParentTypes['SelectedPackagePromokit']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  delivery?: Resolver<Maybe<ResolversTypes['PromokitDeliveryType']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ServiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Service'] = ResolversParentTypes['Service']> = {
  creditcheck?: Resolver<Maybe<ResolversTypes['Creditcheck']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['Locale']>, ParentType, ContextType>;
  timeProcessed?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUserProcessed?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleShort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ServiceLeadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceLead'] = ResolversParentTypes['ServiceLead']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  service?: Resolver<Maybe<ResolversTypes['ServiceType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ServiceListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceList'] = ResolversParentTypes['ServiceList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Service']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SizeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Size'] = ResolversParentTypes['Size']> = {
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportedBankResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportedBank'] = ResolversParentTypes['SupportedBank']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeleSaleResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeleSale'] = ResolversParentTypes['TeleSale']> = {
  advert?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['TeleSaleStatus']>, ParentType, ContextType>;
  subStatus?: Resolver<Maybe<ResolversTypes['TeleSaleSubStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TipResolvers<ContextType = any, ParentType extends ResolversParentTypes['Tip'] = ResolversParentTypes['Tip']> = {
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advertId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['TipCategory']>, ParentType, ContextType>;
  desc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['NotificationStatus']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TipListResolvers<ContextType = any, ParentType extends ResolversParentTypes['TipList'] = ResolversParentTypes['TipList']> = {
  accompanying?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tip']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tip']>>>, ParentType, ContextType>;
  expiration?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tip']>>>, ParentType, ContextType>;
  image?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tip']>>>, ParentType, ContextType>;
  notActivated?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tip']>>>, ParentType, ContextType>;
  verified?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tip']>>>, ParentType, ContextType>;
  warning?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tip']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadTmpImageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadTmpImageResponse'] = ResolversParentTypes['UploadTmpImageResponse']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  accountActivationPending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  accountType?: Resolver<Maybe<ResolversTypes['AccountType']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advertToExpire?: Resolver<Maybe<ResolversTypes['Advert']>, ParentType, ContextType>;
  adverts?: Resolver<Maybe<ResolversTypes['AdvertList']>, ParentType, ContextType>;
  appSettingsMessage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  appSettingsWatchdog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  brokers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Broker']>>>, ParentType, ContextType>;
  calendarToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  calendarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canAddWatchdog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  canShowProfile?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditcheck?: Resolver<Maybe<ResolversTypes['Creditcheck']>, ParentType, ContextType>;
  education?: Resolver<Maybe<ResolversTypes['Education']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailSettingsMessage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  emailSettingsNews?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  emailSettingsWatchdog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  facebook?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  familyMembers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedParameters?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormattedParameter']>>>, ParentType, ContextType>;
  formattedParametersPublic?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormattedParameter']>>>, ParentType, ContextType>;
  google?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasAdditionalInfo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasBasicInfo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasFullAddress?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isBrokerAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isChecked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDeveloper?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLegalEntity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOwner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastAdvertVisits?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdvertUserVisit']>>>, ParentType, ContextType, RequireFields<UserLastAdvertVisitsArgs, never>>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['Locale']>, ParentType, ContextType>;
  manualInvoices?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  menuCounts?: Resolver<Maybe<ResolversTypes['MenuCounts']>, ParentType, ContextType>;
  newsletter?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notificationSettings?: Resolver<Maybe<ResolversTypes['UserNotificationSettings']>, ParentType, ContextType>;
  pets?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberInternationalFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phonePrefix?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  phoneValid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  photo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<UserPhotoArgs, 'filter'>>;
  photoFilename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photoFilenameBig?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photoFilenameSmall?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premium?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  profileScore?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserProfileScore']>>>, ParentType, ContextType>;
  profileScoreSum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profileSettings?: Resolver<Maybe<ResolversTypes['UserProfileSettings']>, ParentType, ContextType>;
  projects?: Resolver<Maybe<Array<Maybe<ResolversTypes['Project']>>>, ParentType, ContextType>;
  removed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showAd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  smoker?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeAccountExpiration?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeAccountUpgraded?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timePasswordUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  tipInfo?: Resolver<Maybe<ResolversTypes['UserTipInfo']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UserGroupType']>, ParentType, ContextType>;
  unreadMessagesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unreadWatchdogAdvertsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userGroup?: Resolver<Maybe<ResolversTypes['UserGroup']>, ParentType, ContextType>;
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  walletBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  walletCurrency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  watchdogCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watchdogFrequency?: Resolver<Maybe<ResolversTypes['WatchdogFrequency']>, ParentType, ContextType>;
  workplace?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yearBorn?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAresInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAresInfo'] = ResolversParentTypes['UserAresInfo']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserGroup'] = ResolversParentTypes['UserGroup']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPSN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameShow?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeLastUpdate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UserGroupKeyType']>, ParentType, ContextType>;
  uri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNotificationSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNotificationSettings'] = ResolversParentTypes['UserNotificationSettings']> = {
  emailMessage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  emailWatchdog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pushMessage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pushWatchdog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserProfileScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserProfileScore'] = ResolversParentTypes['UserProfileScore']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  percent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ProfileScoreType']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserProfileSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserProfileSettings'] = ResolversParentTypes['UserProfileSettings']> = {
  rentPlatformDashboardOrder?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  rentPlatformReminderText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTipInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTipInfo'] = ResolversParentTypes['UserTipInfo']> = {
  hasActiveAdvertComfort?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasActiveAdvertComfortWithReactions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasActiveAdvertRent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasActiveAdvertSale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasAdvert?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasAdvertService?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasAnyAdvertComfort?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasPragueRentAdvert?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasPragueSaleAdvert?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasRentPlatformAdvert?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasReservedAdvert?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mortgageRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  respondedToRent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  respondedToSale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shouldBuyRentContract?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shouldBuySaleContract?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shouldShowTvujSpravce?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shouldShowTvujSpravce21days?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shouldShowTvujSpravceInactive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shouldShowTvujSpravceWithReactions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WatchdogResolvers<ContextType = any, ParentType extends ResolversParentTypes['Watchdog'] = ResolversParentTypes['Watchdog']> = {
  adverts?: Resolver<Maybe<ResolversTypes['AdvertList']>, ParentType, ContextType, RequireFields<WatchdogAdvertsArgs, never>>;
  criteria?: Resolver<Maybe<ResolversTypes['WatchdogCriteria']>, ParentType, ContextType>;
  emailFrequency?: Resolver<Maybe<ResolversTypes['WatchdogFrequency']>, ParentType, ContextType>;
  geometryGeoJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queryString?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<WatchdogQueryStringArgs, 'locale'>>;
  timeChecked?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timeUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  unreadCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WatchdogCriteriaResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchdogCriteria'] = ResolversParentTypes['WatchdogCriteria']> = {
  __resolveType: TypeResolveFn<'WatchdogCriteriaOffer', ParentType, ContextType>;
  advertType?: Resolver<Maybe<ResolversTypes['AdvertType']>, ParentType, ContextType>;
  balcony?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cellar?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  construction?: Resolver<Maybe<Array<Maybe<ResolversTypes['Construction']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disposition?: Resolver<Maybe<Array<Maybe<ResolversTypes['Disposition']>>>, ParentType, ContextType>;
  equipped?: Resolver<Maybe<Array<Maybe<ResolversTypes['Equipped']>>>, ParentType, ContextType>;
  estateType?: Resolver<Maybe<Array<Maybe<ResolversTypes['EstateType']>>>, ParentType, ContextType>;
  garage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  includeImports?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSelectedOnMap?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  loggia?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  newBuilding?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  offerType?: Resolver<Maybe<ResolversTypes['OfferType']>, ParentType, ContextType>;
  ownership?: Resolver<Maybe<Array<Maybe<ResolversTypes['Ownership']>>>, ParentType, ContextType>;
  parking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  polygon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  polygonFormatted?: Resolver<Maybe<ResolversTypes['GPSPolygon']>, ParentType, ContextType>;
  polygons?: Resolver<Maybe<ResolversTypes['GPSMultipolygon']>, ParentType, ContextType>;
  priceMax?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceMin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['Region']>, ParentType, ContextType>;
  roommate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  selectedAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  square?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  surfaceMax?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  surfaceMin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  terrace?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type WatchdogCriteriaOfferResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchdogCriteriaOffer'] = ResolversParentTypes['WatchdogCriteriaOffer']> = {
  advertType?: Resolver<Maybe<ResolversTypes['AdvertType']>, ParentType, ContextType>;
  balcony?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cellar?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  construction?: Resolver<Maybe<Array<Maybe<ResolversTypes['Construction']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disposition?: Resolver<Maybe<Array<Maybe<ResolversTypes['Disposition']>>>, ParentType, ContextType>;
  equipped?: Resolver<Maybe<Array<Maybe<ResolversTypes['Equipped']>>>, ParentType, ContextType>;
  estateType?: Resolver<Maybe<Array<Maybe<ResolversTypes['EstateType']>>>, ParentType, ContextType>;
  garage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  includeImports?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSelectedOnMap?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  loggia?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  newBuilding?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  offerType?: Resolver<Maybe<ResolversTypes['OfferType']>, ParentType, ContextType>;
  ownership?: Resolver<Maybe<Array<Maybe<ResolversTypes['Ownership']>>>, ParentType, ContextType>;
  parking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  polygon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  polygonFormatted?: Resolver<Maybe<ResolversTypes['GPSPolygon']>, ParentType, ContextType>;
  polygons?: Resolver<Maybe<ResolversTypes['GPSMultipolygon']>, ParentType, ContextType>;
  priceMax?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceMin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['Region']>, ParentType, ContextType>;
  roommate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  selectedAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  square?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  surfaceMax?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  surfaceMin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  terrace?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WatchdogListResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchdogList'] = ResolversParentTypes['WatchdogList']> = {
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Watchdog']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Advert?: AdvertResolvers<ContextType>;
  AdvertBadge?: AdvertBadgeResolvers<ContextType>;
  AdvertEvent?: AdvertEventResolvers<ContextType>;
  AdvertEventList?: AdvertEventListResolvers<ContextType>;
  AdvertFilterOptions?: AdvertFilterOptionsResolvers<ContextType>;
  AdvertLead?: AdvertLeadResolvers<ContextType>;
  AdvertList?: AdvertListResolvers<ContextType>;
  AdvertMarker?: AdvertMarkerResolvers<ContextType>;
  AdvertMessageData?: AdvertMessageDataResolvers<ContextType>;
  AdvertParameter?: AdvertParameterResolvers<ContextType>;
  AdvertPriceEstimation?: AdvertPriceEstimationResolvers<ContextType>;
  AdvertPriceRange?: AdvertPriceRangeResolvers<ContextType>;
  AdvertStatsDaily?: AdvertStatsDailyResolvers<ContextType>;
  AdvertUserVisit?: AdvertUserVisitResolvers<ContextType>;
  AdvertUserstate?: AdvertUserstateResolvers<ContextType>;
  AdvertUserstateList?: AdvertUserstateListResolvers<ContextType>;
  AdvertVideo?: AdvertVideoResolvers<ContextType>;
  ApplePaySession?: ApplePaySessionResolvers<ContextType>;
  AuthData?: AuthDataResolvers<ContextType>;
  AvailablePaymentMethods?: AvailablePaymentMethodsResolvers<ContextType>;
  BreadcrumbItem?: BreadcrumbItemResolvers<ContextType>;
  Broker?: BrokerResolvers<ContextType>;
  BrokerList?: BrokerListResolvers<ContextType>;
  CalendarEntry?: CalendarEntryResolvers<ContextType>;
  CalendarEntryList?: CalendarEntryListResolvers<ContextType>;
  CalendarEvent?: CalendarEventResolvers<ContextType>;
  CalendarEventList?: CalendarEventListResolvers<ContextType>;
  Conversation?: ConversationResolvers<ContextType>;
  ConversationList?: ConversationListResolvers<ContextType>;
  Creditcheck?: CreditcheckResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  Document?: DocumentResolvers<ContextType>;
  DocumentList?: DocumentListResolvers<ContextType>;
  DocumentReference?: DocumentReferenceResolvers<ContextType>;
  FormError?: FormErrorResolvers<ContextType>;
  FormattedBoolParameter?: FormattedBoolParameterResolvers<ContextType>;
  FormattedParameter?: FormattedParameterResolvers<ContextType>;
  GPSMultipolygon?: GraphQLScalarType;
  GPSPoint?: GpsPointResolvers<ContextType>;
  GPSPolygon?: GpsPolygonResolvers<ContextType>;
  Gallery?: GalleryResolvers<ContextType>;
  GalleryReference?: GalleryReferenceResolvers<ContextType>;
  HrefLang?: HrefLangResolvers<ContextType>;
  Image?: ImageResolvers<ContextType>;
  ImageUpload?: GraphQLScalarType;
  LayoutStats?: LayoutStatsResolvers<ContextType>;
  MallPayResponse?: MallPayResponseResolvers<ContextType>;
  MenuCounts?: MenuCountsResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  MessageList?: MessageListResolvers<ContextType>;
  MortgageData?: MortgageDataResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Notification?: NotificationResolvers<ContextType>;
  NotificationList?: NotificationListResolvers<ContextType>;
  NotificationReference?: NotificationReferenceResolvers<ContextType>;
  OrderPackage?: OrderPackageResolvers<ContextType>;
  OrderResponse?: OrderResponseResolvers<ContextType>;
  Package?: PackageResolvers<ContextType>;
  PackageKeyFeature?: PackageKeyFeatureResolvers<ContextType>;
  PackageReferenceOption?: PackageReferenceOptionResolvers<ContextType>;
  Page?: PageResolvers<ContextType>;
  PageList?: PageListResolvers<ContextType>;
  PayUOrderResponse?: PayUOrderResponseResolvers<ContextType>;
  PayUOrderResponseStatus?: PayUOrderResponseStatusResolvers<ContextType>;
  PayUResponse?: PayUResponseResolvers<ContextType>;
  PayUResponseStatus?: PayUResponseStatusResolvers<ContextType>;
  Payment?: PaymentResolvers<ContextType>;
  PaymentList?: PaymentListResolvers<ContextType>;
  PaymentSettings?: PaymentSettingsResolvers<ContextType>;
  PayuCardToken?: PayuCardTokenResolvers<ContextType>;
  PayuPayByLink?: PayuPayByLinkResolvers<ContextType>;
  Project?: ProjectResolvers<ContextType>;
  ProjectStats?: ProjectStatsResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Region?: RegionResolvers<ContextType>;
  RelatedAdvertParameters?: RelatedAdvertParametersResolvers<ContextType>;
  RentBankAccount?: RentBankAccountResolvers<ContextType>;
  RentBankAccountList?: RentBankAccountListResolvers<ContextType>;
  RentContract?: RentContractResolvers<ContextType>;
  RentContractDocument?: RentContractDocumentResolvers<ContextType>;
  RentCost?: RentCostResolvers<ContextType>;
  RentCotenant?: RentCotenantResolvers<ContextType>;
  RentDocument?: RentDocumentResolvers<ContextType>;
  RentEquipment?: RentEquipmentResolvers<ContextType>;
  RentEquipmentDocument?: RentEquipmentDocumentResolvers<ContextType>;
  RentNote?: RentNoteResolvers<ContextType>;
  RentPayment?: RentPaymentResolvers<ContextType>;
  RentPaymentList?: RentPaymentListResolvers<ContextType>;
  RentPaymentReminder?: RentPaymentReminderResolvers<ContextType>;
  RentPropertyList?: RentPropertyListResolvers<ContextType>;
  RentRepair?: RentRepairResolvers<ContextType>;
  RentRepairDocument?: RentRepairDocumentResolvers<ContextType>;
  RentService?: RentServiceResolvers<ContextType>;
  RentStats?: RentStatsResolvers<ContextType>;
  RentStatsLoss?: RentStatsLossResolvers<ContextType>;
  RentStatsProfit?: RentStatsProfitResolvers<ContextType>;
  RentTenant?: RentTenantResolvers<ContextType>;
  RentTenantDocument?: RentTenantDocumentResolvers<ContextType>;
  RentTenantList?: RentTenantListResolvers<ContextType>;
  SelectedPackage?: SelectedPackageResolvers<ContextType>;
  SelectedPackagePromokit?: SelectedPackagePromokitResolvers<ContextType>;
  Service?: ServiceResolvers<ContextType>;
  ServiceLead?: ServiceLeadResolvers<ContextType>;
  ServiceList?: ServiceListResolvers<ContextType>;
  Size?: SizeResolvers<ContextType>;
  SupportedBank?: SupportedBankResolvers<ContextType>;
  TeleSale?: TeleSaleResolvers<ContextType>;
  Tip?: TipResolvers<ContextType>;
  TipList?: TipListResolvers<ContextType>;
  UploadTmpImageResponse?: UploadTmpImageResponseResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserAresInfo?: UserAresInfoResolvers<ContextType>;
  UserGroup?: UserGroupResolvers<ContextType>;
  UserNotificationSettings?: UserNotificationSettingsResolvers<ContextType>;
  UserProfileScore?: UserProfileScoreResolvers<ContextType>;
  UserProfileSettings?: UserProfileSettingsResolvers<ContextType>;
  UserTipInfo?: UserTipInfoResolvers<ContextType>;
  Watchdog?: WatchdogResolvers<ContextType>;
  WatchdogCriteria?: WatchdogCriteriaResolvers<ContextType>;
  WatchdogCriteriaOffer?: WatchdogCriteriaOfferResolvers<ContextType>;
  WatchdogList?: WatchdogListResolvers<ContextType>;
};


/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
 */
export type IResolvers<ContextType = any> = Resolvers<ContextType>;
